var Ut = Object.defineProperty;
var qt = (t, n, e) => n in t ? Ut(t, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[n] = e;
var K = (t, n, e) => (qt(t, typeof n != "symbol" ? n + "" : n, e), e);
import { reactive as Ee, nextTick as fe, watch as se, ref as E, onUnmounted as Jt, unref as l, inject as ae, getCurrentInstance as mt, computed as je, onMounted as we, defineComponent as ce, onBeforeUnmount as Re, openBlock as x, createElementBlock as V, normalizeClass as re, Fragment as xe, renderList as Oe, normalizeStyle as Ge, createCommentVNode as Z, createElementVNode as q, renderSlot as U, resolveComponent as Ve, createBlock as te, withCtx as ee, normalizeProps as pe, guardReactiveProps as Se, h as le, provide as ge, toRefs as be, createVNode as ie, toDisplayString as Ce, withModifiers as Yt, useSlots as It, Teleport as yt, withDirectives as Me, vShow as De, mergeProps as nt, Transition as Ot, createSlots as Xt, render as kt, createTextVNode as tt } from "vue";
class Kt {
  constructor() {
    K(this, "lateNotifyCallbacks", /* @__PURE__ */ new Map());
    K(this, "lateNotifyItems", []);
  }
  listenLateAction(n, e) {
    this.lateNotifyCallbacks.set(n, e), this.applyLateActions(n);
  }
  unlistenLateAction(n) {
    this.lateNotifyCallbacks.delete(n);
  }
  unlistenAllLateAction() {
    this.lateNotifyCallbacks.clear();
  }
  applyLateActions(n) {
    const e = this.lateNotifyCallbacks.get(n);
    if (e)
      for (let o = this.lateNotifyItems.length - 1; o >= 0; o--) {
        const i = this.lateNotifyItems[o];
        if (i.name === n) {
          try {
            i.resolve(e(...i.args));
          } catch (a) {
            i.reject(a);
          }
          this.lateNotifyItems.splice(o, 1);
        }
      }
  }
  pushLateAction(n, ...e) {
    const o = this.lateNotifyCallbacks.get(n);
    if (o)
      try {
        return Promise.resolve(o(...e));
      } catch (i) {
        return Promise.reject(i);
      }
    else
      return new Promise((i, a) => {
        const s = { name: n, args: e, resolve: i, reject: a };
        this.lateNotifyItems.push(s);
      });
  }
}
const Zt = {
  primarySideBarSwitchWithActivityBar: !0,
  primarySideBarPosition: "left",
  primarySideBarWidth: 20,
  primarySideBarMinWidth: 170,
  activityBarPosition: "side",
  secondarySideBarWidth: 20,
  secondarySideBarMinWidth: 170,
  secondarySideBarAsActivityBar: !1,
  secondaryActivityBarPosition: "side",
  bottomPanelHeight: 30,
  bottomPanelMinHeight: 40,
  bottomPanelMaximize: !1,
  bottomAlignment: "center",
  panelHeaderHeight: 24,
  panelMinHeight: 150,
  titleBar: !0,
  titleBarShowCustomizeLayout: !0,
  activityBar: !0,
  primarySideBar: !0,
  secondarySideBar: !1,
  bottomPanel: !0,
  statusBar: !0,
  menuBar: !0
};
class ze extends Kt {
  constructor(e) {
    super();
    K(this, "context");
    /**
     * Title of this panel.
     * 
     * * Display in header.
     */
    K(this, "title", "");
    /**
     * Name of this panel.
     * 
     * Don't change this value after panel added to layout.
     * 
     * You can obtain an instance of a panel using this name in the `CodeLayout.getPanelByName` instance method. 
     * 
     * * This name needs to be unique in a CodeLayout/SplitLayout.
     */
    K(this, "name", "");
    /**
     * Open state of this panel.
     * 
     * * Only used in CodeLayout. 
     * In SplitLayout, all panels are always in open state.
     */
    K(this, "open", !1);
    /**
     * Set user can resize this panel.
     * 
     * * Only used in CodeLayout.
     */
    K(this, "resizeable", !0);
    /**
     * Show panel?
     * 
     * * Only used in CodeLayout.
     * 
     * After changed, need call `relayoutAfterToggleVisible` to apply.
     */
    K(this, "visible", !0);
    K(this, "showBadge", !0);
    /**
     * Size of this panel.
     * 
     * * In CodeLayout, it's pixel size.
     * * In SplitLayout, it's percentage size.
     */
    K(this, "size", 0);
    /**
     * Child panel of this grid.
     */
    K(this, "children", []);
    /**
     * Active child of this grid.
     * 
     * * Use in Tab
     */
    K(this, "activePanel", null);
    /**
     * Parent grid instance of this panel.
     */
    K(this, "parentGroup", null);
    /**
     * Parent toplevel grid name of this panel.
     */
    K(this, "parentGrid", "none");
    K(this, "tooltip");
    K(this, "badge");
    K(this, "accept");
    K(this, "draggable", !0);
    K(this, "preDropCheck");
    K(this, "tabStyle");
    K(this, "noAutoShink", !1);
    K(this, "noHide", !1);
    K(this, "minSize");
    K(this, "startOpen");
    K(this, "iconLarge");
    K(this, "iconSmall");
    K(this, "closeType", "close");
    K(this, "actions");
    K(this, "data");
    K(this, "lastRelayoutSize", 0);
    K(this, "lastLayoutSizeCounter", 0);
    this.context = e;
  }
  //Public
  /**
   * Add child panel to this grid.
   * @param panel Child panel
   * @param startOpen Is the sub panel in an open state
   * @returns Child panel instance
   */
  addPanel(e, o = !1, i) {
    const a = e;
    if (a.parentGroup)
      throw new Error(`Panel ${e.name} already added to ${a.parentGroup.name} !`);
    if (this.context.panelInstances.has(a.name))
      throw new Error(`A panel named ${e.name} already exists`);
    const s = Ee(new ze(this.context));
    return Object.assign(s, e), s.children = [], s.open = e.startOpen ?? !1, s.size = e.size ?? 0, s.accept = e.accept ?? this.accept, s.parentGrid = this.parentGrid, this.addChild(s, i), (o || e.startOpen) && s.openPanel(), this.context.panelInstances.set(a.name, s), s;
  }
  /**
   * Remove panel from this group.
   * @param panel Panel instance.
   * @param shrink Automatically shrink? Default true
   */
  removePanel(e, o = !0) {
    if (e.parentGroup !== this)
      throw new Error(`Panel ${e.name} is not child of this group !`);
    return o ? this.context.removePanelInternal(e) : this.removeChild(e), this.context.panelInstances.delete(e.name), e;
  }
  /**
   * Open this panel.
   * @param closeOthers When opening oneself, do you also close other panels at the same level, Default: false
   */
  openPanel(e = !1) {
    if (this.parentGroup) {
      const o = this.parentGroup;
      o.activePanel = this, e && o.children.forEach((i) => i.open = !1), this.open = !0;
    } else
      throw new Error(`Panel ${this.name} has not in any container, can not active it.`);
  }
  /**
   * Close this panel.
   */
  closePanel() {
    if (this.parentGroup) {
      const e = this.parentGroup;
      this.parentGroup.reselectActiveChild(), e.open = !1;
    } else
      throw new Error(`Panel ${this.name} has not in any container, can not active it.`);
  }
  /**
   * Toggle open state of this panel.
   * @returns Return new open state
   */
  togglePanel() {
    if (this.parentGroup) {
      const e = this.parentGroup;
      return this.parentGroup.activePanel = this, e.open = !e.open, e.open;
    } else
      throw new Error(`Panel ${this.name} has not in any container, can not active it.`);
  }
  /**
   * Remove the current panel/grid from its parent.
   * @returns 
   */
  removeSelf() {
    var e;
    return (e = this.parentGroup) == null ? void 0 : e.removePanel(this, !1);
  }
  /**
   * Remove the current panel/grid from its parent and 
   * trigger automatic shrink operations.
   * @returns 
   */
  removeSelfWithShrink() {
    var e;
    return (e = this.parentGroup) == null ? void 0 : e.removePanel(this, !0);
  }
  /**
   * Set activePanel.
   * @param child The panel to be activated
   */
  setActiveChild(e) {
    this.activePanel = e;
  }
  /**
   * Auto select a visible panel as activePanel.
   */
  reselectActiveChild() {
    this.activePanel = this.children.find((e) => e.visible) || null;
  }
  /**
   * Set parent activePanel to self.
   */
  activeSelf() {
    this.parentGroup && (this.parentGroup.setActiveChild(this), this.parentGroup.activeSelf());
  }
  /**
   * Get is this panel actived in parent (Tab)
   */
  isSelfActived() {
    return this.parentGroup ? this.parentGroup.activePanel == this : !1;
  }
  /**
   * Check panel is children.
   */
  isChildren(e) {
    return this.children.includes(e);
  }
  /**
   * Get grid hoster container size (pixel).
   * @returns 
   */
  getContainerSize() {
    return this.lastRelayoutSize;
  }
  /**
   * Notify hoster container force relayout.
   */
  notifyRelayout() {
    this.pushLateAction("notifyRelayout");
  }
  /**
   * Notify hoster container there has new grids was added and needs to relayout.
   * 
   * * This method is called internally, and generally you do not need to use this method.
   * @param panels New panels
   * @param referencePanel Drop grid.
   */
  relayoutAllWithNewPanel(e, o) {
    this.pushLateAction("relayoutAllWithNewPanel", e, o);
  }
  /**
   * Notify hoster container there has grids was visible changed and needs to relayout.
   * @param panel Changed panel.
   */
  relayoutAfterToggleVisible(e) {
    e || (e = this);
    const o = e.getParent();
    o && (e.visible ? (o instanceof ze && o.relayoutAllWithNewPanel([e]), o.setActiveChild(e)) : (o instanceof ze && o.relayoutAllWithRemovePanel(e), o.reselectActiveChild()));
  }
  /**
   * Notify hoster container there has grids was removed and needs to relayout.
   * 
   * * This method is called internally, and generally you do not need to use this method.
   * @param panel Removed panel.
   */
  relayoutAllWithRemovePanel(e) {
    this.pushLateAction("relayoutAllWithRemovePanel", e);
  }
  /**
   * Notify hoster container to relayout when container size changed.
   * 
   * * This method is called internally, and generally you do not need to use this method.
   * @param resizedContainerSize 
   */
  relayoutAllWithResizedSize(e) {
    this.pushLateAction("relayoutAllWithResizedSize", e);
  }
  //Internal
  //These methods is called internally, and you do not need to use them.
  addChild(e, o) {
    if (!(e instanceof ze))
      throw new Error("Try add bad panel data");
    if (this.name === e.name)
      throw new Error("Try add self");
    typeof o == "number" ? this.children.splice(o, 0, e) : this.children.push(e), e.parentGroup = this, e.parentGrid = this.parentGrid, this.activePanel || (this.activePanel = e);
  }
  addChilds(e, o) {
    for (const i of e)
      if (!(i instanceof ze))
        throw new Error("Try add bad panel data");
    typeof o == "number" ? this.children.splice(o, 0, ...e) : this.children.push(...e);
    for (const i of e) {
      if (this.name === i.name)
        throw new Error("Try add self");
      i.parentGroup = this, i.parentGrid = this.parentGrid;
    }
    this.activePanel || (this.activePanel = this.children[0]);
  }
  removeChild(e) {
    var o;
    this.children.splice(this.children.indexOf(e), 1), e.parentGroup = null, e.name === ((o = this.activePanel) == null ? void 0 : o.name) && this.reselectActiveChild();
  }
  replaceChild(e, o) {
    var i;
    this.children.splice(
      this.children.indexOf(e),
      1,
      o
    ), e.parentGroup = null, ((i = this.activePanel) == null ? void 0 : i.name) === e.name && (this.activePanel = o), o.parentGroup = this, o.parentGrid = this.parentGrid;
  }
  hasChild(e) {
    return this.children.includes(e);
  }
  getIsTabContainer() {
    return this.tabStyle === "text" || this.tabStyle === "icon";
  }
  getIsTopGroup() {
    return !this.parentGroup;
  }
  getIsInTab() {
    var e;
    return ((e = this.parentGroup) == null ? void 0 : e.getIsTabContainer()) ?? !1;
  }
  getParent() {
    return this.parentGroup;
  }
  getIndexInParent() {
    var e;
    return this.parentGroup ? this.parentGroup.children.indexOf(this) ?? 0 : ((e = this.getParent()) == null ? void 0 : e.children.indexOf(this)) ?? 0;
  }
  getLastChildOrSelf() {
    return this.children.length > 0 ? this.children[this.children.length - 1] : this;
  }
  getFlatternChildOrSelf() {
    return this.children.length > 0 ? this.children : [this];
  }
  toJson() {
    return {
      name: this.name,
      open: this.open,
      resizeable: this.resizeable,
      visible: this.visible,
      showBadge: this.showBadge,
      size: this.size,
      children: this.children.map((e) => e.toJson())
    };
  }
  loadFromJson(e) {
    this.name = e.name, this.open = e.open, this.resizeable = e.resizeable, this.visible = e.visible, this.showBadge = e.showBadge, this.size = e.size;
  }
}
class Je extends ze {
  constructor(e, o, i, a, s) {
    super(i);
    K(this, "onSwitchCollapse");
    K(this, "onActiveSelf");
    this.name = e, this.tabStyle = o, this.parentGrid = e, this.onActiveSelf = s, this.onSwitchCollapse = a;
  }
  activeSelf() {
    var e;
    this.open || this.collapse(!0), (e = this.onActiveSelf) == null || e.call(this);
  }
  /**
   * Open or collapse the current top-level grid.
   * @param open Is open?
   */
  collapse(e) {
    var o;
    (o = this.onSwitchCollapse) == null || o.call(this, e);
  }
}
class ye extends ze {
  constructor(e = null) {
    super(e == null ? void 0 : e.context);
    K(this, "name", "");
    K(this, "title", "");
    K(this, "tooltip");
    K(this, "badge");
    K(this, "_iconSmall");
    K(this, "_iconLarge");
    K(this, "_iconSmallName");
    K(this, "_iconLargeName");
    K(this, "actions");
    K(this, "data", {});
    // For storing panel state
    K(this, "parentGroup", null);
    K(this, "onActive");
    K(this, "onClose");
    this.parentGroup = e, this.open = !0;
  }
  get iconSmall() {
    return this._iconSmall;
  }
  set iconSmall(e) {
    typeof e == "string" ? (this._iconSmallName = e, this._iconSmall = void 0) : this._iconSmall = e;
  }
  get iconLarge() {
    return this._iconLarge;
  }
  set iconLarge(e) {
    typeof e == "string" ? (this._iconLargeName = e, this._iconLarge = void 0) : this._iconLarge = e;
  }
  get iconSmallName() {
    return this._iconSmallName;
  }
  set iconSmallName(e) {
    this._iconSmallName = e;
  }
  get iconLargeName() {
    return this._iconLargeName;
  }
  set iconLargeName(e) {
    this._iconLargeName = e;
  }
  /**
   * Panel in SplitLayout always open, no need to call the open method.
   */
  openPanel() {
    throw new Error("SplitLayout panel can only close");
  }
  /**
   * Close this panel.
   * 
   * This method will trigger panelClose event in SplitLayout.
   */
  closePanel() {
    this.context.closePanelInternal(this);
  }
  /**
   * Copy this panel and split it
   * @param direction Split direction
   * @param instanceCb New panel instance callback, can modify params
  */
  splitCopy(e, o) {
    var S;
    const i = this, a = this.parentGroup, s = (S = this.parentGroup) == null ? void 0 : S.parentGroup;
    if (!s)
      throw new Error("No top grid!");
    function c(m = !1) {
      const b = new he(a.context);
      return Object.assign(b, {
        ...a,
        direction: a.direction,
        name: a.name + Math.floor(Math.random() * 10),
        children: [],
        childGrid: [],
        size: 0,
        noAutoShink: !1
      }), s.addChildGrid(
        b,
        s.childGrid.indexOf(a) + (m ? -1 : 0)
      ), b;
    }
    function g(m = !1) {
      const b = new he(a.context);
      Object.assign(b, {
        ...a,
        direction: a.direction == "horizontal" ? "vertical" : "horizontal",
        name: a.name + Math.floor(Math.random() * 10),
        children: [],
        childGrid: [],
        size: 0,
        noAutoShink: !1
      }), b.addChilds(a.children), b.setActiveChild(i), a.children = [], a.childGrid = [], a.addChildGrid(b);
      const k = new he(a.context);
      return Object.assign(k, {
        ...a,
        direction: a.direction == "horizontal" ? "vertical" : "horizontal",
        name: a.name + Math.floor(Math.random() * 10),
        children: [],
        childGrid: [],
        size: 0,
        noAutoShink: !1
      }), a.addChildGrid(k, m ? 0 : 1), k;
    }
    let u;
    switch (e) {
      case "left": {
        u = a.direction == "horizontal" ? g(!0) : c(!0);
        break;
      }
      case "right": {
        u = a.direction == "horizontal" ? g() : c();
        break;
      }
      case "top": {
        u = a.direction == "vertical" ? g(!0) : c(!0);
        break;
      }
      case "bottom": {
        u = a.direction == "vertical" ? g() : c();
        break;
      }
      default:
        throw new Error("Unknow direction: " + e);
    }
    const r = {
      title: this.title,
      tooltip: this.tooltip,
      name: this.name,
      badge: this.badge,
      draggable: this.draggable,
      accept: this.accept,
      size: this.size,
      minSize: this.minSize,
      iconSmall: this._iconSmall,
      iconLarge: this._iconLarge,
      iconSmallName: this._iconSmallName,
      iconLargeName: this._iconLargeName,
      closeType: this.closeType
    }, h = u.addPanel(o(r));
    u.setActiveChild(h), fe(() => {
      s.notifyRelayout(), a.notifyRelayout(), u.notifyRelayout();
    });
  }
  /**
   * Update this panel's data by merging new data with existing data.
   * This will:
   * 1. Merge the new data with existing data
   * 2. Mark the panel as unsaved
   * 3. Trigger a relayout
   * @param data The new data to merge with existing data
   */
  updateData(e) {
    this.data = Ee({
      ...this.data,
      ...e
    }), this.markAsUnsaved(), this.notifyRelayout(), this.parentGroup && this.parentGroup.notifyRelayout();
  }
  // Helper method to get data with type safety
  getData(e, o) {
    return this.data[e] ?? o;
  }
  markAsSaved() {
    this.closeType === "unSave" && (this.closeType = "close");
    for (const e of this.children || [])
      e.markAsSaved && e.markAsSaved();
  }
  markAsUnsaved() {
    this.closeType = "unSave";
  }
  // Apply initial configuration if available
  applyInitialConfig(e) {
    if (!e)
      return;
    const o = this.name;
    e.titleGenerator && !this.title && (this.title = e.titleGenerator(o)), e.tooltipGenerator && !this.tooltip && (this.tooltip = e.tooltipGenerator(o)), e.badgeGenerator && !this.badge && (this.badge = e.badgeGenerator(o)), e.iconGenerator && (!this._iconSmall && !this._iconSmallName && (this.iconSmall = o), !this._iconLarge && !this._iconLargeName && (this.iconLarge = o)), e.dataGenerator && (this.data = {
      ...e.dataGenerator(o),
      ...this.data
      // Preserve any existing data
    }), e.closeType && !this.closeType && (this.closeType = e.closeType);
  }
  // Generate a unique panel name
  static generateUniqueName(e = "panel") {
    return `${e}-${crypto.randomUUID().split("-")[0]}`;
  }
  init(e = !0) {
    e && se(() => this.data, () => {
      this.markAsUnsaved();
    }, { deep: !0 });
  }
  toJson() {
    return this.markAsSaved(), {
      name: this.name,
      open: this.open,
      size: this.size,
      visible: this.visible,
      direction: this.direction,
      children: this.children.map((e) => {
        var i;
        const o = e;
        return {
          name: o.name,
          title: o.title,
          tooltip: o.tooltip,
          badge: o.badge,
          data: o.data,
          closeType: o.closeType || "close",
          // Store icon names for serialization
          iconSmallName: o._iconSmallName,
          iconLargeName: o._iconLargeName,
          hasIconSmall: !!o._iconSmallName,
          hasIconLarge: !!o._iconLargeName,
          hasActions: !!((i = o.actions) != null && i.length)
        };
      }),
      childGrid: this.childGrid.map((e) => e.toJson())
    };
  }
  loadFromJson(e) {
    super.loadFromJson(e), this._iconSmallName = e.iconSmallName, this._iconLargeName = e.iconLargeName;
  }
}
class he extends Je {
  constructor(e) {
    super("centerArea", "text", e, () => {
    }, () => {
    });
    /**
     * Set whether users can close the current panel by continuously shrinking it.
     */
    K(this, "canMinClose", !1);
    /**
     * Layout direction. 
     */
    K(this, "direction", "vertical");
    /**
     * Child grid of this grid.
     */
    K(this, "childGrid", []);
    K(this, "onActive");
    K(this, "onActivePanelChanged");
    K(this, "onMinCloseChanged");
    //Internal
    //These methods is called internally, and you do not need to use them.
    K(this, "childReplacedBy", null);
    this.open = !0, this.title = "";
  }
  //Public
  /**
   * Add a child grid to this grid.
   * @param grid Grid to add
   * @param direction Direction, default is the direction perpendicular to the current grid
   * @returns Child grid instance.
   */
  addGrid(e, o = void 0) {
    const i = e;
    if (i.parentGroup)
      throw new Error(`Panel ${e.name} already added to ${i.parentGroup.name} !`);
    const a = Ee(new he(this.context));
    return Object.assign(a, e), a.children = [], a.childGrid = [], a.open = !0, a.size = e.size ?? 0, a.accept = e.accept ?? this.accept, a.parentGrid = this.parentGrid, a.direction = o ?? (this.direction === "vertical" ? "horizontal" : "vertical"), this.addChildGrid(a), a;
  }
  /**
   * Remove a child grid from this grid.
   * @param grid Grid to remove
   */
  removeGrid(e) {
    const o = e;
    if (o.parentGroup !== this)
      throw new Error(`Panel ${e.name} is not child of this group !`);
    return this.removeChildGrid(o), e;
  }
  addPanel(e, o, i) {
    var g, u;
    const a = e;
    if (a.parentGroup)
      throw new Error(`Panel ${e.name} already added to ${a.parentGroup.name} !`);
    if (this.context.panelInstances.has(a.name))
      throw new Error(`A panel named ${e.name} already exists in this layout`);
    const s = Ee(new ye(this));
    Object.assign(s, e), s.children = [], s.size = e.size ?? 0, s.accept = e.accept ?? this.accept;
    const c = ((g = this.context.layoutConfig) == null ? void 0 : g.defaultPanelConfig) || ((u = this.context.layoutConfig) == null ? void 0 : u.initialPanelConfig);
    return c && s.applyInitialConfig(c), this.addChild(s, i), this.context.panelInstances.set(a.name, s), s;
  }
  moveChildGridToSelf(e) {
    e.childReplacedBy = this, this.children.push(...e.children);
    for (const o of this.children)
      o.parentGroup = this;
    for (const o of this.childGrid)
      o.parentGroup = null;
    this.childGrid.splice(0);
    for (const o of e.childGrid)
      this.childGrid.push(o);
    for (const o of this.childGrid)
      o.parentGroup = this;
    this.direction = e.direction, this.setActiveChild(e.activePanel);
  }
  getContainerSize() {
    return this.pushLateAction("getContainerSize"), super.getContainerSize();
  }
  setActiveChild(e) {
    var i;
    this.activePanel !== e && (this.activePanel = e, e instanceof ye && ((i = e.onActive) == null || i.call(e, e)), this.context.childGridActiveChildChanged(this));
  }
  reselectActiveChild() {
    super.reselectActiveChild(), this.context.childGridActiveChildChanged(this);
  }
  addChildGrid(e, o) {
    typeof o == "number" ? this.childGrid.splice(o, 0, e) : this.childGrid.push(e), e.parentGroup = this, e.parentGrid = this.parentGrid;
  }
  addChildGrids(e, o) {
    typeof o == "number" ? this.childGrid.splice(o, 0, ...e) : this.childGrid.push(...e);
    for (const i of e)
      i.parentGroup = this, i.parentGrid = this.parentGrid;
  }
  removeChildGrid(e) {
    this.childGrid.splice(this.childGrid.indexOf(e), 1), e.parentGroup = null;
  }
  replaceChildGrid(e, o) {
    const i = this.childGrid.indexOf(e);
    if (i === -1)
      throw new Error(`Panel ${e.name} is not child of this group !`);
    this.childGrid.splice(
      i,
      1,
      o
    ), e.parentGroup === this && (e.parentGroup = null), o.parentGroup = this, o.parentGrid = this.parentGrid;
  }
  hasChildGrid(e) {
    return this.childGrid.includes(e);
  }
  toJson() {
    return {
      name: this.name,
      open: this.open,
      size: this.size,
      visible: this.visible,
      direction: this.direction,
      children: this.children.map((e) => {
        var i;
        const o = e;
        return {
          name: o.name,
          title: o.title,
          tooltip: o.tooltip,
          badge: o.badge,
          data: o.data,
          closeType: o.closeType || "close",
          // Store icon names for serialization
          iconSmallName: o._iconSmallName,
          iconLargeName: o._iconLargeName,
          hasIconSmall: !!o._iconSmallName,
          hasIconLarge: !!o._iconLargeName,
          hasActions: !!((i = o.actions) != null && i.length)
        };
      }),
      childGrid: this.childGrid.map((e) => e.toJson())
    };
  }
  loadFromJson(e) {
    this.direction = e.direction || this.direction, this.canMinClose = e.canMinClose ?? this.canMinClose, super.loadFromJson(e), this._iconSmallName = e.iconSmallName, this._iconLargeName = e.iconLargeName;
  }
  loadLayout(e, o, i) {
    this.clearLayout();
    const a = (g) => {
      var r;
      const u = o(g);
      return (r = i == null ? void 0 : i.defaultPanelConfig) != null && r.iconGenerator && (u.iconSmallName && (u.iconSmall = i.defaultPanelConfig.iconGenerator(u.iconSmallName)), u.iconLargeName && (u.iconLarge = i.defaultPanelConfig.iconGenerator(u.iconLargeName))), u;
    }, s = [];
    function c(g) {
      if (g.children)
        for (const u of g.children)
          u.children ? c(u) : s.push(a(u));
    }
    if (c(e), s.length !== 0)
      switch (i == null ? void 0 : i.arrangement) {
        case "columns": {
          this.direction = "horizontal";
          const g = 100 / s.length;
          for (const u of s) {
            const r = this.addPanel(u);
            r.size = g;
          }
          break;
        }
        case "rows": {
          this.direction = "vertical";
          const g = 100 / s.length;
          for (const u of s) {
            const r = this.addPanel(u);
            r.size = g;
          }
          break;
        }
        case "grid": {
          const g = s.length, u = Math.ceil(Math.sqrt(g)), r = Math.ceil(g / u);
          this.direction = "vertical";
          const h = 100 / r;
          let S = 0;
          for (let m = 0; m < r; m++) {
            const b = new he(this.context);
            b.direction = "horizontal", b.name = `row-${m}`, b.size = h, this.addChildGrid(b);
            const k = Math.min(u, g - m * u), _ = 100 / k;
            for (let P = 0; P < k && S < g; P++) {
              const L = new he(this.context);
              L.direction = "vertical", L.name = `cell-${m}-${P}`, L.size = _, b.addChildGrid(L);
              const I = s[S++], B = L.addPanel(I);
              B.size = 100;
            }
          }
          break;
        }
        default: {
          let g = function(u, r) {
            if (u.direction && (r.direction = u.direction), u.children)
              for (const h of u.children)
                if (h.children) {
                  const S = new he(r.context);
                  r.addChildGrid(S), g(h, S);
                } else {
                  const S = a(h), m = r.addPanel(S);
                  h.size && (m.size = h.size);
                }
          };
          g(e, this);
        }
      }
  }
}
const Qt = {}, en = (() => {
  let t = !1;
  return () => {
    t || (console.warn(
      "[vue-code-layout] Direct usage of useLayoutPersistence is deprecated. Please use the plugin-based approach with useLayoutStore instead. See documentation for migration guide."
    ), t = !0);
  };
})();
function tn(t) {
  en();
  const {
    supabase: n,
    stateId: e,
    layoutInstance: o,
    autoSync: i = !0,
    autoSyncDebounce: a = 1e3,
    onError: s = console.error,
    onBeforeSave: c,
    onAfterSave: g,
    onBeforeLoad: u,
    onAfterLoad: r,
    onBeforeCreateVersion: h,
    onAfterCreateVersion: S,
    onBeforeLoadVersion: m,
    onAfterLoadVersion: b,
    debug: k = !1,
    tables: _ = {
      states: "layout_states",
      versions: "layout_state_versions"
    },
    columns: P = {
      stateId: "state_id",
      layout: "layout",
      versionName: "version_name",
      createdAt: "created_at",
      updatedAt: "updated_at",
      layoutStateId: "layout_state_id"
    },
    additionalData: L,
    additionalVersionData: I,
    defaultPanelConfig: B,
    initialPanelConfig: T
  } = t, O = E(null), ne = E([]), v = E(!1), C = E(null), D = E(k);
  let W = null;
  const y = (G, f) => {
    D.value && (console.group(`[vue-code-layout] ${G}`), f && console.log(f), console.groupEnd());
  }, J = async () => {
    v.value = !0, C.value = null;
    try {
      if (y("Initializing state", { initialStateId: e }), e) {
        const { data: G, error: f } = await n.from(_.states).select("*").eq(P.stateId, e).single();
        if (f && f.code !== "PGRST116")
          throw f;
        if (G)
          return y("Found existing state", G), O.value = G, await j(G.id), G.state_id;
      }
      return y("No existing state found, will create new"), null;
    } catch (G) {
      return C.value = G, s(G), null;
    } finally {
      v.value = !1;
    }
  }, j = async (G) => {
    v.value = !0, C.value = null;
    try {
      y("Fetching versions", { stateId: G });
      const { data: f, error: p } = await n.from(_.versions).select("*").eq("layout_state_id", G).order("created_at", { ascending: !1 });
      if (p)
        throw p;
      ne.value = f || [], y("Versions fetched", ne.value);
    } catch (f) {
      C.value = f, s(f);
    } finally {
      v.value = !1;
    }
  }, M = (G) => typeof G == "function" ? G() : G || {}, z = async (G) => {
    var f, p;
    v.value = !0, C.value = null;
    try {
      y("Saving state");
      let w;
      if (o.saveLayout) {
        let N = function(Q) {
          for (const X of Q.children || [])
            X.markAsSaved && X.markAsSaved();
          for (const X of Q.childGrid || [])
            N(X);
        };
        const Y = o.getRootGrid();
        N(Y), w = o.saveLayout();
      } else if (o.getRootGrid) {
        let N = function(Q) {
          for (const X of Q.children || [])
            X.markAsSaved && X.markAsSaved();
          for (const X of Q.childGrid || [])
            N(X);
        };
        const Y = o.getRootGrid();
        N(Y), w = Y.toJSON();
      } else
        throw new Error("Layout instance does not have saveLayout or getRootGrid method");
      const A = ((f = O.value) == null ? void 0 : f.state_id) || e || crypto.randomUUID();
      y("Using state ID", A);
      const F = {
        [P.stateId]: A,
        [P.layout]: w,
        [P.updatedAt]: (/* @__PURE__ */ new Date()).toISOString(),
        ...M(L),
        // Default additional data
        ...M(G)
        // Override with save-time data
      };
      let R;
      if ((p = O.value) != null && p.id) {
        y("Updating existing state");
        const { data: N, error: Y } = await n.from(_.states).update(F).eq("id", O.value.id).select().single();
        if (Y)
          throw Y;
        R = N;
      } else {
        y("Creating new state"), F[P.createdAt] = (/* @__PURE__ */ new Date()).toISOString();
        const { data: N, error: Y } = await n.from(_.states).insert(F).select().single();
        if (Y)
          throw Y;
        R = N;
      }
      return y("State saved successfully", R), O.value = R, R;
    } catch (w) {
      throw C.value = w, s(w), w;
    } finally {
      v.value = !1;
    }
  }, H = async (G, f) => {
    var p;
    v.value = !0, C.value = null;
    try {
      if (y("Creating version", { versionName: G }), !((p = O.value) != null && p.id)) {
        y("No current state, saving state first");
        const N = await z();
        if (!N)
          throw new Error("Failed to save state");
        O.value = N;
      }
      let w;
      if (o.saveLayout)
        w = o.saveLayout();
      else if (o.getRootGrid)
        w = o.getRootGrid().toJSON();
      else
        throw new Error("Layout instance does not have saveLayout or getRootGrid method");
      y("Creating version in database");
      const A = {
        layout_state_id: O.value.id,
        // Using the UUID primary key from parent layout_states record
        [P.versionName]: G,
        [P.layout]: w,
        ...M(I),
        // Default additional data
        ...M(f)
        // Override with save-time data
      }, { data: F, error: R } = await n.from(_.versions).insert(A).select().single();
      if (R)
        throw R;
      y("Version created successfully", F), await j(O.value.id);
    } catch (w) {
      throw C.value = w, s(w), w;
    } finally {
      v.value = !1;
    }
  }, d = async (G, f) => {
    var p, w, A;
    v.value = !0, C.value = null;
    try {
      y("Loading version", G);
      const F = G.layout, R = /* @__PURE__ */ new Map();
      if (o.getRootGrid) {
        let N = function(Q) {
          var X;
          for (const oe of Q.children || [])
            (X = oe.data) != null && X.fromVersion || R.set(oe.name, oe);
          for (const oe of Q.childGrid || [])
            N(oe);
        };
        const Y = o.getRootGrid();
        N(Y);
      }
      if (o.clearLayout && o.clearLayout(), o.loadLayout) {
        if (o.loadLayout(F, (N) => {
          var X;
          if (R.has(N.name))
            return R.get(N.name);
          const Y = {
            ...N,
            data: {
              ...N.data || {},
              fromVersion: !0
              // Mark this panel as coming from a version
            },
            actions: N.hasActions ? [] : void 0
          }, Q = (f == null ? void 0 : f.defaultPanelConfig) || ((X = f == null ? void 0 : f.layoutConfig) == null ? void 0 : X.defaultPanelConfig) || B || T;
          return Q != null && Q.iconGenerator ? (N.hasIconSmall && N.iconSmallName && (Y.iconSmall = Q.iconGenerator(N.iconSmallName)), N.hasIconLarge && N.iconLargeName && (Y.iconLarge = Q.iconGenerator(N.iconLargeName))) : (Y.iconSmallName = N.iconSmallName, Y.iconLargeName = N.iconLargeName), Y;
        }, f), (f == null ? void 0 : f.arrangement) !== "default") {
          const N = (p = o.getActiveGrid) == null ? void 0 : p.call(o);
          if (N)
            for (const [Y, Q] of R)
              (w = o.getPanelByName) != null && w.call(o, Q.name) || N.addPanel(Q);
        }
      } else
        o.getRootGrid().fromJSON(F), (A = o.notifyRelayout) == null || A.call(o);
      y("Version loaded successfully");
    } catch (F) {
      C.value = F, s(F);
    } finally {
      v.value = !1;
    }
  }, $ = async () => {
    var G, f;
    v.value = !0, C.value = null;
    try {
      y("Loading state"), O.value || await J() || (y("No existing state found, creating new"), await z()), (G = O.value) != null && G.layout && (y("Loading layout from state"), o.clearLayout && o.clearLayout(), o.loadLayout ? o.loadLayout(O.value.layout, (p) => {
        const w = {
          ...p,
          data: p.data || {},
          // Ensure data object exists
          actions: p.hasActions ? [] : void 0
        };
        return B != null && B.iconGenerator ? (p.hasIconSmall && p.iconSmallName && (w.iconSmall = B.iconGenerator(p.iconSmallName)), p.hasIconLarge && p.iconLargeName && (w.iconLarge = B.iconGenerator(p.iconLargeName))) : (w.iconSmallName = p.iconSmallName, w.iconLargeName = p.iconLargeName), w;
      }) : (o.getRootGrid().fromJSON(O.value.layout), (f = o.notifyRelayout) == null || f.call(o)), y("Layout loaded successfully"));
    } catch (p) {
      C.value = p, s(p);
    } finally {
      v.value = !1;
    }
  };
  if (i && o.onLayoutChange) {
    let G;
    W = o.onLayoutChange(() => {
      if (y("Layout changed, triggering auto-sync"), a === !1) {
        z();
        return;
      }
      G && clearTimeout(G), G = setTimeout(() => {
        z();
      }, a);
    });
  }
  return Jt(() => {
    W && W();
  }), {
    currentState: O,
    versions: ne,
    isLoading: v,
    error: C,
    loadState: $,
    saveState: z,
    createVersion: H,
    loadVersion: d,
    fetchVersions: j,
    debug: D
  };
}
const Tt = Symbol("layout-store");
function nn() {
  let t = null;
  const n = E(null), e = E(null), o = E(!1);
  let i = {};
  const a = () => {
    if (!o.value)
      throw new Error("[vue-code-layout] Store not initialized. Call initialize first.");
  }, s = {
    initialize: async (c) => {
      if (!n.value)
        throw new Error("[vue-code-layout] Layout instance not set. Call setLayoutInstance before initializing.");
      i = c.events || {}, t = tn({
        ...c,
        layoutInstance: n.value,
        onError: async (g) => {
          var u, r;
          (u = c.onError) == null || u.call(c, g), await ((r = i.onError) == null ? void 0 : r.call(i, g));
        },
        onBeforeSave: i.onBeforeSave,
        onAfterSave: i.onAfterSave,
        onBeforeLoad: i.onBeforeLoad,
        onAfterLoad: i.onAfterLoad,
        onBeforeCreateVersion: i.onBeforeCreateVersion,
        onAfterCreateVersion: i.onAfterCreateVersion,
        onBeforeLoadVersion: i.onBeforeLoadVersion,
        onAfterLoadVersion: i.onAfterLoadVersion
      }), s.currentState = t.currentState, s.versions = t.versions, s.isLoading = t.isLoading, s.error = t.error, s.loadState = async () => {
        var g, u;
        await ((g = i.onBeforeLoad) == null ? void 0 : g.call(i)), await t.loadState(), s.currentState.value && await ((u = i.onAfterLoad) == null ? void 0 : u.call(i, s.currentState.value));
      }, s.saveState = async () => {
        var u, r;
        await ((u = i.onBeforeSave) == null ? void 0 : u.call(i));
        const g = await t.saveState();
        return await ((r = i.onAfterSave) == null ? void 0 : r.call(i, g)), g;
      }, s.createVersion = async (g) => {
        var r, h;
        await ((r = i.onBeforeCreateVersion) == null ? void 0 : r.call(i)), await t.createVersion(g);
        const u = t.versions.value[0];
        u && await ((h = i.onAfterCreateVersion) == null ? void 0 : h.call(i, u));
      }, s.loadVersion = async (g, u) => {
        var r, h, S;
        await ((r = i.onBeforeLoadVersion) == null ? void 0 : r.call(i, g)), await t.loadVersion(g, {
          ...u,
          defaultPanelConfig: (u == null ? void 0 : u.defaultPanelConfig) || ((h = u == null ? void 0 : u.layoutConfig) == null ? void 0 : h.defaultPanelConfig)
        }), await ((S = i.onAfterLoadVersion) == null ? void 0 : S.call(i, g));
      }, s.fetchVersions = t.fetchVersions, o.value = !0, await s.loadState();
    },
    setLayoutInstance: (c) => {
      if (o.value)
        throw new Error("[vue-code-layout] Cannot set layout instance after initialization.");
      n.value = l(c);
    },
    layoutInstance: n,
    lastActivePanel: e,
    // Initialize with empty refs and no-op functions that throw
    currentState: E(null),
    versions: E([]),
    isLoading: E(!1),
    error: E(null),
    updateData: (c, g) => {
      const u = l(n);
      if (!u) {
        console.warn("[vue-code-layout] Layout instance not set");
        return;
      }
      let r;
      if (typeof c != "string")
        r = c;
      else {
        const h = u.getRootGrid(), S = (m) => {
          for (const b of m.children)
            if (b.name === c)
              return b;
          for (const b of m.childGrid) {
            const k = S(b);
            if (k)
              return k;
          }
        };
        r = S(h);
      }
      if (!r) {
        console.warn(`[vue-code-layout] Could not find panel instance: ${typeof c == "string" ? c : "unknown"}`);
        return;
      }
      r.updateData ? r.updateData(g) : r.data = {
        ...r.data,
        ...g
      }, u.getRootGrid().notifyRelayout();
    },
    getAllPanels: () => {
      const c = l(n);
      if (!c)
        return console.warn("[vue-code-layout] Layout instance not set"), [];
      try {
        const g = c.getRootGrid();
        if (!g)
          return console.warn("[vue-code-layout] Root grid not available"), [];
        const u = [], r = (h, S) => {
          try {
            if (Array.isArray(h.children))
              for (const m of h.children)
                m && typeof m == "object" && u.push({
                  name: m.name || "",
                  title: m.title || "",
                  data: { ...m.data || {} },
                  // Create a copy of the data, handling undefined
                  gridName: h.name,
                  parentGrid: S
                });
            if (Array.isArray(h.childGrid))
              for (const m of h.childGrid)
                m && r(m, h.name);
          } catch (m) {
            console.error("[vue-code-layout] Error collecting panels from grid", m);
          }
        };
        return r(g), u;
      } catch (g) {
        return console.error("[vue-code-layout] Error getting all panels", g), [];
      }
    },
    loadState: async () => (a(), null),
    saveState: async () => (a(), null),
    createVersion: async () => (a(), null),
    loadVersion: async () => (a(), null),
    fetchVersions: async () => (a(), null)
  };
  return {
    install(c) {
      c.provide(Tt, s);
    },
    store: s
    // Expose the store instance
  };
}
function Wt() {
  const t = ae(Tt);
  if (!t)
    throw new Error("[vue-code-layout] Layout store not found. Did you install the plugin?");
  return t;
}
function Ia(t) {
  const n = !!mt();
  !t && !n && console.warn(
    "[vue-code-layout] useLayout() was called outside of a component setup. This may lead to issues. Pass the store explicitly when using outside of components."
  );
  const e = t || Wt(), o = (h) => {
    e.setLayoutInstance(h);
  }, i = (h, S) => {
    const m = l(e.layoutInstance);
    if (!m) {
      console.warn("[vue-code-layout] Layout instance not set");
      return;
    }
    return m.addPanelToActiveGrid(h, S);
  }, a = () => {
    var h;
    return (h = l(e.layoutInstance)) == null ? void 0 : h.getActiveGrid();
  }, s = (h) => {
    var S;
    return (S = l(e.layoutInstance)) == null ? void 0 : S.getPanelByName(h);
  }, c = (h, S, m) => {
    var b;
    return (b = l(e.layoutInstance)) == null ? void 0 : b.replacePanel(h, S, m);
  }, g = () => {
    var h;
    return (h = l(e.layoutInstance)) == null ? void 0 : h.getRootGrid();
  }, u = (h) => {
    var S;
    return (S = l(e.layoutInstance)) == null ? void 0 : S.clearLayout(h);
  }, r = (h, S) => e.loadVersion(h, S);
  return {
    // Layout instance methods
    setLayoutRef: o,
    addPanel: i,
    getActiveGrid: a,
    getPanelByName: s,
    replacePanel: c,
    getRootGrid: g,
    clearLayout: u,
    layoutInstance: e.layoutInstance,
    lastActivePanel: e.lastActivePanel,
    // Store methods
    store: e,
    currentState: e.currentState,
    versions: e.versions,
    isLoading: e.isLoading,
    error: e.error,
    loadState: e.loadState,
    saveState: e.saveState,
    createVersion: e.createVersion,
    loadVersion: r,
    fetchVersions: e.fetchVersions,
    updateData: e.updateData
  };
}
function Oa(t = {}) {
  const n = Wt(), e = E([]), o = E(t.filter), i = E(!1), a = E(null);
  let s;
  const c = je(() => o.value ? e.value.filter(o.value) : e.value), g = async () => {
    i.value = !0, a.value = null;
    try {
      e.value = n.getAllPanels();
    } catch (m) {
      console.error("[vue-code-layout] Error refreshing panels:", m), a.value = m instanceof Error ? m : new Error(String(m));
    } finally {
      i.value = !1;
    }
  }, u = (m) => {
    o.value = m;
  }, r = (m) => e.value.find((b) => b.name === m), h = (m) => e.value.filter((b) => b.gridName === m), S = () => {
    s && (clearInterval(s), s = void 0);
  };
  return we(() => {
    g(), t.autoRefreshInterval && t.autoRefreshInterval > 0 && (s = window.setInterval(() => {
      g();
    }, t.autoRefreshInterval));
  }), {
    allPanels: e,
    filteredPanels: c,
    currentFilter: o,
    isLoading: i,
    error: a,
    refreshPanels: g,
    setFilter: u,
    findPanelByName: r,
    findPanelsByGrid: h,
    stopAutoRefresh: S
  };
}
const Be = {
  getTop: pt,
  getLeft: St,
  getElementIndex: an,
  getElementAbsolutePositionInParent: on
};
function pt(t, n) {
  let e = t.offsetTop;
  const o = t.offsetParent;
  return t.offsetParent !== null && (!n || (typeof n == "string" ? !o.classList.contains(n) : t.offsetParent !== n)) && (e += pt(o, n) - o.scrollTop), t.offsetParent === null && (e -= document.documentElement.scrollTop), e;
}
function St(t, n) {
  let e = t.offsetLeft;
  const o = t.offsetParent;
  return t.offsetParent !== null && (!n || (typeof n == "string" ? !o.classList.contains(n) : t.offsetParent !== n)) && (e += St(o, n) - o.scrollLeft), t.offsetParent === null && (e -= document.documentElement.scrollLeft), e;
}
function on(t, n) {
  return {
    x: St(t, n),
    y: pt(t, n)
  };
}
function an(t) {
  for (let n = 0, e = t.parentNode.childNodes.length; n < e; n++)
    if (t.parentNode.childNodes.item(n) === t)
      return n;
  return -1;
}
class ot {
  constructor(n = 0, e = 0) {
    /**
     * X axis
     */
    K(this, "x", 0);
    /**
     * Y axis
     */
    K(this, "y", 0);
    typeof n == "object" ? (this.y = n.y, this.x = n.x) : (this.y = e, this.x = n);
  }
  /**
   * Set new vector values
   * @param x X axis or other Vector
   * @param y Y axis or none
   */
  set(n, e = 0) {
    return typeof n == "number" ? (this.y = typeof e == "number" ? e : n, this.x = n) : (this.y = n.y, this.x = n.x), this;
  }
  /**
   * Clone a new item
   * @returns 
   */
  clone() {
    return new ot(this.x, this.y);
  }
  /**
   * 将当前二维向量加指定数字 【Adds the specified number to the current 2D vector】
   * @param v 
   * @returns 
   */
  add(n) {
    return typeof n == "number" ? (this.x += n, this.y += n) : typeof n == "object" && (this.x += n.x, this.y += n.y), this;
  }
  /**
   * 将当前二维向量减以指定数字【Subtract the current 2D vector to specify a number】
   * @param v 
   * @returns 
   */
  substract(n) {
    return typeof n == "number" ? (this.x -= n, this.y -= n) : typeof n == "object" && (this.x -= n.x, this.y -= n.y), this;
  }
  /**
   * 将当前二维向量乘以指定数字 【Multiplies the current 2D vector by the specified number】
   * @param v 
   * @returns 
   */
  multiply(n) {
    return this.x *= n, this.y *= n, this;
  }
  /**
   * 将当前二维向量除以指定数字 【Divides the current 2D vector by the specified number】
   * @param v 
   * @returns 
   */
  divide(n) {
    return this.x /= n, this.y /= n, this;
  }
  /**
   * Test two vector2's value is equal
   */
  equal(n) {
    return this.x === n.x && this.y === n.y;
  }
  /**
   * 转为字符串
   * @returns 
   */
  toString() {
    return `{x=${this.x},y=${this.y}}`;
  }
}
function it(t) {
  const { onDown: n, onMove: e, onUp: o } = t, i = new ot(), a = new ot();
  let s;
  function c(u) {
    u.stopPropagation(), a.set(u.x, u.y), a.substract(i), e(i, a, u, s);
  }
  function g(u) {
    o(u, s), i.set(0, 0), document.removeEventListener("mousemove", c), document.removeEventListener("mouseup", g);
  }
  return (u, r) => n(u, r) ? (s = r, i.set(u.x, u.y), document.addEventListener("mousemove", c), document.addEventListener("mouseup", g), u.stopPropagation(), !0) : !1;
}
const rn = ["onMousedown"], ln = { class: "content" }, sn = /* @__PURE__ */ ce({
  __name: "SplitN",
  props: {
    grid: {
      type: Object,
      default: null
    },
    /**
     * Is horizontal?
     * 
     * Default: true
     */
    horizontal: {
      type: Boolean,
      default: !0
    },
    /**
     * Set Dragger size (pixel)
     * 
     * Default: true
     */
    draggerSize: {
      type: Number,
      default: 1
    },
    forceDraggerActiveState: {
      type: Number,
      default: 0
    },
    indexOfParent: {
      type: Number,
      default: 0
    },
    isLastOfParent: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "orthogonalDraggerHover",
    "orthogonalDraggerDrag"
  ],
  setup(t, { expose: n, emit: e }) {
    const o = e, i = t, a = E(), s = E([]);
    let c = 0, g = 0, u = !1, r = !1;
    const h = [], S = [];
    function m(M, z, H, d) {
      var A;
      let $ = 0;
      const G = H / 100 * M, f = G + d, p = (z == null ? void 0 : z.minSize) || 0, w = Math.max(p, f);
      if (z.canMinClose && p > 0) {
        const F = f > p / 2;
        F != z.visible && (z.visible = F, (A = z.onMinCloseChanged) == null || A.call(z, z, F)), z.visible || ($ += w);
      }
      return z.size = w / M * 100, {
        adjustedSize: w - G,
        visibleChangedSize: $
      };
    }
    function b(M) {
      if (!a.value)
        throw new Error("!splitBase.value");
      const z = i.horizontal ? a.value.offsetWidth : a.value.offsetHeight;
      return M.minSize ? M.minSize / z * 100 : 0;
    }
    function k(M, z) {
      c = i.horizontal ? Be.getLeft(a.value) : Be.getTop(a.value), s.value[z] = !0, g = 0, h.splice(0), S.splice(0);
      for (let H = z - 1; H >= 0; H--) {
        const d = i.grid.childGrid[H];
        d.visible && (g += d.size, h.push({ panel: d, size: d.size }));
      }
      for (let H = z; H < i.grid.childGrid.length; H++) {
        const d = i.grid.childGrid[H];
        d.visible && S.push({ panel: d, size: d.size });
      }
    }
    function _(M, z) {
      if (!a.value)
        return;
      const H = i.horizontal ? a.value.offsetWidth : a.value.offsetHeight;
      let $ = (i.horizontal ? M.x : M.y) - c - g / 100 * H;
      if ($ === 0)
        return;
      const G = $ > 0, f = (w) => {
        let A = $ - w, F = 0;
        for (let R = 0; R < S.length; R++) {
          const N = S[R], { adjustedSize: Y, visibleChangedSize: Q } = m(
            H,
            N.panel,
            N.size,
            -A
          );
          if (F += Q, A += Y, G ? A <= 0 : A >= 0)
            break;
        }
        return {
          overflowSize: A,
          visibleChangedSize: F
        };
      }, p = (w) => {
        let A = $ - w, F = 0;
        for (let R = 0; R < h.length; R++) {
          const N = h[R], { adjustedSize: Y, visibleChangedSize: Q } = m(
            H,
            N.panel,
            N.size,
            A
          );
          if (A -= Y, F += Q, G ? A <= 0 : A >= 0)
            break;
        }
        return {
          overflowSize: A,
          visibleChangedSize: F
        };
      };
      if (G) {
        const { overflowSize: w, visibleChangedSize: A } = f(0);
        A !== 0 && ($ += A), p(w);
      } else {
        const { overflowSize: w, visibleChangedSize: A } = p(0);
        A !== 0 && ($ -= A), f(w);
      }
    }
    function P(M, z) {
      s.value[z] = !1;
    }
    function L(M) {
      o("orthogonalDraggerHover", M, !0);
    }
    function I(M) {
      u ? r = !0 : (r = !1, o("orthogonalDraggerHover", M, !1));
    }
    function B(M, z) {
      switch (M) {
        case "down":
          k(z, i.forceDraggerActiveState);
          break;
        case "move":
          _(z, i.forceDraggerActiveState);
          break;
        case "up":
          P(z, i.forceDraggerActiveState);
          break;
      }
    }
    const T = it({
      onDown(M, z) {
        return a.value && typeof z == "number" ? (u = !0, k(M, z), o("orthogonalDraggerDrag", "down", M), !0) : !1;
      },
      onMove(M, z, H, d) {
        a.value && typeof d == "number" && (_(H), o("orthogonalDraggerDrag", "move", H));
      },
      onUp(M, z) {
        u = !1, o("orthogonalDraggerDrag", "up", M), P(M, z), r && I("");
      }
    });
    function O() {
      if (!a.value)
        throw new Error("!splitBase.value");
      const M = i.horizontal ? a.value.offsetWidth : a.value.offsetHeight;
      let z = 0, H = 100;
      for (const d of i.grid.childGrid)
        d.lastRelayoutSize = M, d.size > 0 ? H -= d.visible ? d.size : 0 : z++;
      return {
        canAllocSize: Math.max(H, 0),
        notAllocSpaceAndOpenCount: z
      };
    }
    function ne() {
      const { canAllocSize: M, notAllocSpaceAndOpenCount: z } = O();
      return z > 0 ? M / z : 0;
    }
    function v() {
      const M = ne();
      for (const z of i.grid.childGrid)
        z.size <= 0 && (z.size = Math.max(M, b(z)));
    }
    function C(M) {
      if (!a.value)
        throw new Error("!splitBase.value");
      const z = 100, H = i.horizontal ? a.value.offsetWidth : a.value.offsetHeight, d = M < 0;
      let $ = 0;
      const G = i.grid.childGrid.filter((f) => f.visible ? ($ += f.size, !0) : !1).sort((f, p) => f.size > p.size ? 1 : -1);
      if (d) {
        if ($ >= z)
          return;
        const f = $ + -M - z;
        f > 0 && (M -= -f);
      }
      for (let f = 0; f < G.length; f++) {
        const p = G[f], { adjustedSize: w } = m(H, p, p.size, -M);
        if (M += w, !d && M <= 0 || d && M >= 0)
          break;
      }
    }
    function D(M, z) {
      if (M.length === 1 && z && z.size > b(z) + b(M[0])) {
        const H = z.size / 2;
        z.size = H, M[0].size = H;
      } else {
        for (const H of i.grid.childGrid)
          H.size = 0;
        v();
      }
    }
    function W(M) {
      C(-M.size);
    }
    function y() {
      v();
    }
    function J() {
      i.grid.listenLateAction("notifyRelayout", () => y()), i.grid.listenLateAction("relayoutAllWithNewPanel", D), i.grid.listenLateAction("relayoutAllWithResizedSize", C), i.grid.listenLateAction("relayoutAllWithRemovePanel", W);
    }
    function j(M) {
      M.unlistenAllLateAction();
    }
    return se(() => i.grid, (M, z) => {
      j(z), J(), v();
    }), se(() => i.grid.childGrid.length, () => {
      v();
    }), we(() => {
      fe(() => {
        v(), J();
      });
    }), Re(() => {
      j(i.grid);
    }), n({
      applyOrthogonalDragger: B
    }), (M, z) => (x(), V("div", {
      ref_key: "splitBase",
      ref: a,
      class: re([
        "code-layout-split-base",
        t.horizontal ? "horizontal" : "vertical"
      ])
    }, [
      (x(!0), V(xe, null, Oe(t.grid.childGrid, (H, d) => (x(), V("div", {
        key: H.name,
        style: Ge({
          width: t.horizontal && H.visible ? `calc(${H.size}% - ${t.draggerSize}px)` : void 0,
          height: t.horizontal ? void 0 : H.visible ? `calc(${H.size}% - ${t.draggerSize}px)` : void 0
        }),
        class: "split-n-container"
      }, [
        H.visible && d !== 0 ? (x(), V("div", {
          key: 0,
          class: re([
            "code-layout-split-dragger resize inner",
            s.value[d] || t.forceDraggerActiveState === d ? "active" : ""
          ]),
          style: Ge({
            width: t.horizontal ? `${t.draggerSize}px` : void 0,
            height: t.horizontal ? void 0 : `${t.draggerSize}px`
          }),
          onMousedown: ($) => l(T)($, d)
        }, [
          t.indexOfParent > 0 ? (x(), V("div", {
            key: 0,
            class: "code-layout-split-orthogonal-drag-handle start",
            onMouseenter: z[0] || (z[0] = ($) => L("start")),
            onMouseleave: z[1] || (z[1] = ($) => I("start"))
          }, null, 32)) : Z("", !0),
          t.isLastOfParent ? Z("", !0) : (x(), V("div", {
            key: 1,
            class: "code-layout-split-orthogonal-drag-handle end",
            onMouseenter: z[2] || (z[2] = ($) => L("end")),
            onMouseleave: z[3] || (z[3] = ($) => I("end"))
          }, null, 32))
        ], 46, rn)) : Z("", !0),
        q("div", ln, [
          H.visible ? U(M.$slots, "grid", {
            key: 0,
            grid: H,
            index: d
          }) : Z("", !0)
        ])
      ], 4))), 128))
    ], 2));
  }
});
const cn = /* @__PURE__ */ ce({
  __name: "SplitNest",
  props: {
    grid: {
      type: Object,
      default: null
    },
    indexOfParent: {
      type: Number,
      default: 0
    },
    isLastOfParent: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    const n = E(), e = E(0);
    function o(a, s, c) {
      if (!c) {
        e.value = 0;
        return;
      }
      s === "start" ? e.value = a : s === "end" && (e.value = a + 1);
    }
    function i(a, s, c) {
      var g;
      e.value > 0 && ((g = n.value) == null || g.applyOrthogonalDragger(s, c));
    }
    return (a, s) => {
      var g;
      const c = Ve("SplitNest", !0);
      return (g = t.grid.childGrid) != null && g.length ? (x(), te(sn, {
        ref_key: "splitLayoutRef",
        ref: n,
        key: t.grid.name,
        grid: t.grid,
        horizontal: t.grid.direction === "horizontal",
        indexOfParent: t.indexOfParent,
        isLastOfParent: t.isLastOfParent,
        forceDraggerActiveState: e.value
      }, {
        grid: ee(({ grid: u, index: r }) => {
          var h;
          return [
            (h = u.childGrid) != null && h.length ? (x(), te(c, {
              key: u.name,
              grid: u,
              indexOfParent: r,
              isLastOfParent: r === t.grid.childGrid.length - 1,
              onOrthogonalDraggerHover: (S, m) => o(r, S, m),
              onOrthogonalDraggerDrag: (S, m) => i(r, S, m)
            }, {
              grid: ee((S) => [
                U(a.$slots, "grid", pe(Se(S)))
              ]),
              _: 2
            }, 1032, ["grid", "indexOfParent", "isLastOfParent", "onOrthogonalDraggerHover", "onOrthogonalDraggerDrag"])) : U(a.$slots, "grid", {
              key: 1,
              grid: u,
              index: r
            })
          ];
        }),
        _: 3
      }, 8, ["grid", "horizontal", "indexOfParent", "isLastOfParent", "forceDraggerActiveState"])) : U(a.$slots, "grid", {
        key: 1,
        grid: t.grid,
        index: 0
      });
    };
  }
}), ke = ce({
  props: {
    content: {
      type: null,
      required: !0
    },
    class: {
      type: String,
      default: ""
    },
    fallback: {
      type: String,
      default: null
    }
  },
  render() {
    return typeof this.content == "string" ? [le("span", { class: this.class }, this.content)] : typeof this.content == "function" ? [this.content()] : this.fallback != null ? [le("span", { class: this.class }, this.fallback)] : [];
  }
}), de = (t, n) => {
  const e = t.__vccOpts || t;
  for (const [o, i] of n)
    e[o] = i;
  return e;
}, un = {}, dn = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function fn(t, n) {
  return x(), V("svg", dn, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M150 163l68 69l14 -14l-69 -68l69 -68l-14 -14l-68 69l-68 -69l-14 14l69 68l-69 68l14 14z"
    }, null, -1)
  ]));
}
const Ht = /* @__PURE__ */ de(un, [["render", fn]]), hn = {}, vn = {
  id: "图层_1",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 310 300",
  style: { "enable-background": "new 0 0 310 300" },
  "xml:space": "preserve"
};
function gn(t, n) {
  return x(), V("svg", vn, n[0] || (n[0] = [
    q("circle", {
      cx: "160",
      cy: "150",
      r: "99",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const mn = /* @__PURE__ */ de(hn, [["render", gn]]);
function xt(t, n) {
  let e = 0;
  return {
    start() {
      e > 0 && clearTimeout(e), e = setTimeout(() => {
        e = 0, n();
      }, t);
    },
    stop() {
      e > 0 && (clearTimeout(e), e = 0);
    }
  };
}
function yn(t, n) {
  let e = 0;
  return {
    start() {
      e > 0 && clearInterval(e), e = setInterval(() => {
        e = 0, n();
      }, t);
    },
    stop() {
      e > 0 && (clearInterval(e), e = 0);
    }
  };
}
function Ke(t, n, e) {
  return t !== n && (!t.accept || t.accept.includes(n.parentGrid)) && (!t.preDropCheck || t.preDropCheck(t, n.parentGrid, n, e.value));
}
let Ye = null;
function $e() {
  return Ye;
}
function Nt() {
  const t = E(!1);
  ge("dragPanelState", t), ge("setDragPanelState", () => {
    t.value = !0, console.log("setDragPanelState");
  }), ge("resetDragPanelState", () => {
    t.value = !1;
  });
}
function Ze() {
  ae("dragPanelState");
  const t = ae("setDragPanelState"), n = ae("resetDragPanelState"), e = ae("codeLayoutConfig", void 0), o = 40, i = E(!1);
  function a(g) {
    e && (g.x < o && (e.value.primarySideBar = !0), g.x >= window.innerWidth - o && (e.value.secondarySideBar = !0), g.y >= window.innerHeight - o && (e.value.bottomPanel = !0));
  }
  function s(g, u) {
    var h, S;
    (((S = (h = e == null ? void 0 : e.value) == null ? void 0 : h.onStartDrag) == null ? void 0 : S.call(h, g)) ?? !1) || (u.stopPropagation(), Ye = g, u.target.classList.add("dragging"), i.value = !0, t(), document.addEventListener("dragover", a));
  }
  function c(g) {
    var u, r;
    Ye && ((r = (u = e == null ? void 0 : e.value) == null ? void 0 : u.onEndDrag) == null || r.call(u, Ye), Ye = null), g.target.classList.remove("dragging"), i.value = !1, n(), document.removeEventListener("dragover", a);
  }
  return {
    dragSelfState: i,
    handleDragStart: s,
    handleDragEnd: c
  };
}
function _e(t, n, e, o, i, a) {
  const s = ae("dragPanelState"), c = ae("resetDragPanelState"), g = E(!1), u = E(""), r = xt(600, () => {
    const I = $e();
    I != null && o(I);
  }), h = xt(200, () => {
    u.value = "";
  });
  let S = 0, m = 0;
  function b(I) {
    if (!I.dataTransfer)
      return;
    h.stop();
    const B = $e();
    if (B && I.preventDefault(), B && n && B !== n.value && !B.children.includes(n.value) && (!a || a(B)) || i(I)) {
      if (I.stopPropagation(), I.dataTransfer.dropEffect = "copy", !t.value)
        return;
      if (e === "four") {
        const T = I.x - S, O = I.y - m;
        T < t.value.offsetWidth / 4 ? u.value = "left" : T > t.value.offsetWidth - t.value.offsetWidth / 4 ? u.value = "right" : O < t.value.offsetHeight / 4 ? u.value = "up" : O > t.value.offsetHeight - t.value.offsetHeight / 4 ? u.value = "down" : u.value = "center";
      } else if (e === "center")
        u.value = "center";
      else if (e) {
        const T = e.value ? I.x - S : I.y - m;
        u.value = T > (e.value ? t.value.offsetWidth : t.value.offsetHeight) / 2 ? e.value ? "right" : "down" : e.value ? "left" : "up";
      } else
        u.value = "", I.stopPropagation(), I.dataTransfer.dropEffect = "none";
    } else
      u.value = "", I.stopPropagation(), I.dataTransfer.dropEffect = "none";
  }
  function k(I) {
    I.preventDefault(), I.stopPropagation(), r.start(), h.stop(), S = Be.getLeft(t.value), m = Be.getTop(t.value), g.value = !0, b(I);
  }
  function _(I) {
    I.preventDefault(), I.stopPropagation();
    let B = I.target;
    for (; B; ) {
      if (B === t.value) {
        g.value = !1, u.value = "", r.stop(), h.start();
        return;
      }
      B = B.parentNode;
    }
  }
  function P() {
    r.stop(), g.value = !1, u.value = "";
  }
  function L() {
    c();
  }
  return {
    dragPanelState: s,
    dragEnterState: g,
    dragOverState: u,
    handleDropPreCheck(I) {
      return i(I);
    },
    handleDragOver: b,
    handleDragEnter: k,
    handleDragLeave: _,
    resetDragOverState: P,
    resetDragState: L
  };
}
const pn = ["title", "draggable"], Sn = { class: "icon" }, bn = { class: "title" }, Cn = {
  key: 0,
  class: "badge"
}, wn = /* @__PURE__ */ ce({
  __name: "SplitTabItem",
  props: {
    panel: {
      type: Object,
      default: null
    },
    active: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["click", "contextMenu", "tab-hover"],
  setup(t, { emit: n }) {
    const e = t, o = E(), i = E(!0), { panel: a } = be(e), s = n, c = ae("splitLayoutContext"), {
      handleDragStart: g,
      handleDragEnd: u
    } = Ze(), {
      dragEnterState: r,
      dragOverState: h,
      handleDragOver: S,
      handleDragEnter: m,
      handleDragLeave: b,
      handleDropPreCheck: k,
      resetDragOverState: _,
      resetDragState: P
    } = _e(
      o,
      a,
      i,
      () => s("click"),
      (B) => c.dragDropNonPanel(B, !1, "tab-header"),
      (B) => Ke(B, a.value, h)
    );
    function L(B) {
      const T = $e();
      T && h.value ? (B.preventDefault(), B.stopPropagation(), c.dragDropToPanel(
        a.value,
        h.value,
        T,
        !0
      )) : k(B) && c.dragDropNonPanel(
        B,
        !0,
        "tab-header",
        a.value,
        h.value
      ), _(), P();
    }
    function I(B) {
      B.button === 1 && (B.preventDefault(), B.stopPropagation(), a.value.closeType !== "none" && a.value.closePanel());
    }
    return (B, T) => (x(), V("div", {
      ref_key: "container",
      ref: o,
      class: re([
        "item",
        t.active ? "active" : "",
        l(r) ? "drag-active" : "",
        `drag-over-${l(h)}`
      ]),
      title: l(a).tooltip,
      draggable: l(a).draggable,
      onDragstart: T[1] || (T[1] = (O) => l(g)(l(a), O)),
      onDragend: T[2] || (T[2] = //@ts-ignore
      (...O) => l(u) && l(u)(...O)),
      onDragover: T[3] || (T[3] = //@ts-ignore
      (...O) => l(S) && l(S)(...O)),
      onDragleave: T[4] || (T[4] = //@ts-ignore
      (...O) => l(b) && l(b)(...O)),
      onDragenter: T[5] || (T[5] = //@ts-ignore
      (...O) => l(m) && l(m)(...O)),
      onDrop: L,
      onClick: T[6] || (T[6] = (O) => s("click")),
      onMouseup: I,
      onMouseenter: T[7] || (T[7] = (O) => s("tab-hover", l(a), !0)),
      onMouseleave: T[8] || (T[8] = (O) => s("tab-hover", l(a), !1))
    }, [
      U(B.$slots, "icon", {}, () => [
        q("span", Sn, [
          ie(ke, {
            content: l(a).iconSmall || l(a).iconLarge
          }, null, 8, ["content"])
        ])
      ]),
      U(B.$slots, "title", {}, () => [
        q("span", bn, Ce(l(a).title), 1)
      ]),
      U(B.$slots, "badge", {}, () => [
        l(a).badge ? (x(), V("span", Cn, [
          ie(ke, {
            content: l(a).badge
          }, null, 8, ["content"])
        ])) : Z("", !0)
      ]),
      U(B.$slots, "close", {}, () => [
        l(a).closeType !== "none" ? (x(), V("span", {
          key: 0,
          class: "close",
          onClick: T[0] || (T[0] = Yt((O) => l(a).closePanel(), ["stop"]))
        }, [
          l(a).closeType === "close" ? (x(), te(Ht, {
            key: 0,
            class: "close-icon"
          })) : Z("", !0),
          l(a).closeType === "unSave" ? (x(), te(mn, {
            key: 1,
            class: "unsave-dot"
          })) : Z("", !0)
        ])) : Z("", !0)
      ])
    ], 42, pn));
  }
});
let st = 0, Fe = 0, ct = !1;
function Pn() {
  let t = !1;
  function n(o) {
    if (t = !1, Fe > 0 && (clearTimeout(Fe), Fe = 0), ct) {
      o();
      return;
    }
    st > 0 && clearTimeout(st), st = setTimeout(() => {
      t || (o(), ct = !0);
    }, 650);
  }
  function e() {
    Fe > 0 && clearTimeout(Fe), Fe = setTimeout(() => {
      ct = !1, t = !0;
    }, 50);
  }
  return {
    onEnter: n,
    onLeave: e
  };
}
const bt = /* @__PURE__ */ ce({
  __name: "SimpleTooltip",
  props: {
    /**
     * The content of the tooltip.
     */
    content: {
      type: String,
      default: ""
    },
    /**
     * Whether to enable the tooltip.
     */
    enable: {
      type: Boolean,
      default: !0
    },
    /**
     * The direction of the tooltip.
     * 
     * Default is 'right'.
     */
    direction: {
      type: String,
      default: "right"
    },
    /**
     * The teleport target of the tooltip.
     * 
     * Default is 'body'.
     */
    teleport: {
      type: String,
      default: "body"
    },
    /**
     * The main direction offset of the tooltip. (px)
     * 
     * Default is 5.
     */
    offset: {
      type: Number,
      default: 5
    }
  },
  setup(t) {
    const n = t, e = It(), o = E(), i = E(), a = E(0), s = E(0), c = E(""), g = E(!1), {
      onEnter: u,
      onLeave: r
    } = Pn();
    function h() {
      return o.value && o.value.children[0] || null;
    }
    function S() {
      const P = h();
      P && (P.addEventListener("mouseenter", b), P.addEventListener("mouseleave", k), P.addEventListener("click", k));
    }
    function m() {
      const P = h();
      P && (P.removeEventListener("mouseenter", b), P.removeEventListener("mouseleave", k), P.removeEventListener("click", k));
    }
    function b() {
      n.enable && n.content && u(() => {
        g.value = !0, _();
      });
    }
    function k() {
      g.value = !1, r();
    }
    function _() {
      a.value = 0, s.value = 0, fe(() => {
        const P = h();
        if (!P || !i.value)
          return;
        let L = n.direction;
        const I = Be.getLeft(P), B = Be.getTop(P);
        switch (L === "top" && B < window.innerHeight / 3 && (L = "bottom"), c.value = L, L) {
          case "left":
          case "right":
            s.value = B - i.value.offsetHeight / 2 + P.offsetHeight / 2;
            break;
          case "top":
          case "bottom":
            a.value = I - i.value.offsetWidth / 2 + P.offsetWidth / 2;
            break;
        }
        switch (L) {
          case "left":
            a.value = I - i.value.offsetWidth - n.offset;
            break;
          case "top":
            s.value = B - i.value.offsetHeight - n.offset;
            break;
          case "right":
            a.value = I + P.offsetWidth + n.offset;
            break;
          case "bottom":
            s.value = B + P.offsetHeight + n.offset;
            break;
        }
      });
    }
    return se(() => e.default, () => {
      g.value = !1, m(), fe(() => S());
    }), se(() => n.enable, (P) => {
      P || (g.value = !1);
    }), we(() => {
      fe(() => {
        S();
      });
    }), Re(() => {
      m(), g.value = !1;
    }), (P, L) => (x(), V("span", {
      ref_key: "container",
      ref: o,
      class: "code-layout-tooltip-ref"
    }, [
      U(P.$slots, "default"),
      (x(), te(yt, { to: t.teleport }, [
        g.value ? (x(), V("div", {
          key: 0,
          ref_key: "tooltip",
          ref: i,
          class: re("code-layout-tooltip " + c.value),
          style: Ge({
            left: `${a.value}px`,
            top: `${s.value}px`
          })
        }, Ce(t.content), 7)) : Z("", !0)
      ], 8, ["to"]))
    ], 512));
  }
});
const zn = {
  class: /* @__PURE__ */ re(["code-layout-actions"]),
  draggable: "false"
}, kn = ["onClick"], Te = /* @__PURE__ */ ce({
  __name: "CodeLayoutActionsRender",
  props: {
    actions: {
      type: Object,
      default: () => []
    }
  },
  setup(t) {
    return (n, e) => (x(), V("div", zn, [
      (x(!0), V(xe, null, Oe(t.actions, (o, i) => (x(), te(bt, {
        key: o.name ?? i,
        content: o.tooltip,
        direction: o.tooltipDirection ?? "bottom"
      }, {
        default: ee(() => [
          o.render ? (x(), te(ke, {
            key: 0,
            content: o.render
          }, null, 8, ["content"])) : (x(), V("button", {
            key: 1,
            draggable: "false",
            tabindex: "0",
            class: re([
              i === t.actions.length - 1 ? "last" : ""
            ]),
            onClick: o.onClick
          }, [
            ie(ke, {
              content: o.icon
            }, null, 8, ["content"]),
            ie(ke, {
              content: o.text
            }, null, 8, ["content"])
          ], 10, kn))
        ]),
        _: 2
      }, 1032, ["content", "direction"]))), 128))
    ]));
  }
});
const Xe = [], Bt = yn(100, () => {
  for (const t of Xe)
    t();
});
function Ct(t, n, e, o) {
  let i = 0, a = 0;
  function s() {
    t.value && (n && i !== t.value.offsetWidth && n(t.value.offsetWidth), e && a !== t.value.offsetHeight && e(t.value.offsetHeight), o && (i !== t.value.offsetWidth || a !== t.value.offsetHeight) && o(t.value.offsetWidth, t.value.offsetHeight), i = t.value.offsetWidth, a = t.value.offsetHeight);
  }
  return {
    startResizeChecker() {
      Bt.start(), Xe.push(s);
    },
    stopResizeChecker() {
      const c = Xe.indexOf(s);
      c >= 0 && Xe.splice(c, 1), Xe.length === 0 && Bt.stop();
    }
  };
}
const xn = /* @__PURE__ */ ce({
  __name: "CodeLayoutScrollbar",
  props: {
    /**
     * Scroll direction
     */
    scroll: {
      type: String,
      default: "both"
    },
    /**
     * Scroll bar size (pixel)
     */
    scrollBarSize: {
      type: Number,
      default: 8
    },
    /**
     * CSS class of inner container
     */
    containerClass: {
      type: String,
      default: ""
    }
  },
  setup(t, { expose: n }) {
    const e = t, o = E(), i = E(), a = E(), s = Ee({
      show: !1,
      size: 0,
      sizeRaw: 0,
      pos: 0
    }), c = Ee({
      show: !1,
      size: 0,
      sizeRaw: 0,
      pos: 0
    });
    let g = 0, u = 0, r = 0, h = 0;
    const S = new MutationObserver(() => k()), m = { attributes: !0, childList: !0 };
    function b() {
      if (o.value) {
        if (s.show) {
          const C = o.value.offsetWidth / o.value.scrollWidth;
          s.sizeRaw = C * o.value.offsetWidth, s.size = C * 100, s.pos = o.value.scrollLeft / (o.value.scrollWidth - o.value.offsetWidth) * (100 - s.size), C >= 1 && (s.show = !1);
        }
        if (c.show) {
          const C = o.value.offsetHeight / o.value.scrollHeight;
          c.sizeRaw = C * o.value.offsetHeight, c.size = C * 100, c.pos = o.value.scrollTop / (o.value.scrollHeight - o.value.offsetHeight) * (100 - c.size), C >= 1 && (c.show = !1);
        }
      }
    }
    function k(C = !1) {
      if (!o.value)
        return;
      let D = e.scroll === "horizontal" || e.scroll === "both", W = e.scroll === "vertical" || e.scroll === "both";
      const y = D && (g !== o.value.scrollWidth || r !== o.value.offsetWidth), J = W && (u !== o.value.scrollHeight || h !== o.value.offsetHeight);
      if (!C && !y && !J)
        return;
      const j = window.getComputedStyle(o.value);
      (j.overflow === "hidden" || j.overflowX === "hidden") && (D = !1), (j.overflow === "hidden" || j.overflowY === "hidden") && (W = !1), s.show = D, c.show = W, b(), r = o.value.offsetWidth, h = o.value.offsetHeight, g = o.value.scrollWidth, u = o.value.scrollHeight;
    }
    function _(C) {
      var D;
      e.scroll == "horizontal" && C.deltaMode == 0 && ((D = o.value) == null || D.scrollTo({
        left: o.value.scrollLeft + (C.deltaY > 0 ? 30 : -30)
      }));
    }
    let P = 0, L = 0, I = 0, B = 0;
    const T = it({
      onDown(C) {
        return P = C.offsetX, i.value && (L = Be.getLeft(i.value)), !0;
      },
      onMove(C, D, W) {
        o.value && i.value && (o.value.scrollLeft = (W.x - P - L) / (o.value.offsetWidth - s.sizeRaw) * (o.value.scrollWidth - o.value.offsetWidth), W.preventDefault(), W.stopPropagation());
      },
      onUp() {
      }
    }), O = it({
      onDown(C) {
        return I = C.offsetY, a.value && (B = Be.getTop(a.value)), !0;
      },
      onMove(C, D, W) {
        o.value && a.value && (o.value.scrollTop = (W.y - I - B) / (o.value.offsetHeight - c.sizeRaw) * (o.value.scrollHeight - o.value.offsetHeight), W.preventDefault(), W.stopPropagation());
      },
      onUp() {
      }
    }), {
      startResizeChecker: ne,
      stopResizeChecker: v
    } = Ct(
      o,
      () => k(),
      () => k()
    );
    return we(() => {
      fe(() => {
        setTimeout(() => k(!0), 200), k(!0), ne(), S.observe(o.value, m);
      });
    }), Re(() => {
      v(), S.disconnect();
    }), n({
      refreshScrollState() {
        k(!0);
      },
      getScrollContainer() {
        return o.value;
      },
      scrollTo(C, D) {
        var W;
        (W = o.value) == null || W.scrollTo(C, D);
      },
      scrollToTop() {
        var C;
        (C = o.value) == null || C.scrollTo(0, 0);
      },
      scrollToBottom() {
        var C;
        (C = o.value) == null || C.scrollTo(o.value.scrollWidth, o.value.scrollHeight);
      }
    }), (C, D) => (x(), V("div", {
      class: "code-layout-scrollbar",
      onWheel: _
    }, [
      q("div", {
        ref_key: "container",
        ref: o,
        class: re("scroll-content " + t.scroll + " " + t.containerClass),
        onScroll: b
      }, [
        U(C.$slots, "default")
      ], 34),
      s.show ? (x(), V("div", {
        key: 0,
        ref_key: "scrollBarRefX",
        ref: i,
        class: "scrollbar horizontal",
        style: Ge({ height: `${t.scrollBarSize}px` })
      }, [
        q("div", {
          class: "thumb",
          style: Ge({ left: `${s.pos}%`, width: `${s.size}%` }),
          onMousedown: D[0] || (D[0] = //@ts-ignore
          (...W) => l(T) && l(T)(...W))
        }, null, 36)
      ], 4)) : Z("", !0),
      c.show ? (x(), V("div", {
        key: 1,
        ref_key: "scrollBarRefY",
        ref: a,
        class: "scrollbar vertical",
        style: Ge({ width: `${t.scrollBarSize}px` })
      }, [
        q("div", {
          class: "thumb",
          style: Ge({ top: `${c.pos}%`, height: `${c.size}%` }),
          onMousedown: D[1] || (D[1] = //@ts-ignore
          (...W) => l(O) && l(O)(...W))
        }, null, 36)
      ], 4)) : Z("", !0)
    ], 32));
  }
});
const Bn = { class: "code-layout-split-tab-list-extra" }, Ln = /* @__PURE__ */ ce({
  __name: "SplitTab",
  props: {
    grid: {
      type: Object,
      default: null
    }
  },
  emits: [
    "tabItemContextMenu",
    "tabActive",
    "tabHover"
  ],
  setup(t, { emit: n }) {
    const e = t, o = n, { grid: i } = be(e), a = ae("splitLayoutContext"), s = E(), c = E(), g = E(!1);
    function u(b) {
      const k = i.value.activePanel;
      o("tabActive", b, k), i.value.setActiveChild(b);
    }
    const r = _e(
      s,
      i,
      g,
      () => {
      },
      (b) => a.dragDropNonPanel(b, !1, "tab-header"),
      (b) => (!b.accept || b.accept.includes(e.grid.parentGrid)) && (!b.preDropCheck || b.preDropCheck(b, e.grid.parentGrid))
    );
    function h(b) {
      const k = $e();
      k ? (b.preventDefault(), b.stopPropagation(), a.dragDropToPanel(e.grid, "center", k, !0)) : r.handleDropPreCheck(b) && a.dragDropNonPanel(b, !0, "tab-header", e.grid, "center"), r.resetDragOverState();
    }
    const S = _e(
      c,
      i,
      "four",
      () => {
      },
      (b) => a.dragDropNonPanel(b, !1, "tab-content"),
      (b) => (!b.accept || b.accept.includes(e.grid.parentGrid)) && (!b.preDropCheck || b.preDropCheck(b, e.grid.parentGrid)) && !(i.value.hasChild(b) && i.value.children.length === 1)
    );
    function m(b) {
      const k = $e();
      k ? (b.preventDefault(), b.stopPropagation(), a.dragDropToPanel(
        i.value,
        S.dragOverState.value,
        k
      )) : S.handleDropPreCheck(b) && a.dragDropNonPanel(
        b,
        !0,
        "tab-content",
        i.value,
        S.dragOverState.value
      ), S.resetDragOverState(), S.resetDragState();
    }
    return (b, k) => {
      var _, P;
      return x(), V("div", {
        class: re([
          "code-layout-split-tab",
          l(a).currentActiveGrid.value === l(i) ? "active" : ""
        ]),
        onClick: k[6] || (k[6] = (L) => l(a).activeGrid(l(i)))
      }, [
        l(i).children.length > 0 ? (x(), V("div", {
          key: 0,
          ref_key: "tabScroll",
          ref: s,
          class: re([
            "code-layout-split-tab-list",
            l(r).dragEnterState.value ? "drag-active" : ""
          ]),
          onDragover: k[0] || (k[0] = //@ts-ignore
          (...L) => l(r).handleDragOver && l(r).handleDragOver(...L)),
          onDragleave: k[1] || (k[1] = //@ts-ignore
          (...L) => l(r).handleDragLeave && l(r).handleDragLeave(...L)),
          onDragenter: k[2] || (k[2] = //@ts-ignore
          (...L) => l(r).handleDragEnter && l(r).handleDragEnter(...L)),
          onDrop: h
        }, [
          U(b.$slots, "tabHeaderRender", {}, () => [
            ie(xn, {
              scroll: "horizontal",
              scrollBarSize: 4,
              containerClass: "code-layout-split-tab-list-tabs"
            }, {
              default: ee(() => [
                (x(!0), V(xe, null, Oe(l(i).children, (L, I) => U(b.$slots, "tabItemRender", {
                  key: L.name,
                  panel: L,
                  index: I,
                  active: L === l(i).activePanel,
                  onTabClick: () => u(L),
                  onContextMenu: (B) => o("tabItemContextMenu", L, B)
                }, () => [
                  ie(wn, {
                    panel: L,
                    active: L === l(i).activePanel,
                    onClick: (B) => u(L),
                    onContextmenu: (B) => o("tabItemContextMenu", L, B),
                    onTabHover: (B, T) => o("tabHover", B, T)
                  }, null, 8, ["panel", "active", "onClick", "onContextmenu", "onTabHover"])
                ])), 128)),
                U(b.$slots, "tabHeaderEndRender", { grid: l(i) })
              ]),
              _: 3
            })
          ]),
          q("div", Bn, [
            U(b.$slots, "tabHeaderExtraRender", { grid: l(i) }),
            (_ = l(i).activePanel) != null && _.actions ? (x(), te(Te, {
              key: 0,
              actions: (P = l(i).activePanel) == null ? void 0 : P.actions
            }, null, 8, ["actions"])) : Z("", !0)
          ])
        ], 34)) : Z("", !0),
        q("div", {
          ref_key: "tabContent",
          ref: c,
          class: re([
            "code-layout-split-tab-content",
            l(i).children.length > 0 ? "" : "empty",
            l(S).dragPanelState.value ? "dragging" : "",
            l(S).dragEnterState.value ? "drag-active" : "",
            `drag-over-${l(S).dragOverState.value}`
          ]),
          onDragover: k[3] || (k[3] = //@ts-ignore
          (...L) => l(S).handleDragOver && l(S).handleDragOver(...L)),
          onDragleave: k[4] || (k[4] = //@ts-ignore
          (...L) => l(S).handleDragLeave && l(S).handleDragLeave(...L)),
          onDragenter: k[5] || (k[5] = //@ts-ignore
          (...L) => l(S).handleDragEnter && l(S).handleDragEnter(...L)),
          onDrop: m
        }, [
          l(i).activePanel ? U(b.$slots, "tabContentRender", {
            key: 0,
            panel: l(i).activePanel
          }) : U(b.$slots, "tabEmptyContentRender", {
            key: 1,
            grid: l(i)
          })
        ], 34)
      ], 2);
    };
  }
}), Gn = /* @__PURE__ */ ce({
  __name: "SplitLayout",
  props: {
    /**
     * Specify the type of the root grid, usually used to set different types in multiple components to restrict mutual dragging
     */
    rootGridType: {
      type: String,
      default: "centerArea"
    },
    /**
     * Whether to display Tab components. When it is `true`, it supports multiple sub panels in one grid, and the components should be rendered in the tabContentRender slot; When it is `false`, only grid segmentation is supported and panel and drag functions are not supported. You should render the content yourself in gridRender.
     */
    showTabHeader: {
      type: Boolean,
      default: !0
    },
    /**
     * Should save layout in window.beforeunload
     */
    saveBeforeUnload: {
      type: Boolean,
      default: !0
    },
    /**
     * Base layout config
     */
    layoutConfig: {
      type: Object,
      default: () => Qt
    },
    /**
     * The panel that was last clicked by the user. Can be used with v-model:lastActive.
     */
    lastActive: {
      type: Object,
      default: null
    }
  },
  emits: [
    "panelClose",
    "panelContextMenu",
    "panelActive",
    "panelDrop",
    "gridActive",
    "canLoadLayout",
    "canSaveLayout",
    "update:lastActive",
    "tabHover"
  ],
  setup(t, { expose: n, emit: e }) {
    const o = e, i = t, a = /* @__PURE__ */ new Map(), s = {
      panelInstances: a,
      removePanelInternal: L,
      childGridActiveChildChanged: (v) => k(v),
      closePanelInternal: (v) => b(v),
      layoutConfig: i.layoutConfig
    };
    se(() => i.layoutConfig, (v) => {
      s.layoutConfig = v;
    }, { deep: !0 });
    const c = E(new he(s));
    c.value.size = 100, c.value.noAutoShink = !1, c.value.direction = "horizontal";
    const g = E(null);
    we(() => {
      c.value.accept = [i.rootGridType], c.value.parentGrid = i.rootGridType, o("canLoadLayout", r), i.saveBeforeUnload && window.addEventListener("beforeunload", u);
    }), Re(() => {
      window.removeEventListener("beforeunload", u), u();
    }), se(() => i.rootGridType, (v) => {
      c.value.accept = [v], c.value.parentGrid = i.rootGridType;
    });
    function u() {
      o("canSaveLayout", r);
    }
    const r = {
      getGridTreeDebugText: () => {
        let v = "";
        function C(D, W = 0) {
          v += `
└`;
          for (let y = 0; y < W; y++)
            v += "─";
          v += `─${D.name} : ${D.size} ${D.direction}`;
          for (const y of D.childGrid)
            C(y, W + 1), y.parentGroup || (v += `
└───ERROR ▲────`);
          for (const y of D.children) {
            v += `
└`;
            for (let J = 0; J < W + 1; J++)
              v += "─";
            v += `┷─${y.name}`;
          }
        }
        return C(c.value), v;
      },
      getRootGrid: () => c.value,
      getPanelByName: (v) => a.get(v),
      getActiveGird: () => g.value || c.value,
      getActiveGrid: () => g.value || c.value,
      getGridByName: (v) => {
        function C(D, W) {
          for (const y of D.childGrid) {
            if (y.name === W)
              return y;
            const J = C(y, W);
            if (J)
              return J;
          }
        }
        return C(c.value, v);
      },
      activePanel(v) {
        var C;
        (C = a.get(v)) == null || C.activeSelf();
      },
      /**
       * Clear all panels and grids.
       * @param options Configuration options for clearing the layout
       * @param options.leaveEmptyGrid Whether to leave one empty grid after clearing. Defaults to false.
       */
      clearLayout(v = {}) {
        const { leaveEmptyGrid: C = !1 } = v;
        a.clear();
        function D(W) {
          W.children.splice(0);
          for (const y of W.childGrid)
            D(y);
          W.childGrid.splice(0), W.setActiveChild(null);
        }
        if (C) {
          const W = c.value.childGrid[0];
          if (W)
            D(W), Object.assign(W, {
              direction: c.value.direction,
              children: [],
              childGrid: [],
              size: 100,
              // Ensure size is 100 since it will be the only grid
              noAutoShink: !1
            }), c.value.children.splice(0), c.value.childGrid = [W], c.value.setActiveChild(null);
          else {
            const y = new he(s);
            Object.assign(y, {
              direction: c.value.direction,
              name: c.value.name + "0",
              children: [],
              childGrid: [],
              size: 100,
              noAutoShink: !1
            }), c.value.children.splice(0), c.value.childGrid = [y], c.value.setActiveChild(null);
          }
        } else
          D(c.value), c.value.children.splice(0), c.value.childGrid.splice(0), c.value.setActiveChild(null);
        fe(() => {
          c.value.notifyRelayout();
        });
      },
      loadLayout(v, C, D) {
        const W = (z) => {
          var d;
          if (z instanceof ye)
            return z;
          const H = C(z);
          return (d = D == null ? void 0 : D.defaultPanelConfig) != null && d.iconGenerator && (H.iconSmall && (H.iconSmall = D.defaultPanelConfig.iconGenerator(H.iconSmall.toString())), H.iconLarge && (H.iconLarge = D.defaultPanelConfig.iconGenerator(H.iconLarge.toString()))), H;
        }, y = [], J = /* @__PURE__ */ new Map();
        function j(z) {
          if (z.children) {
            for (const H of z.children)
              if (H.children)
                j(H);
              else if (!J.has(H.name)) {
                const d = W(H);
                y.push(d), J.set(H.name, d);
              }
          }
          if (z.childGrid)
            for (const H of z.childGrid)
              j(H);
        }
        if (!v && c.value) {
          for (const [z, H] of a)
            J.has(z) || (y.push(H), J.set(z, H));
          j(c.value);
        } else
          v && j(v);
        if (y.length === 0)
          return;
        y.forEach((z) => {
          z instanceof ye && z.parentGroup && z.parentGroup.removeChild(z);
        }), v && !this._defaultLayoutJson && (this._defaultLayoutJson = {
          layout: JSON.stringify(v),
          originalPanelNames: new Set(y.map((z) => z.name))
        }), this.clearLayout();
        const M = B(this.getRootGrid());
        switch (D == null ? void 0 : D.arrangement) {
          case "default": {
            if (this._defaultLayoutJson) {
              let z = function(p, w = "") {
                if (p.children)
                  for (const A of p.children)
                    A.children || G.set(A.name, w);
                p.childGrid && p.childGrid.forEach((A, F) => {
                  z(A, w ? `${w}.${F}` : `${F}`);
                });
              }, H = function(p, w, A = "") {
                if (w.loadFromJson(p), p.childGrid instanceof Array && p.childGrid.length > 0) {
                  for (let F = 0; F < p.childGrid.length; F++) {
                    const R = p.childGrid[F], N = new he(s);
                    H(R, N, A ? `${A}.${F}` : `${F}`), w.addChildGrid(N);
                  }
                  w.notifyRelayout();
                } else if (p.children instanceof Array)
                  for (const F of p.children) {
                    const R = J.get(F.name);
                    if (R) {
                      const N = w.addPanel(R);
                      N.init && N.init(!1), N.markAsSaved(), a.set(N.name, N);
                    }
                  }
              }, d = function(p) {
                let w = p.children.length, A = p;
                function F(R) {
                  R.children.length > w && (w = R.children.length, A = R);
                  for (const N of R.childGrid)
                    F(N);
                }
                for (const R of p.childGrid)
                  F(R);
                return A;
              };
              const $ = JSON.parse(this._defaultLayoutJson.layout), G = /* @__PURE__ */ new Map();
              z($), y.filter(
                (p) => this._defaultLayoutJson.originalPanelNames.has(p.name)
              );
              const f = y.filter(
                (p) => !this._defaultLayoutJson.originalPanelNames.has(p.name)
              );
              if (H($, M), f.length > 0) {
                const p = d(M);
                for (const w of f) {
                  const A = p.addPanel(w);
                  A.init && A.init(!1), A.markAsSaved(), a.set(A.name, A);
                }
              }
              M.notifyRelayout();
              return;
            }
            break;
          }
          case "columns": {
            O(M, y);
            break;
          }
          case "grid": {
            const z = y.length, H = Math.ceil(Math.sqrt(z)), d = H, $ = H;
            M.direction = "vertical", M.children = [], M.childGrid = [], y.forEach((p) => {
              p instanceof ye && p.parentGroup && p.parentGroup.removeChild(p);
            });
            const G = 100 / d;
            let f = 0;
            for (let p = 0; p < d && f < z; p++) {
              const w = new he(s);
              w.direction = "horizontal", w.name = `row-${p}`, w.size = G, M.addChildGrid(w);
              const A = 100 / $;
              for (let F = 0; F < $ && f < z; F++) {
                const R = new he(s);
                if (R.direction = "vertical", R.name = `cell-${p}-${F}`, R.size = A, w.addChildGrid(R), f < y.length) {
                  const N = y[f++], Y = N instanceof ye ? N : R.addPanel(N);
                  N instanceof ye ? (R.addChild(Y), Y.size = 100) : (Y.size = 100, T(Y));
                }
              }
            }
            fe(() => {
              M.notifyRelayout();
            });
            break;
          }
          case "rows": {
            ne(M, y);
            break;
          }
          default: {
            let z = function(H, d) {
              if (d.loadFromJson(H), H.childGrid instanceof Array && H.childGrid.length > 0) {
                for (const $ of H.childGrid) {
                  const G = new he(s);
                  z($, G), d.addChildGrid(G);
                }
                d.notifyRelayout();
              } else if (H.children instanceof Array) {
                for (const $ of H.children) {
                  const G = W($), f = d.addPanel(G);
                  f.init && f.init(!1), f.markAsSaved(), a.set(f.name, f);
                }
                d.children.length > 0 && !d.activePanel && d.setActiveChild(d.children[0]);
              }
            };
            z(v, M), M.notifyRelayout();
          }
        }
        fe(() => {
          M.notifyRelayout();
        });
      },
      saveLayout: () => {
        if (!c.value)
          return null;
        function v(C) {
          var D, W;
          for (const y of C.children)
            (D = y.markAsSaved) == null || D.call(y), (W = y.children) != null && W.length && v(y);
        }
        return v(c.value), c.value.toJson();
      },
      addPanelToActiveGrid(v, C) {
        const D = this.getActiveGrid();
        if (!D)
          return;
        const W = D.addPanel(v, void 0, void 0);
        return C && D.setActiveChild(W), W;
      },
      replacePanel(v, C, D) {
        function W(y) {
          for (let J = 0; J < y.children.length; J++) {
            const j = y.children[J];
            if (j.name === v) {
              y.children.splice(J, 1), a.delete(j.name);
              const M = y.addPanel(C, void 0, J);
              return D && y.setActiveChild(M), !0;
            }
          }
          for (const J of y.childGrid)
            if (W(J))
              return !0;
          return !1;
        }
        return W(this.getRootGrid());
      },
      updateData(v, C) {
        const D = a.get(v);
        if (!D) {
          console.warn(`[vue-code-layout] No panel found with name: ${v}`);
          return;
        }
        D instanceof ye ? D.updateData(C) : console.warn(`[vue-code-layout] Panel ${v} is not a SplitN panel instance`);
      }
    }, h = E(null), S = {
      currentActiveGrid: g,
      activeGrid(v) {
        const C = g.value;
        C != v && (g.value = v, S.currentActiveGrid.value = v, o("gridActive", C, v));
      },
      dragDropToPanel: P,
      dragDropNonPanel(v, C, D, W, y) {
        var J, j, M, z;
        return C ? ((j = (J = i.layoutConfig).onNonPanelDrop) == null || j.call(J, v, D, W, y), !1) : ((z = (M = i.layoutConfig).onNonPanelDrag) == null ? void 0 : z.call(M, v, D)) ?? !1;
      }
    };
    Nt();
    function m(v, C) {
      var y;
      const D = C.parentGroup, W = g.value;
      W != D && (S.currentActiveGrid.value = D, (y = D.onActive) == null || y.call(D, D), o("gridActive", W, D));
    }
    function b(v) {
      return new Promise((C, D) => {
        v.onClose ? o("panelClose", v, C, D) : C();
      }).then(() => {
        var D;
        const C = v.parentGroup;
        if (C) {
          const W = C.children.filter((y) => y !== v);
          if (a.delete(v.name), C.removePanel(v), g.value === C)
            if (W.length > 0) {
              const y = W[0];
              C.setActiveChild(y), o("panelActive", h.value, y), h.value = y, o("update:lastActive", y);
            } else {
              const y = C.parentGroup;
              y && (S.activeGrid(y), y.children.length > 0 && y.setActiveChild(y.children[0]));
            }
          fe(() => {
            C.notifyRelayout();
          });
        }
        (D = v.onClose) == null || D.call(v, v);
      }).catch(() => {
      });
    }
    function k(v) {
      S.currentActiveGrid.value === v && (o("panelActive", h.value, v.activePanel), h.value = v.activePanel, o("update:lastActive", v.activePanel));
    }
    se(() => i.lastActive, (v) => {
      v !== h.value && (h.value = v, v && r.activePanel(v.name));
    }, { immediate: !0 });
    let _ = 0;
    function P(v, C, D, W) {
      let y = null;
      if (v instanceof he ? y = v : v instanceof ye && (y = v.parentGroup), !y)
        return;
      const J = D.parentGroup;
      (J !== y || C !== "center" || !W) && D.removeSelf();
      const j = y.parentGroup;
      let M;
      if (C === "center" || W) {
        if (y.hasChild(D))
          W && (y.removeChild(D), y.addChild(D));
        else {
          let z = y.children.indexOf(v);
          z === -1 && (z = y.children.indexOf(y.activePanel)), y.addChild(
            D,
            z + (C === "right" || C === "down" || C === "center" ? 1 : 0)
          );
        }
        y.setActiveChild(D);
      } else if (j && (j.direction === "horizontal" && (C === "left" || C === "right") || j.direction === "vertical" && (C === "up" || C === "down"))) {
        const z = new he(j.context);
        Object.assign(z, {
          ...y,
          direction: y.direction,
          name: y.name + Math.floor(Math.random() * 10),
          children: [],
          childGrid: [],
          size: 0,
          noAutoShink: !1
        }), z.addChild(D), z.setActiveChild(D), j.addChildGrid(
          z,
          j.childGrid.indexOf(y) + (C === "down" || C === "right" ? 1 : 0)
        ), M = () => {
          j.relayoutAllWithNewPanel([z], y);
        };
      } else {
        const z = y.parentGroup, H = new he(y.context), d = new he(y.context);
        switch (Object.assign(d, {
          ...y,
          direction: y.direction === "vertical" ? "horizontal" : "vertical",
          //相对的方向
          name: y.name + _++,
          children: [],
          childGrid: [],
          size: 0,
          noAutoShink: !1
        }), Object.assign(H, {
          ...y,
          name: y.name + _++,
          direction: C === "left" || C === "right" ? "horizontal" : "vertical",
          children: [],
          childGrid: [],
          noAutoShink: !1
        }), y.size = 0, H.addChildGrid(y), d.addChild(D), C) {
          case "left":
          case "up":
            H.addChildGrid(d, 0);
            break;
          case "right":
          case "down":
            H.addChildGrid(d);
            break;
        }
        d.setActiveChild(D), y === c.value ? (c.value = H, c.value.noAutoShink = !1) : z ? z.replaceChildGrid(y, H) : (c.value = H, c.value.noAutoShink = !1, c.value.accept = [i.rootGridType], c.value.parentGrid = i.rootGridType), M = () => {
          H.childReplacedBy ? H.childReplacedBy.notifyRelayout() : H.notifyRelayout(), d.notifyRelayout();
        };
      }
      I(J, y), fe(() => {
        M == null || M();
      }), o("panelDrop", D, v, C);
    }
    function L(v) {
      const C = v.parentGroup;
      if (C) {
        if (a.delete(v.name), C.removeChild(v), C.children.length > 0) {
          C.reselectActiveChild(), fe(() => {
            C.notifyRelayout();
          });
          return;
        }
        if (C.noAutoShink || !C.parentGroup) {
          fe(() => {
            C.notifyRelayout();
          });
          return;
        }
        I(C);
      }
    }
    function I(v, C = void 0) {
      if (!v.parentGroup || v.noAutoShink || v.children.length > 0)
        return;
      const D = v.parentGroup, W = C && C.parentGroup === v.parentGroup;
      D.removeChildGrid(v), C && W ? C.size += v.size : D.childGrid.length > 0 && (D.childGrid[0].size += v.size), D.childGrid.length === 1 && D.moveChildGridToSelf(D.childGrid[0]), D.children.length === 0 && D.childGrid.length === 0 && I(D);
    }
    function B(v) {
      return v.direction = "vertical", v.children = [], v.childGrid = [], v.size = 100, v;
    }
    function T(v) {
      v.init && v.init(!1), v.markAsSaved(), v.data || (v.data = Ee({})), a.set(v.name, v);
    }
    function O(v, C) {
      var W;
      v.direction = "horizontal", v.children = [], v.childGrid = [];
      const D = 100 / C.length;
      C.forEach((y) => {
        y instanceof ye && y.parentGroup && y.parentGroup.removeChild(y);
      }), C.forEach((y, J) => {
        const j = new he(s);
        j.direction = "vertical", j.name = `column-${J}`, j.size = D, v.addChildGrid(j);
        const M = y instanceof ye ? y : j.addPanel(y);
        y instanceof ye ? (j.addChild(M), M.size = 100) : (M.size = 100, T(M));
      }), (W = v.childGrid[0]) != null && W.children[0] && v.childGrid[0].setActiveChild(v.childGrid[0].children[0]);
    }
    function ne(v, C) {
      var W;
      v.direction = "vertical", v.children = [], v.childGrid = [];
      const D = 100 / C.length;
      C.forEach((y) => {
        y instanceof ye && y.parentGroup && y.parentGroup.removeChild(y);
      }), C.forEach((y, J) => {
        const j = new he(s);
        j.direction = "horizontal", j.name = `row-${J}`, j.size = D, v.addChildGrid(j);
        const M = y instanceof ye ? y : j.addPanel(y);
        y instanceof ye ? (j.addChild(M), M.size = 100) : (M.size = 100, T(M));
      }), (W = v.childGrid[0]) != null && W.children[0] && v.childGrid[0].setActiveChild(v.childGrid[0].children[0]);
    }
    return ge("splitLayoutContext", S), n(r), (v, C) => (x(), te(cn, {
      grid: c.value
    }, {
      grid: ee(({ grid: D }) => [
        t.showTabHeader ? U(v.$slots, "tabRender", {
          key: 0,
          grid: D
        }, () => [
          ie(Ln, {
            grid: D,
            onTabItemContextMenu: C[0] || (C[0] = (W, y) => o("panelContextMenu", W, y)),
            onTabActive: m,
            onTabHover: C[1] || (C[1] = (W, y) => o("tabHover", W, y))
          }, {
            tabContentRender: ee((W) => [
              U(v.$slots, "tabContentRender", pe(Se(W)))
            ]),
            tabEmptyContentRender: ee((W) => [
              U(v.$slots, "tabEmptyContentRender", pe(Se(W)))
            ]),
            tabHeaderExtraRender: ee((W) => [
              U(v.$slots, "tabHeaderExtraRender", pe(Se(W)))
            ]),
            tabHeaderEndRender: ee((W) => [
              U(v.$slots, "tabHeaderEndRender", pe(Se(W)))
            ]),
            tabItemRender: ee((W) => [
              U(v.$slots, "tabItemRender", pe(Se(W)))
            ]),
            _: 2
          }, 1032, ["grid"])
        ]) : U(v.$slots, "gridRender", {
          key: 1,
          grid: D
        })
      ]),
      _: 3
    }, 8, ["grid"]));
  }
}), An = { class: "code-layout-title-bar" }, Mn = { class: "code-layout-activity" }, Dn = {
  class: /* @__PURE__ */ re(["code-layout-activity-bar", "left"])
}, $n = { class: "code-layout-inner-0" }, Rn = {
  class: /* @__PURE__ */ re(["code-layout-activity-bar", "right"])
}, In = { class: "code-layout-status" }, On = /* @__PURE__ */ ce({
  __name: "CodeLayoutBase",
  props: {
    config: {
      type: Object,
      required: !0
    }
  },
  setup(t, { expose: n }) {
    const e = E(), o = E(), i = t, a = E();
    function s() {
      if (e.value) {
        const r = e.value.getRootGrid(), h = i.config, S = i.config.primarySideBarPosition === "right", m = (L) => L.addGrid({
          name: S ? "primarySideBar" : "secondarySideBar",
          visible: S ? h.primarySideBar : h.secondarySideBar,
          size: S ? h.primarySideBarWidth : h.secondarySideBarWidth,
          minSize: S ? h.primarySideBarMinWidth : h.secondarySideBarMinWidth,
          canMinClose: !0,
          onMinCloseChanged(I, B) {
            S ? h.primarySideBar = B : h.secondarySideBar = B;
          }
        }), b = (L) => L.addGrid({
          name: S ? "secondarySideBar" : "primarySideBar",
          visible: S ? h.secondarySideBar : h.primarySideBar,
          size: S ? h.secondarySideBarWidth : h.primarySideBarWidth,
          minSize: S ? h.secondarySideBarMinWidth : h.primarySideBarMinWidth,
          canMinClose: !0,
          onMinCloseChanged(I, B) {
            S ? h.secondarySideBar = B : h.primarySideBar = B;
          }
        }), k = (L) => (a.value = L.addGrid({
          name: "bottomPanel",
          visible: h.bottomPanel,
          size: h.bottomPanelMaximize ? 100 : h.bottomPanelHeight < 100 ? h.bottomPanelHeight : 20,
          minSize: h.bottomPanelMinHeight,
          canMinClose: !0,
          onMinCloseChanged(I, B) {
            h.bottomPanel = B;
          }
        }), a.value), _ = (L) => L.addGrid({
          name: "centerArea",
          visible: !0,
          size: 0,
          minSize: 0
        }), P = (L, I, B) => {
          const T = L.addGrid({
            name: I,
            visible: !0,
            size: 0,
            minSize: 0
          }, B);
          return T.notifyRelayout(), T;
        };
        switch (e.value.clearLayout(), r.direction = "horizontal", i.config.bottomAlignment) {
          case "left": {
            const L = P(r, "group1", "vertical");
            {
              const I = P(L, "group2", "horizontal");
              b(I), _(I), k(L);
            }
            m(r);
            break;
          }
          case "right": {
            b(r);
            const L = P(r, "group1", "vertical");
            {
              const I = P(L, "group2", "horizontal");
              _(I), m(I), k(L);
            }
            break;
          }
          case "justify": {
            const L = P(r, "group1", "vertical");
            {
              const I = P(L, "group2", "horizontal");
              b(I), _(I), m(I), k(L);
            }
            break;
          }
          case "center": {
            b(r);
            const L = P(r, "group1", "vertical");
            _(L), k(L), m(r);
            break;
          }
          case "left-side": {
            b(r), k(r), _(r), m(r);
            break;
          }
          case "right-side": {
            b(r), _(r), k(r), m(r);
            break;
          }
        }
        r.notifyRelayout();
      }
    }
    let c = !1;
    se(() => i.config.bottomPanel, s), se(() => i.config.secondarySideBar, s), se(() => i.config.primarySideBar, s), se(() => i.config.bottomPanelMaximize, (r) => {
      if (c) {
        c = !1;
        return;
      }
      r ? g() : s();
    }), se(() => {
      var r;
      return (r = a.value) == null ? void 0 : r.size;
    }, (r) => {
      const h = i.config;
      r && r < 100 && h.bottomPanelMaximize && (c = !0, h.bottomPanelMaximize = !1);
    }), se(() => i.config.bottomAlignment, s), se(() => i.config.bottomPanelHeight, s), se(() => i.config.bottomPanelMinHeight, g), se(() => i.config.primarySideBarMinWidth, g), se(() => i.config.primarySideBarPosition, g), se(() => i.config.primarySideBarWidth, s), se(() => i.config.secondarySideBarMinWidth, g), se(() => i.config.secondarySideBarWidth, s);
    function g() {
      u(), s();
    }
    function u() {
      const r = i.config;
      if (e.value) {
        const h = e.value.getGridByName("bottomPanel"), S = e.value.getGridByName("primarySideBar"), m = e.value.getGridByName("secondarySideBar");
        h && (r.bottomPanel = h.visible, r.bottomPanelHeight = h.size), S && (r.primarySideBar = S.visible, r.primarySideBarWidth = S.size), m && (r.secondarySideBar = m.visible, r.secondarySideBarWidth = m.size);
      }
    }
    return n({
      getRef: () => o.value,
      saveGridLayoutDataToConfig: u
    }), (r, h) => (x(), V("div", {
      ref_key: "container",
      ref: o,
      class: "code-layout-root"
    }, [
      U(r.$slots, "titleBarTop"),
      Me(q("div", An, [
        q("div", null, [
          U(r.$slots, "titleBarIcon"),
          t.config.menuBar ? U(r.$slots, "titleBarMenu", { key: 0 }) : Z("", !0)
        ]),
        q("div", null, [
          U(r.$slots, "titleBarCenter")
        ]),
        q("div", null, [
          U(r.$slots, "titleBarRight")
        ])
      ], 512), [
        [De, t.config.titleBar]
      ]),
      U(r.$slots, "titleBarBottom"),
      q("div", Mn, [
        Me(q("div", {
          class: re(["code-layout-activity-bar", t.config.primarySideBarPosition])
        }, [
          U(r.$slots, "activityBar")
        ], 2), [
          [De, t.config.activityBar && t.config.primarySideBarPosition === "left" && t.config.activityBarPosition === "side"]
        ]),
        Me(q("div", Dn, [
          U(r.$slots, "activityBarSecondary")
        ], 512), [
          [De, t.config.secondarySideBarAsActivityBar && t.config.primarySideBarPosition === "right" && t.config.secondaryActivityBarPosition === "side"]
        ]),
        q("div", $n, [
          ie(Gn, {
            ref_key: "splitLayoutRef",
            ref: e,
            rootGridType: "rootGrid",
            showTabHeader: !1,
            onCanLoadLayout: s,
            onCanSaveLayout: u
          }, {
            gridRender: ee(({ grid: S }) => [
              U(r.$slots, S.name)
            ]),
            _: 3
          }, 512)
        ]),
        Me(q("div", {
          class: re(["code-layout-activity-bar", t.config.primarySideBarPosition])
        }, [
          U(r.$slots, "activityBar")
        ], 2), [
          [De, t.config.activityBar && t.config.primarySideBarPosition === "right" && t.config.activityBarPosition === "side"]
        ]),
        Me(q("div", Rn, [
          U(r.$slots, "activityBarSecondary")
        ], 512), [
          [De, t.config.secondarySideBarAsActivityBar && t.config.primarySideBarPosition === "left" && t.config.secondaryActivityBarPosition === "side"]
        ])
      ]),
      Me(q("div", In, [
        U(r.$slots, "statusBar")
      ], 512), [
        [De, t.config.statusBar]
      ])
    ], 512));
  }
});
let We = null;
function Tn() {
  return We !== null;
}
function Wn(t) {
  We && Et(), We = t;
}
function Lt(t) {
  t === We && (We = null);
}
function Et() {
  We && (We.closeMenu(), We = null);
}
const Pe = {
  defaultDirection: "br",
  defaultMinWidth: 100,
  defaultMaxWidth: 600,
  defaultZindex: 100,
  defaultZoom: 1,
  defaultAdjustPadding: {
    x: 0,
    y: 10
  }
};
function He(t, n) {
  let e = t.offsetTop;
  return t.offsetParent != null && t.offsetParent != n && (e -= t.offsetParent.scrollTop, e += He(t.offsetParent, n)), e;
}
function Ne(t, n) {
  let e = t.offsetLeft;
  return t.offsetParent != null && t.offsetParent != n && (e -= t.offsetParent.scrollLeft, e += Ne(t.offsetParent, n)), e;
}
function Hn(t, n, e, o) {
  return {
    x: Ne(t, o) + n,
    y: He(t, o) + e
  };
}
const ut = "mx-menu-default-container", Nn = "mx-menu-container-";
let En = 0;
function _t(t) {
  const { getContainer: n, zIndex: e } = t;
  if (n) {
    const i = typeof n == "function" ? n() : n;
    if (i) {
      let a = i.getAttribute("id");
      return a || (a = Nn + En++, i.setAttribute("id", a)), {
        eleId: a,
        container: i,
        isNew: !1
      };
    }
  }
  let o = document.getElementById(ut);
  return o || (o = document.createElement("div"), o.setAttribute("id", ut), o.setAttribute("class", "mx-menu-ghost-host fullscreen"), document.body.appendChild(o)), o.style.zIndex = (e == null ? void 0 : e.toString()) || Pe.defaultZindex.toString(), {
    eleId: ut,
    container: o,
    isNew: !0
  };
}
function _n(t) {
  return typeof t == "number" ? `${t}px` : t;
}
const Ae = ce({
  props: {
    /**
     * Can be VNode or (data: unknown) => VNode
     */
    vnode: {
      type: null
    },
    /**
     * If vnode is a callback, this data will be passed to the callback first parameter.
     * @default null
     */
    data: {
      type: null,
      default: null
    }
  },
  setup(t) {
    const { vnode: n, data: e } = be(t);
    return () => typeof n.value == "function" ? n.value(e.value) : n.value;
  }
}), Qe = (t, n) => {
  const e = t.__vccOpts || t;
  for (const [o, i] of n)
    e[o] = i;
  return e;
}, Vn = {}, jn = {
  class: "mx-checked-mark",
  "aria-hidden": "true",
  viewBox: "0 0 1024 1024"
}, Fn = /* @__PURE__ */ q("path", { d: "M129.3,428.6L52,512l345,372.5l575-620.8l-69.5-75L400.4,718.2L129.3,428.6z" }, null, -1), Un = [
  Fn
];
function qn(t, n) {
  return x(), V("svg", jn, Un);
}
const Jn = /* @__PURE__ */ Qe(Vn, [["render", qn]]), Yn = {}, Xn = {
  class: "mx-right-arrow",
  "aria-hidden": "true",
  viewBox: "0 0 1024 1024"
}, Kn = /* @__PURE__ */ q("path", { d: "M307.018 49.445c11.517 0 23.032 4.394 31.819 13.18L756.404 480.18c8.439 8.438 13.181 19.885 13.181 31.82s-4.741 23.38-13.181 31.82L338.838 961.376c-17.574 17.573-46.065 17.573-63.64-0.001-17.573-17.573-17.573-46.065 0.001-63.64L660.944 512 275.198 126.265c-17.574-17.573-17.574-46.066-0.001-63.64C283.985 53.839 295.501 49.445 307.018 49.445z" }, null, -1), Zn = [
  Kn
];
function Qn(t, n) {
  return x(), V("svg", Xn, Zn);
}
const Vt = /* @__PURE__ */ Qe(Yn, [["render", Qn]]), eo = { class: "mx-item-row" }, to = ["xlink:href"], no = {
  key: 1,
  class: "label"
}, oo = { class: "mx-item-row" }, io = { class: "mx-shortcut" }, wt = /* @__PURE__ */ ce({
  __name: "ContextMenuItem",
  props: {
    /**
     * Is this menu disabled? 
     */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * Is this menu hidden? 
     */
    hidden: {
      type: Boolean,
      default: !1
    },
    customRender: {
      type: Function,
      default: null
    },
    /**
     * Custom css class for submenu
     */
    customClass: {
      type: String,
      default: ""
    },
    clickHandler: {
      type: Function,
      default: null
    },
    /**
     * Menu label
     */
    label: {
      type: [String, Object, Function],
      default: ""
    },
    /**
     * Menu icon (for icon class)
     */
    icon: {
      type: [String, Object, Function],
      default: ""
    },
    /**
     * Custom icon library font class name.
     * 
     * Only for css font icon, If you use the svg icon, you do not need to use this.
     */
    iconFontClass: {
      type: String,
      default: "iconfont"
    },
    /**
     * Is this menu item checked?
     * 
     * The check mark are displayed on the left side of the icon, so it is not recommended to display the icon at the same time.
     */
    checked: {
      type: Boolean,
      default: !1
    },
    /**
     * Shortcut key text display on the right.
     * 
     * The shortcut keys here are only for display. You need to handle the key events by yourself.
     */
    shortcut: {
      type: String,
      default: ""
    },
    /**
     * Display icons use svg symbol (`<use xlink:href="#icon-symbol-name">`) ， only valid when icon attribute is empty.
     */
    svgIcon: {
      type: String,
      default: ""
    },
    /**
     * The user-defined attribute of the svg tag, which is valid when using `svgIcon`.
     */
    svgProps: {
      type: Object,
      default: null
    },
    /**
     * Should a fixed-width icon area be reserved for menu items without icon. (this item)
     * 
     * Default is true .
     * 
     * The width of icon area can be override with css var `--mx-menu-placeholder-width`.
     */
    preserveIconWidth: {
      type: Boolean,
      default: !0
    },
    /**
     * Show right arrow on this menu?
     */
    showRightArrow: {
      type: Boolean,
      default: !1
    },
    hasChildren: {
      type: Boolean,
      default: !1
    },
    /**
     * Should close menu when Click this menu item ?
     */
    clickClose: {
      type: Boolean,
      default: !0
    },
    /**
     * When there are subitems in this item, is it allowed to trigger its own click event? Default is false
     */
    clickableWhenHasChildren: {
      type: Boolean,
      default: !1
    },
    rawMenuItem: {
      type: Object,
      default: void 0
    }
  },
  emits: [
    "click",
    "subMenuOpen",
    "subMenuClose"
  ],
  setup(t, { expose: n, emit: e }) {
    const o = t, i = e, {
      clickHandler: a,
      clickClose: s,
      clickableWhenHasChildren: c,
      disabled: g,
      hidden: u,
      label: r,
      icon: h,
      iconFontClass: S,
      showRightArrow: m,
      shortcut: b,
      hasChildren: k
    } = be(o), _ = E(!1), P = E(!1), L = E(), I = ae("globalOptions"), B = ae("globalHasSlot"), T = ae("globalRenderSlot"), O = ae("globalCloseMenu"), ne = ae("menuContext"), v = {
      getSubMenuInstance: () => {
      },
      showSubMenu: () => _.value ? (ne.markActiveMenuItem(v, !0), !0) : k.value ? (D(), !0) : !1,
      hideSubMenu: () => {
        ne.closeOtherSubMenu();
      },
      isDisabledOrHidden: () => g.value || u.value,
      getElement: () => L.value,
      focus: () => P.value = !0,
      blur: () => P.value = !1,
      click: C
    };
    ge("menuItemInstance", v), we(() => {
      ne.isMenuItemDataCollectedFlag() ? fe(() => {
        let J = 0;
        const j = ne.getElement();
        if (j) {
          let M = 0;
          for (let z = 0; z < j.children.length; z++) {
            const H = j.children[z];
            if (H.getAttribute("data-type") === "ContextMenuItem") {
              if (H === L.value) {
                J = M;
                break;
              }
              M++;
            }
          }
        }
        ne.addChildMenuItem(v, J);
      }) : ne.addChildMenuItem(v);
    }), Re(() => {
      ne.removeChildMenuItem(v);
    });
    function C(J) {
      if (!g.value) {
        if (J) {
          const j = J.target;
          if (j.classList.contains("mx-context-no-clickable") || I.value.ignoreClickClassName && j.classList.contains(I.value.ignoreClickClassName))
            return;
          if (I.value.clickCloseClassName && j.classList.contains(I.value.clickCloseClassName)) {
            J.stopPropagation(), O(o.rawMenuItem);
            return;
          }
        }
        k.value ? c.value ? (typeof a.value == "function" && a.value(J), i("click", J)) : _.value || D() : (typeof a.value == "function" && a.value(J), i("click", J), s.value && O(o.rawMenuItem));
      }
    }
    function D(J) {
      P.value = !1, ne.checkCloseOtherSubMenuTimeOut() || ne.closeOtherSubMenu(), g.value || (ne.markActiveMenuItem(v), k.value && (J || ne.markThisOpenedByKeyBoard(), ne.addOpenedSubMenu(W), _.value = !0, fe(() => i("subMenuOpen", v))));
    }
    function W() {
      P.value = !1, _.value = !1, i("subMenuClose", v);
    }
    function y() {
      return {
        disabled: g.value,
        label: r.value,
        icon: h.value,
        iconFontClass: S.value,
        showRightArrow: m.value,
        clickClose: s.value,
        clickableWhenHasChildren: c.value,
        shortcut: b.value,
        theme: I.value.theme,
        isOpen: _,
        hasChildren: k,
        onClick: C,
        onMouseEnter: D,
        closeMenu: O
      };
    }
    return n(v), (J, j) => l(u) ? Z("", !0) : (x(), V("div", {
      key: 0,
      class: "mx-context-menu-item-wrapper",
      ref_key: "menuItemRef",
      ref: L,
      "data-type": "ContextMenuItem"
    }, [
      l(B)("itemRender") ? (x(), te(l(Ae), {
        key: 0,
        vnode: () => l(T)("itemRender", y())
      }, null, 8, ["vnode"])) : t.customRender ? (x(), te(l(Ae), {
        key: 1,
        vnode: t.customRender,
        data: y()
      }, null, 8, ["vnode", "data"])) : (x(), V("div", {
        key: 2,
        class: re([
          "mx-context-menu-item",
          l(g) ? "disabled" : "",
          P.value ? "keyboard-focus" : "",
          t.customClass ? " " + t.customClass : "",
          _.value ? "open" : ""
        ]),
        onClick: C,
        onMouseenter: D
      }, [
        U(J.$slots, "default", {}, () => [
          q("div", eo, [
            q("div", {
              class: re([
                "mx-icon-placeholder",
                t.preserveIconWidth ? "preserve-width" : ""
              ])
            }, [
              U(J.$slots, "icon", {}, () => [
                l(B)("itemIconRender") ? (x(), te(l(Ae), {
                  key: 0,
                  vnode: () => l(T)("itemIconRender", y())
                }, null, 8, ["vnode"])) : typeof t.svgIcon == "string" && t.svgIcon ? (x(), V("svg", nt({
                  key: 1,
                  class: "icon svg"
                }, t.svgProps), [
                  q("use", { "xlink:href": t.svgIcon }, null, 8, to)
                ], 16)) : typeof l(h) != "string" ? (x(), te(l(Ae), {
                  key: 2,
                  vnode: l(h),
                  data: l(h)
                }, null, 8, ["vnode", "data"])) : typeof l(h) == "string" && l(h) !== "" ? (x(), V("i", {
                  key: 3,
                  class: re(l(h) + " icon " + l(S) + " " + l(I).iconFontClass)
                }, null, 2)) : Z("", !0)
              ]),
              t.checked ? U(J.$slots, "check", { key: 0 }, () => [
                l(B)("itemCheckRender") ? (x(), te(l(Ae), {
                  key: 0,
                  vnode: () => l(T)("itemCheckRender", y())
                }, null, 8, ["vnode"])) : Z("", !0),
                ie(Jn)
              ]) : Z("", !0)
            ], 2),
            U(J.$slots, "label", {}, () => [
              l(B)("itemLabelRender") ? (x(), te(l(Ae), {
                key: 0,
                vnode: () => l(T)("itemLabelRender", y())
              }, null, 8, ["vnode"])) : typeof l(r) == "string" ? (x(), V("span", no, Ce(l(r)), 1)) : (x(), te(l(Ae), {
                key: 2,
                vnode: l(r),
                data: l(r)
              }, null, 8, ["vnode", "data"]))
            ])
          ]),
          q("div", oo, [
            l(b) ? U(J.$slots, "shortcut", { key: 0 }, () => [
              l(B)("itemShortcutRender") ? (x(), te(l(Ae), {
                key: 0,
                vnode: () => l(T)("itemShortcutRender", y())
              }, null, 8, ["vnode"])) : Z("", !0),
              q("span", io, Ce(l(b)), 1)
            ]) : Z("", !0),
            l(m) ? U(J.$slots, "rightArrow", { key: 1 }, () => [
              l(B)("itemRightArrowRender") ? (x(), te(l(Ae), {
                key: 0,
                vnode: () => l(T)("itemRightArrowRender", y())
              }, null, 8, ["vnode"])) : Z("", !0),
              ie(Vt)
            ]) : Z("", !0)
          ])
        ])
      ], 34)),
      l(I).menuTransitionProps ? (x(), te(Ot, pe(nt({ key: 3 }, l(I).menuTransitionProps)), {
        default: ee(() => [
          _.value ? U(J.$slots, "submenu", { key: 0 }) : Z("", !0)
        ]),
        _: 3
      }, 16)) : _.value ? U(J.$slots, "submenu", { key: 4 }) : Z("", !0)
    ], 512));
  }
}), ao = ce({
  name: "ContextMenuSperator",
  components: {
    VNodeRender: Ae
  },
  setup() {
    const t = ae("globalHasSlot"), n = ae("globalRenderSlot");
    return {
      globalHasSlot: t,
      globalRenderSlot: n
    };
  }
}), ro = {
  key: 1,
  class: "mx-context-menu-item-sperator mx-context-no-clickable"
};
function lo(t, n, e, o, i, a) {
  const s = Ve("VNodeRender");
  return t.globalHasSlot("separatorRender") ? (x(), te(s, {
    key: 0,
    vnode: () => t.globalRenderSlot("separatorRender", {})
  }, null, 8, ["vnode"])) : (x(), V("div", ro));
}
const vt = /* @__PURE__ */ Qe(ao, [["render", lo]]), so = ce({
  name: "ContextSubMenu",
  components: {
    ContextMenuItem: wt,
    ContextMenuSeparator: vt,
    ContextMenuIconRight: Vt
  },
  props: {
    /**
     * Items from options
     */
    items: {
      type: Object,
      default: null
    },
    /**
     * Max width for this submenu
     */
    maxWidth: {
      type: [String, Number],
      default: 0
    },
    /**
     * Min width for this submenu
     */
    minWidth: {
      type: [String, Number],
      default: 0
    },
    /**
     * Specifies should submenu adjust it position
     * when the menu exceeds the screen. The default is true
     */
    adjustPosition: {
      type: Boolean,
      default: !0
    },
    /**
     * Menu direction
     */
    direction: {
      type: String,
      default: "br"
    }
  },
  setup(t) {
    const n = ae("menuContext"), e = ae("globalOptions"), o = ae("globalHasSlot"), i = ae("globalRenderSlot"), { zIndex: a, getParentWidth: s, getParentHeight: c, getZoom: g } = n, { adjustPosition: u } = be(t), r = E(), h = E(), S = E(), m = E(), b = [], k = ae("globalSetCurrentSubMenu"), _ = [];
    let P = null, L = 0;
    function I() {
      P && P.blur();
    }
    function B(f, p) {
      if (f) {
        for (let w = p !== void 0 ? p : 0; w < _.length; w++)
          if (!_[w].isDisabledOrHidden()) {
            T(w);
            break;
          }
      } else
        for (let w = p !== void 0 ? p : _.length - 1; w >= 0; w--)
          if (!_[w].isDisabledOrHidden()) {
            T(w);
            break;
          }
    }
    function T(f) {
      if (P && I(), f !== void 0 && (P = _[Math.max(0, Math.min(f, _.length - 1))]), !!P && (P.focus(), d.value)) {
        const p = P.getElement();
        p && (J.value = Math.min(Math.max(-j.value, -p.offsetTop - p.offsetHeight + G.value), 0));
      }
    }
    function O() {
      k(ne);
    }
    const ne = {
      isTopLevel: () => n.getParentContext() === null,
      closeSelfAndActiveParent: () => {
        const f = D.getParentContext();
        if (f) {
          f.closeOtherSubMenu();
          const p = f.getSubMenuInstanceContext();
          if (p)
            return p.focusCurrentItem(), !0;
        }
        return !1;
      },
      closeCurrentSubMenu: () => {
        var f;
        return (f = D.getParentContext()) == null ? void 0 : f.closeOtherSubMenu();
      },
      moveCurrentItemFirst: () => B(!0),
      moveCurrentItemLast: () => B(!1),
      moveCurrentItemDown: () => B(!0, P ? _.indexOf(P) + 1 : 0),
      moveCurrentItemUp: () => B(!1, P ? _.indexOf(P) - 1 : 0),
      focusCurrentItem: () => T(),
      openCurrentItemSubMenu: () => P ? P == null ? void 0 : P.showSubMenu() : !1,
      triggerCurrentItemClick: (f) => P == null ? void 0 : P.click(f)
    };
    let v = !1, C = !1;
    const D = {
      zIndex: a + 1,
      container: n.container,
      adjustPadding: e.value.adjustPadding || Pe.defaultAdjustPadding,
      getParentWidth: () => {
        var f;
        return ((f = h.value) == null ? void 0 : f.offsetWidth) || 0;
      },
      getParentHeight: () => {
        var f;
        return ((f = h.value) == null ? void 0 : f.offsetHeight) || 0;
      },
      getParentX: () => $.value.x,
      getParentY: () => $.value.y,
      getParentAbsX: () => h.value ? Ne(h.value, n.container) : 0,
      getParentAbsY: () => h.value ? He(h.value, n.container) : 0,
      getPositon: () => [0, 0],
      getZoom: () => e.value.zoom || Pe.defaultZoom,
      addOpenedSubMenu(f) {
        b.push(f);
      },
      closeOtherSubMenu() {
        b.forEach((f) => f()), b.splice(0, b.length), k(ne);
      },
      checkCloseOtherSubMenuTimeOut() {
        return L ? (clearTimeout(L), L = 0, !0) : !1;
      },
      closeOtherSubMenuWithTimeOut() {
        L = setTimeout(() => {
          L = 0, this.closeOtherSubMenu();
        }, 200);
      },
      addChildMenuItem: (f, p) => {
        p === void 0 ? _.push(f) : _.splice(p, 0, f);
      },
      removeChildMenuItem: (f) => {
        _.splice(_.indexOf(f), 1), f.getSubMenuInstance = () => {
        };
      },
      markActiveMenuItem: (f, p = !1) => {
        I(), P = f, p && T();
      },
      markThisOpenedByKeyBoard: () => {
        v = !0;
      },
      isOpenedByKeyBoardFlag: () => v ? (v = !1, !0) : !1,
      isMenuItemDataCollectedFlag: () => C,
      getElement: () => h.value || null,
      getParentContext: () => n,
      getSubMenuInstanceContext: () => ne
    };
    ge("menuContext", D);
    const W = {
      getChildItem: (f) => _[f],
      getMenuDimensions: () => r.value ? {
        width: r.value.offsetWidth,
        height: r.value.offsetHeight
      } : { width: 0, height: 0 },
      getSubmenuRoot: () => r.value,
      getMenu: () => h.value,
      getScrollValue: () => J.value,
      setScrollValue: (f) => J.value = f,
      getScrollHeight: () => j.value,
      getMaxHeight: () => G.value,
      getPosition: () => $.value,
      setPosition: (f, p) => {
        $.value.x = f, $.value.y = p;
      }
    }, y = ae("menuItemInstance", void 0);
    y && (y.getSubMenuInstance = () => W);
    const J = E(0), j = E(0);
    function M(f) {
      f ? J.value = Math.min(Math.max(J.value - 50, -j.value), 0) : J.value = Math.min(J.value + 50, 0);
    }
    function z(f) {
      f.preventDefault(), f.stopPropagation(), M(f.deltaY > 0);
    }
    function H(f) {
      e.value.mouseScroll && (f.preventDefault(), f.stopPropagation(), M(f.deltaY > 0));
    }
    const d = E(!1), $ = E({ x: 0, y: 0 }), G = E(0);
    return we(() => {
      const f = n.getPositon();
      $.value = {
        x: (f[0] ?? e.value.xOffset ?? 0) / g(),
        y: (f[1] ?? e.value.yOffset ?? 0) / g()
      }, k(ne), fe(() => {
        var p, w;
        const A = h.value;
        if (A && S.value) {
          const { container: F } = n, R = (s == null ? void 0 : s()) ?? 0, N = (c == null ? void 0 : c()) ?? 0, Y = typeof n.adjustPadding == "number" ? n.adjustPadding : ((p = n.adjustPadding) == null ? void 0 : p.x) ?? 0, Q = typeof n.adjustPadding == "number" ? n.adjustPadding : ((w = n.adjustPadding) == null ? void 0 : w.y) ?? 0, X = N > 0 ? Q : 0, oe = document.documentElement.scrollHeight / g(), ue = document.documentElement.scrollWidth / g(), ve = Math.min(ue, F.offsetWidth), me = Math.min(oe, F.offsetHeight);
          let Le = Ne(A, F), Ie = He(A, F);
          t.direction.includes("l") ? $.value.x -= A.offsetWidth + Y : t.direction.includes("r") ? $.value.x += R + Y : ($.value.x += R / 2, $.value.x -= (A.offsetWidth + Y) / 2), t.direction.includes("t") ? $.value.y -= (A.offsetHeight + Q * 2) / g() : t.direction.includes("b") ? $.value.y -= Q / g() : ($.value.y += N / 2 / g(), $.value.y -= (A.offsetHeight + Q) / 2 / g()), u.value && fe(() => {
            Le = Ne(A, F), Ie = He(A, F);
            const Ft = Le + A.offsetWidth - ve, zt = Ie + A.offsetHeight + X * 2 - me;
            if (d.value = zt > 0, j.value = A.offsetHeight - me + X * 2, Ft > 0) {
              const Ue = R + A.offsetWidth - Y, qe = Le;
              Ue > qe ? $.value.x -= qe : $.value.x -= Ue;
            }
            if (d.value) {
              const Ue = zt, qe = Ie;
              Ue > qe ? $.value.y -= qe - X : $.value.y -= Ue - X, G.value = me - X * 2;
            } else
              G.value = 0;
          });
        }
        A == null || A.focus({
          preventScroll: !0
        }), n.isOpenedByKeyBoardFlag() && B(!0), C = !0;
      });
    }), Re(() => {
      y && (y.getSubMenuInstance = () => {
      });
    }), {
      submenuRoot: r,
      menu: h,
      scroll: S,
      options: e,
      zIndex: a,
      constOptions: Pe,
      scrollValue: J,
      upScrollButton: m,
      overflow: d,
      position: $,
      scrollHeight: j,
      maxHeight: G,
      ...W,
      globalHasSlot: o,
      globalRenderSlot: i,
      onScroll: M,
      onSubMenuBodyClick: O,
      onMouseWhell: H,
      onMouseWhellMx: z,
      solveNumberOrStringSize: _n
    };
  }
}), co = {
  key: 0,
  class: "mx-context-menu-updown placeholder"
}, uo = {
  key: 1,
  class: "mx-context-menu-updown placeholder"
}, fo = {
  class: "mx-context-menu-scroll",
  ref: "scroll"
};
function ho(t, n, e, o, i, a) {
  const s = Ve("ContextMenuSeparator"), c = Ve("ContextSubMenu", !0), g = Ve("ContextMenuItem"), u = Ve("ContextMenuIconRight");
  return x(), V("div", {
    ref: "submenuRoot",
    class: re([
      "mx-context-menu",
      t.options.customClass ? t.options.customClass : "",
      t.options.theme ?? ""
    ]),
    style: Ge({
      maxWidth: t.maxWidth ? t.solveNumberOrStringSize(t.maxWidth) : `${t.constOptions.defaultMaxWidth}px`,
      minWidth: t.minWidth ? t.solveNumberOrStringSize(t.minWidth) : `${t.constOptions.defaultMinWidth}px`,
      maxHeight: t.overflow && t.maxHeight > 0 ? `${t.maxHeight}px` : void 0,
      zIndex: t.zIndex,
      left: `${t.position.x}px`,
      top: `${t.position.y}px`
    }),
    "data-type": "ContextSubMenu",
    onClick: n[4] || (n[4] = (...r) => t.onSubMenuBodyClick && t.onSubMenuBodyClick(...r)),
    onWheel: n[5] || (n[5] = (...r) => t.onMouseWhell && t.onMouseWhell(...r))
  }, [
    q("div", {
      class: re(["mx-context-menu-items"]),
      ref: "menu",
      style: Ge({
        top: `${t.scrollValue}px`
      })
    }, [
      U(t.$slots, "default", {}, () => [
        t.overflow && t.options.updownButtonSpaceholder ? (x(), V("div", co)) : Z("", !0),
        (x(!0), V(xe, null, Oe(t.items, (r, h) => (x(), V(xe, { key: h }, [
          r.hidden !== !0 && r.divided === "up" ? (x(), te(s, { key: 0 })) : Z("", !0),
          r.hidden !== !0 && r.divided === "self" ? (x(), te(s, { key: 1 })) : (x(), te(g, {
            key: 2,
            clickHandler: r.onClick ? (S) => r.onClick(S) : void 0,
            disabled: typeof r.disabled == "object" ? r.disabled.value : r.disabled,
            hidden: typeof r.hidden == "object" ? r.hidden.value : r.hidden,
            icon: r.icon,
            iconFontClass: r.iconFontClass,
            svgIcon: r.svgIcon,
            svgProps: r.svgProps,
            label: r.label,
            customRender: r.customRender,
            customClass: r.customClass,
            checked: typeof r.checked == "object" ? r.checked.value : r.checked,
            shortcut: r.shortcut,
            clickClose: r.clickClose,
            clickableWhenHasChildren: r.clickableWhenHasChildren,
            preserveIconWidth: r.preserveIconWidth !== void 0 ? r.preserveIconWidth : t.options.preserveIconWidth,
            showRightArrow: r.children && r.children.length > 0,
            hasChildren: r.children && r.children.length > 0,
            rawMenuItem: r,
            onSubMenuOpen: (S) => {
              var m;
              return (m = r.onSubMenuOpen) == null ? void 0 : m.call(r, S);
            },
            onSubMenuClose: (S) => {
              var m;
              return (m = r.onSubMenuClose) == null ? void 0 : m.call(r, S);
            }
          }, Xt({ _: 2 }, [
            r.children && r.children.length > 0 ? {
              name: "submenu",
              fn: ee(() => [
                ie(c, {
                  items: r.children,
                  maxWidth: r.maxWidth,
                  minWidth: r.minWidth,
                  adjustPosition: r.adjustSubMenuPosition !== void 0 ? r.adjustSubMenuPosition : t.options.adjustPosition,
                  direction: r.direction !== void 0 ? r.direction : t.options.direction
                }, null, 8, ["items", "maxWidth", "minWidth", "adjustPosition", "direction"])
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["clickHandler", "disabled", "hidden", "icon", "iconFontClass", "svgIcon", "svgProps", "label", "customRender", "customClass", "checked", "shortcut", "clickClose", "clickableWhenHasChildren", "preserveIconWidth", "showRightArrow", "hasChildren", "rawMenuItem", "onSubMenuOpen", "onSubMenuClose"])),
          r.hidden !== !0 && (r.divided === "down" || r.divided === !0) ? (x(), te(s, { key: 3 })) : Z("", !0)
        ], 64))), 128)),
        t.overflow && t.options.updownButtonSpaceholder ? (x(), V("div", uo)) : Z("", !0)
      ])
    ], 4),
    q("div", fo, [
      Me(q("div", {
        ref: "upScrollButton",
        class: re("mx-context-menu-updown mx-context-no-clickable up" + (t.overflow && t.scrollValue < 0 ? "" : " disabled")),
        onClick: n[0] || (n[0] = (r) => t.onScroll(!1)),
        onWheel: n[1] || (n[1] = (...r) => t.onMouseWhellMx && t.onMouseWhellMx(...r))
      }, [
        ie(u)
      ], 34), [
        [De, t.overflow]
      ]),
      Me(q("div", {
        class: re("mx-context-menu-updown mx-context-no-clickable down" + (t.overflow && t.scrollValue > -t.scrollHeight ? "" : " disabled")),
        onClick: n[2] || (n[2] = (r) => t.onScroll(!0)),
        onWheel: n[3] || (n[3] = (...r) => t.onMouseWhellMx && t.onMouseWhellMx(...r))
      }, [
        ie(u)
      ], 34), [
        [De, t.overflow]
      ])
    ], 512)
  ], 38);
}
const at = /* @__PURE__ */ Qe(so, [["render", ho]]), vo = { class: "mx-menu-ghost-host" }, jt = /* @__PURE__ */ ce({
  __name: "ContextSubMenuWrapper",
  props: {
    /**
     * Menu options
     */
    options: {
      type: Object,
      default: null
    },
    /**
     * Show menu?
     */
    show: {
      type: Object,
      default: null
    },
    /**
     * Current container, For calculation only
     */
    container: {
      type: Object,
      default: null
    },
    /**
     * Make sure is user set the custom container.
     */
    isFullScreenContainer: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close", "closeAnimFinished"],
  setup(t, { expose: n, emit: e }) {
    const o = t, i = e, a = It(), s = E(), {
      options: c,
      show: g,
      container: u
    } = be(o);
    we(() => {
      g.value && S();
    }), Re(() => {
      _();
    }), se(g, (O) => {
      O ? S() : (Lt(r), _());
    });
    const r = {
      closeMenu: m,
      isClosed: b,
      getMenuRef: () => s.value,
      getMenuDimensions: () => {
        var O;
        return ((O = s.value) == null ? void 0 : O.getMenuDimensions()) ?? { width: 0, height: 0 };
      }
    };
    let h = !1;
    function S() {
      k(), Wn(r);
    }
    function m(O) {
      h = !0, i("close", O), c.value.menuTransitionProps || i("closeAnimFinished"), Lt(r);
    }
    function b() {
      return h;
    }
    function k() {
      setTimeout(() => {
        document.addEventListener("click", B, !0), document.addEventListener("contextmenu", B, !0), document.addEventListener("scroll", I, !0), !o.isFullScreenContainer && u.value && u.value.addEventListener("scroll", I, !0), c.value.keyboardControl !== !1 && document.addEventListener("keydown", L);
      }, 50);
    }
    function _() {
      document.removeEventListener("contextmenu", B, !0), document.removeEventListener("click", B, !0), document.removeEventListener("scroll", I, !0), !o.isFullScreenContainer && u.value && u.value.removeEventListener("scroll", I, !0), c.value.keyboardControl !== !1 && document.removeEventListener("keydown", L);
    }
    const P = E();
    ge("globalSetCurrentSubMenu", (O) => P.value = O);
    function L(O) {
      var ne, v, C, D, W, y, J, j, M, z, H, d, $;
      let G = !0;
      switch (O.key) {
        case "Escape": {
          ((ne = P.value) == null ? void 0 : ne.isTopLevel()) === !1 ? (v = P.value) == null || v.closeCurrentSubMenu() : m();
          break;
        }
        case "ArrowDown":
          (C = P.value) == null || C.moveCurrentItemDown();
          break;
        case "ArrowUp":
          (D = P.value) == null || D.moveCurrentItemUp();
          break;
        case "Home":
          (W = P.value) == null || W.moveCurrentItemFirst();
          break;
        case "End":
          (y = P.value) == null || y.moveCurrentItemLast();
          break;
        case "ArrowLeft": {
          (J = P.value) != null && J.closeSelfAndActiveParent() || (M = (j = c.value).onKeyFocusMoveLeft) == null || M.call(j);
          break;
        }
        case "ArrowRight":
          (z = P.value) != null && z.openCurrentItemSubMenu() || (d = (H = c.value).onKeyFocusMoveRight) == null || d.call(H);
          break;
        case "Enter":
          ($ = P.value) == null || $.triggerCurrentItemClick(O);
          break;
        default:
          G = !1;
          break;
      }
      G && P.value && (O.stopPropagation(), O.preventDefault());
    }
    function I() {
      c.value.closeWhenScroll !== !1 && m();
    }
    function B(O) {
      T(O.target, O);
    }
    function T(O, ne) {
      for (var v, C; O; ) {
        if (O.classList && O.classList.contains("mx-menu-host"))
          return;
        O = O.parentNode;
      }
      c.value.clickCloseOnOutside !== !1 ? (_(), m()) : (C = (v = c.value).onClickOnOutside) == null || C.call(v, ne);
    }
    return ge("globalOptions", c), ge("globalCloseMenu", m), ge("globalIsFullScreenContainer", o.isFullScreenContainer), ge("globalHasSlot", (O) => a[O] !== void 0), ge("globalRenderSlot", (O, ne) => U(a, O, { ...ne }, () => [le("span", "Render slot failed")], !1)), ge("menuContext", {
      zIndex: c.value.zIndex || Pe.defaultZindex,
      container: u.value,
      adjustPadding: { x: 0, y: 0 },
      getParentAbsY: () => c.value.x,
      getParentAbsX: () => c.value.y,
      getZoom: () => c.value.zoom || Pe.defaultZoom,
      getParentX: () => 0,
      getParentY: () => 0,
      getParentWidth: () => 0,
      getParentHeight: () => 0,
      getPositon: () => [c.value.x, c.value.y],
      closeOtherSubMenuWithTimeOut: () => {
      },
      checkCloseOtherSubMenuTimeOut: () => !1,
      addOpenedSubMenu: () => {
      },
      closeOtherSubMenu: () => {
      },
      getParentContext: () => null,
      getSubMenuInstanceContext: () => null,
      getElement: () => null,
      addChildMenuItem: () => {
      },
      removeChildMenuItem: () => {
      },
      markActiveMenuItem: () => {
      },
      markThisOpenedByKeyBoard: () => {
      },
      isOpenedByKeyBoardFlag: () => !1,
      isMenuItemDataCollectedFlag: () => !1
    }), n(r), (O, ne) => (x(), V("div", vo, [
      l(c).menuTransitionProps ? (x(), te(Ot, nt({
        key: 0,
        appear: ""
      }, l(c).menuTransitionProps, {
        onAfterLeave: ne[0] || (ne[0] = (v) => i("closeAnimFinished"))
      }), {
        default: ee(() => [
          l(g) ? (x(), te(at, {
            key: 0,
            ref_key: "submenuInstance",
            ref: s,
            class: "mx-menu-host",
            items: l(c).items,
            adjustPosition: l(c).adjustPosition,
            maxWidth: l(c).maxWidth || l(Pe).defaultMaxWidth,
            minWidth: l(c).minWidth || l(Pe).defaultMinWidth,
            direction: l(c).direction || l(Pe).defaultDirection
          }, {
            default: ee(() => [
              U(O.$slots, "default")
            ]),
            _: 3
          }, 8, ["items", "adjustPosition", "maxWidth", "minWidth", "direction"])) : Z("", !0)
        ]),
        _: 3
      }, 16)) : l(g) ? (x(), te(at, {
        key: 1,
        ref_key: "submenuInstance",
        ref: s,
        class: "mx-menu-host",
        items: l(c).items,
        adjustPosition: l(c).adjustPosition,
        maxWidth: l(c).maxWidth || l(Pe).defaultMaxWidth,
        minWidth: l(c).minWidth || l(Pe).defaultMinWidth,
        direction: l(c).direction || l(Pe).defaultDirection
      }, {
        default: ee(() => [
          U(O.$slots, "default")
        ]),
        _: 3
      }, 8, ["items", "adjustPosition", "maxWidth", "minWidth", "direction"])) : Z("", !0)
    ]));
  }
}), go = ce({
  name: "ContextMenu",
  emits: ["update:show", "close"],
  props: {
    /**
     * Menu options
     */
    options: {
      type: Object,
      default: null
    },
    /**
     * Show menu?
     */
    show: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, n) {
    const {
      options: e,
      show: o
    } = be(t), i = E(null);
    return n.expose({
      closeMenu: () => n.emit("update:show", !1),
      isClosed: () => !o.value,
      getMenuRef: () => {
        var a;
        return (a = i.value) == null ? void 0 : a.getMenuRef();
      },
      getMenuDimensions: () => {
        var a;
        return ((a = i.value) == null ? void 0 : a.getMenuDimensions()) ?? { width: 0, height: 0 };
      }
    }), () => {
      const { isNew: a, container: s, eleId: c } = _t(e.value);
      return [
        le(
          yt,
          { to: `#${c}` },
          [
            le(jt, {
              ref: i,
              options: e,
              show: o,
              container: s,
              isFullScreenContainer: !a,
              onClose: (g) => {
                var u, r;
                n.emit("update:show", !1), n.emit("close"), (r = (u = e.value).onClose) == null || r.call(u, g);
              }
            }, n.slots)
          ]
        )
      ];
    };
  }
}), mo = ce({
  name: "ContextMenuGroup",
  props: {
    /**
    * Is this menu disabled? 
    */
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
    * Is this menu hidden? 
    */
    hidden: {
      type: Boolean,
      default: !1
    },
    /**
     * Is this menu disabled? 
     */
    clickHandler: {
      type: Function,
      default: null
    },
    /**
     * Menu label
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Menu icon (for icon class)
     */
    icon: {
      type: String,
      default: ""
    },
    /**
     * Custom icon library font class name.
     * 
     * Only for css font icon, If you use the svg icon, you do not need to use this.
     */
    iconFontClass: {
      type: String,
      default: "iconfont"
    },
    /**
     * Is this menu item checked?
     * 
     * The check mark are displayed on the left side of the icon, so it is not recommended to display the icon at the same time.
     */
    checked: {
      type: Boolean,
      default: !1
    },
    /**
     * Shortcut key text display on the right.
     * 
     * The shortcut keys here are only for display. You need to handle the key events by yourself.
     */
    shortcut: {
      type: String,
      default: ""
    },
    /**
     * Display icons use svg symbol (`<use xlink:href="#icon-symbol-name">`) ， only valid when icon attribute is empty.
     */
    svgIcon: {
      type: String,
      default: ""
    },
    /**
     * The user-defined attribute of the svg tag, which is valid when using `svgIcon`.
     */
    svgProps: {
      type: Object,
      default: null
    },
    /**
     * Should a fixed-width icon area be reserved for menu items without icon. (this item)
     * 
     * Default is true .
     * 
     * The width of icon area can be override with css var `--mx-menu-placeholder-width`.
     */
    preserveIconWidth: {
      type: Boolean,
      default: !0
    },
    /**
     * Show right arrow on this menu?
     */
    showRightArrow: {
      type: Boolean,
      default: !1
    },
    /**
     * Should close menu when Click this menu item ?
     */
    clickClose: {
      type: Boolean,
      default: !0
    },
    /**
     * By default, the submenu will automatically adjust its position to prevent it overflow the container.
     * 
     * If you allow menu overflow containers, you can set this to false.
     * 
     * Default is inherit from `MenuOptions.adjustPosition`  .
     */
    adjustSubMenuPosition: {
      type: Boolean,
      default: void 0
    },
    /**
     * Max width of submenu
     */
    maxWidth: {
      type: [String, Number],
      default: 0
    },
    /**
     * Min width of submenu
     */
    minWidth: {
      type: [String, Number],
      default: 0
    }
  },
  setup(t, n) {
    const e = ae("globalOptions"), { adjustSubMenuPosition: o, maxWidth: i, minWidth: a } = be(t), s = typeof o.value < "u" ? o.value : e.value.adjustPosition, c = E(), g = E();
    return n.expose({
      getSubMenuRef: () => c.value,
      getMenuItemRef: () => g.value
    }), () => le(wt, {
      ...t,
      ref: g,
      showRightArrow: !0,
      maxWidth: void 0,
      minWidth: void 0,
      adjustSubMenuPosition: void 0,
      hasChildren: typeof n.slots.default !== void 0
    }, n.slots.default ? {
      //Create SubMenu
      submenu: () => le(at, {
        ref: c,
        maxWidth: i.value,
        minWidth: a.value,
        adjustPosition: s
      }, {
        default: n.slots.default
      })
    } : void 0);
  }
});
function yo(t, n, e, o) {
  const i = E(!0), a = le(jt, {
    options: t,
    show: i,
    container: n,
    isFullScreenContainer: !e,
    onCloseAnimFinished: () => {
      kt(null, n);
    },
    onClose: (s) => {
      var c;
      (c = t.onClose) == null || c.call(t, s), i.value = !1;
    }
  }, o);
  return kt(a, n), a.component;
}
function Gt(t, n) {
  const e = _t(t);
  return yo(t, e.container, e.isNew, n).exposed;
}
const rt = {
  /**
   * For Vue install
   * @param app 
   */
  install(t) {
    t.config.globalProperties.$contextmenu = Gt, t.component("ContextMenu", go), t.component("ContextMenuItem", wt), t.component("ContextMenuGroup", mo), t.component("ContextMenuSperator", vt), t.component("ContextMenuSeparator", vt), t.component("ContextSubMenu", at);
  },
  /**
   * Show a ContextMenu in page, same as `this.$contextmenu`
   * 
   * For example:
   * 
   * ```ts
   * onContextMenu(e : MouseEvent) {
   *   //prevent the browser's default menu
   *   e.preventDefault();
   *   //show your menu
   *   ContextMenu.showContextMenu({
   *     x: e.x,
   *     y: e.y,
   *     items: [
   *       { 
   *         label: "A menu item", 
   *         onClick: () => {
   *           alert("You click a menu item");
   *         }
   *       },
   *       { 
   *         label: "A submenu", 
   *         children: [
   *           { label: "Item1" },
   *           { label: "Item2" },
   *           { label: "Item3" },
   *         ]
   *       },
   *     ]
   *   }); 
   * }
   * ```
   * 
   * You can pass customSlots to custom rendering this menu.
   * 
   * For example, custom rendering #itemRender and #separatorRender:
   * ```ts
   *   ContextMenu.showContextMenu({
   *     ...
   *   } as MenuOptions, {
   *     //Use slot in function mode
   *     itemRender: ({ disabled, label, icon, showRightArrow, onClick, onMouseEnter }) => [  h('div', { 
   *       class: 'my-menu-item'+(disabled?' disabled':''),
   *       onMouseenter: onMouseEnter,
   *       onClick: onClick,
   *     }, [
   *       icon ? h('img', { src: icon }) : h('div', { class: 'icon-place-holder' }),
   *       h('span', label),
   *       showRightArrow ? h('span', { class: 'right-arraw' }, '>>') : h('div'),
   *     ]) ],
   *     separatorRender: () => [ h('div', { class: 'my-menu-sperator' }) ]
   *   })
   * ```
   * 
   * @param options The options of ContextMenu
   * @param customSlots You can provide some custom slots to customize the rendering style of the menu. These slots are the same as the slots of component ContextMenu.
   * @returns Menu instance 
   */
  showContextMenu(t, n) {
    return Gt(t, n);
  },
  /**
   * Get if there is a menu open now.
   */
  isAnyContextMenuOpen() {
    return Tn();
  },
  /**
   * Close the currently open menu
   */
  closeContextMenu: Et,
  //Tools
  transformMenuPosition: Hn
}, po = {}, So = {
  class: "mx-menu-bar-icon-menu",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200"
}, bo = /* @__PURE__ */ q("path", { d: "M133.310936 296.552327l757.206115 0c19.781623 0 35.950949-16.169326 35.950949-35.950949 0-19.781623-15.997312-35.950949-35.950949-35.950949L133.310936 224.650428c-19.781623 0-35.950949 16.169326-35.950949 35.950949C97.359987 280.383 113.529313 296.552327 133.310936 296.552327z" }, null, -1), Co = /* @__PURE__ */ q("path", { d: "M890.51705 476.135058 133.310936 476.135058c-19.781623 0-35.950949 16.169326-35.950949 35.950949 0 19.781623 16.169326 35.950949 35.950949 35.950949l757.206115 0c19.781623 0 35.950949-16.169326 35.950949-35.950949C926.467999 492.304384 910.298673 476.135058 890.51705 476.135058z" }, null, -1), wo = /* @__PURE__ */ q("path", { d: "M890.51705 727.447673 133.310936 727.447673c-19.781623 0-35.950949 15.997312-35.950949 35.950949s16.169326 35.950949 35.950949 35.950949l757.206115 0c19.781623 0 35.950949-15.997312 35.950949-35.950949S910.298673 727.447673 890.51705 727.447673z" }, null, -1), Po = [
  bo,
  Co,
  wo
];
function zo(t, n) {
  return x(), V("svg", So, Po);
}
const ko = /* @__PURE__ */ Qe(po, [["render", zo]]), xo = ["onClick", "onMouseenter"], dt = /* @__PURE__ */ ce({
  __name: "MenuBar",
  props: {
    /**
     * Menu options
     */
    options: {
      type: Object,
      default: null
    }
  },
  setup(t) {
    const n = t, e = E(), o = E(!1), i = E([]), a = E(null);
    function s() {
      o.value = !0;
    }
    function c() {
      o.value = !1;
    }
    we(() => {
      i.value = n.options.items || [];
    }), se(() => n.options, () => {
      i.value = n.options.items || [];
    });
    let g = null, u = -1;
    function r() {
      u < i.value.length - 1 ? u++ : u = 0, m(u, i.value[u]);
    }
    function h() {
      u > 0 ? u-- : u = i.value.length - 1, m(u, i.value[u]);
    }
    function S(P) {
      const L = n.options.barPopDirection ?? "bl";
      let I = 0, B = 0;
      return L.startsWith("b") ? B = He(P) + P.offsetHeight : L.startsWith("t") ? B = He(P) : B = He(P) + P.offsetHeight / 2, L.endsWith("l") ? I = Ne(P) : L.startsWith("r") ? I = Ne(P) + P.offsetWidth : I = Ne(P) + P.offsetWidth / 2, { x: I, y: B };
    }
    function m(P, L) {
      var I;
      if (u = P, !L.children)
        return;
      g && (g.closeMenu(), g = null, o.value = !0), a.value = L;
      const B = (I = e.value) == null ? void 0 : I.children[P];
      if (B) {
        const { x: T, y: O } = S(B);
        g = rt.showContextMenu({
          ...n.options,
          items: L.children,
          x: T,
          y: O,
          onKeyFocusMoveLeft() {
            h();
          },
          onKeyFocusMoveRight() {
            r();
          },
          onClose() {
            a.value == L && (o.value = !1, a.value = null), typeof L.onSubMenuClose == "function" && L.onSubMenuClose(void 0);
          }
        }), g && typeof L.onSubMenuOpen == "function" && L.onSubMenuOpen(void 0);
      }
    }
    function b() {
      u = 0;
      const P = e.value;
      if (P) {
        const { x: L, y: I } = S(P);
        g = rt.showContextMenu({
          ...n.options,
          x: L,
          y: I
        });
      }
    }
    function k(P, L) {
      L ? (o.value = !0, m(P, L), L.onClick && (L.clickableWhenHasChildren === !0 && L.children && L.children.length > 0 || !L.children || L.children.length === 0) && L.onClick()) : b();
    }
    function _(P, L) {
      o.value && m(P, L);
    }
    return (P, L) => (x(), V("div", {
      class: re([
        "mx-menu-bar",
        t.options.theme ?? "",
        t.options.mini ? "mini" : ""
      ]),
      onFocus: s,
      onBlur: c
    }, [
      U(P.$slots, "prefix"),
      t.options.mini ? (x(), V("div", {
        key: 0,
        ref_key: "menuBarContent",
        ref: e,
        class: "mx-menu-bar-content"
      }, [
        q("div", {
          class: "mx-menu-bar-item",
          onClick: L[0] || (L[0] = (I) => k(0, null))
        }, [
          ie(ko)
        ])
      ], 512)) : (x(), V("div", {
        key: 1,
        ref_key: "menuBarContent",
        ref: e,
        class: "mx-menu-bar-content"
      }, [
        (x(!0), V(xe, null, Oe(i.value, (I, B) => (x(), V("div", {
          key: B,
          class: re([
            "mx-menu-bar-item",
            I == a.value ? "active" : ""
          ]),
          onClick: (T) => k(B, I),
          onMouseenter: (T) => _(B, I)
        }, Ce(I.label), 43, xo))), 128))
      ], 512)),
      U(P.$slots, "suffix")
    ], 34));
  }
}), Bo = {
  customizeLayout: "Customize Layout",
  togglePanel: "Toggle Panel",
  togglePrimarySideBar: "Toggle Primary Side Bar",
  toggleSecondarySideBar: "Toggle Secondary Side Bar",
  primarySideBar: "Primary Side Bar",
  secondarySideBar: "Secondary Side Bar",
  panel: "Panel",
  alignPanel: "Align Panel",
  menuBar: "Menu Bar",
  activityBar: "Activity Bar",
  statusBar: "Status Bar",
  left: "Left",
  right: "Right",
  center: "Center",
  justify: "Justify",
  primarySideBarPosition: "Primary Side Bar Position",
  panelAlignment: "Panel Alignment",
  visibility: "Visibility",
  restoreDefault: "Restore Default",
  close: "Close",
  hide: "Hide",
  hidden: "Hidden",
  show: "Show",
  side: "Side",
  top: "Top",
  badge: "Badge",
  additionalViews: "Additional Views",
  activityBarPosition: "Activity Bar Position",
  movePrimarySideBarRight: "Move Primary Side Bar Right",
  movePrimarySideBarLeft: "Move Primary Side Bar Left",
  moveSecondarySideBarRight: "Move Secondary Side Bar Right",
  moveSecondarySideBarLeft: "Move Secondary Side Bar Left",
  hideSecondarySideBar: "Hide Secondary Side Bar",
  hidePanel: "Hide Panel",
  maximizePanel: "Maximize Panel",
  restorePanelSize: "Restore Panel Size"
}, Lo = {
  customizeLayout: "自定义布局",
  togglePanel: "切换面板",
  togglePrimarySideBar: "切换主侧栏",
  toggleSecondarySideBar: "切换辅助侧栏",
  primarySideBar: "主侧栏",
  secondarySideBar: "辅助侧栏",
  panel: "面板",
  alignPanel: "对齐面板",
  menuBar: "菜单栏",
  activityBar: "活动栏",
  statusBar: "状态栏",
  left: "左对齐",
  right: "右对齐",
  center: "居中",
  justify: "两端对齐",
  primarySideBarPosition: "主侧栏位置",
  panelAlignment: "面板对齐方式",
  visibility: "可见性",
  restoreDefault: "还原默认值",
  close: "关闭",
  hide: "隐藏",
  hidden: "隐藏",
  show: "显示",
  side: "侧边",
  top: "顶部",
  badge: "徽章",
  additionalViews: "额外视图",
  activityBarPosition: "活动栏位置",
  movePrimarySideBarRight: "向右移动主侧栏",
  movePrimarySideBarLeft: "向左移动主侧栏",
  moveSecondarySideBarRight: "向右移动辅助侧栏",
  moveSecondarySideBarLeft: "向左移动辅助侧栏",
  hideSecondarySideBar: "隐藏辅助侧栏",
  hidePanel: "隐藏面板",
  maximizePanel: "最大化面板大小",
  restorePanelSize: "恢复面板大小"
}, Go = {
  en: Bo,
  zh: Lo
};
function Pt() {
  const t = ae("codeLayoutLangConfig"), n = je(() => ({
    ...Go[t.lang],
    ...t.stringsOverride
  }));
  function e(o) {
    return n.value[o] || o;
  }
  return {
    t: e
  };
}
function lt() {
  const { t } = Pt(), n = ae("codeLayoutContext"), e = ae("codeLayoutConfig");
  function o(i, a) {
    var u;
    a.preventDefault();
    const s = i.getParent();
    if (!s)
      return;
    const c = s.children;
    if (!c)
      return;
    let g = 0;
    for (const r of c)
      g += r.visible ? 1 : 0;
    rt.showContextMenu({
      x: a.x,
      y: a.y,
      theme: "code-layout",
      items: [
        {
          label: `${t(i.visible ? "hide" : "show")} '${i.name}'`,
          disabled: i.noHide || g <= 1,
          onClick: () => {
            i.visible = !i.visible, i.relayoutAfterToggleVisible();
          }
        },
        {
          label: `${t(i.showBadge ? "hide" : "show")} ${t("badge")}`,
          hidden: !((u = i.parentGroup) != null && u.getIsTopGroup()),
          divided: "down",
          onClick: () => {
            i.showBadge = !i.showBadge;
          }
        },
        ...c.map((r) => ({
          label: r.name,
          checked: r.visible,
          disabled: r.noHide || g <= 1 && r.visible,
          onClick() {
            r.visible = !r.visible, r.relayoutAfterToggleVisible();
          }
        })),
        ...i.parentGrid === "primarySideBar" ? [
          {
            label: t("activityBarPosition"),
            divided: "up",
            children: [
              {
                label: t("side"),
                checked: e.value.activityBarPosition === "side",
                onClick() {
                  e.value.activityBarPosition = "side";
                }
              },
              {
                label: t("top"),
                checked: e.value.activityBarPosition === "top",
                onClick() {
                  e.value.activityBarPosition = "top";
                }
              },
              {
                label: t("hidden"),
                checked: e.value.activityBarPosition === "hidden",
                onClick() {
                  e.value.activityBarPosition = "hidden";
                }
              }
            ]
          },
          {
            label: e.value.primarySideBarPosition === "left" ? t("movePrimarySideBarRight") : t("movePrimarySideBarLeft"),
            onClick() {
              e.value.primarySideBarPosition = e.value.primarySideBarPosition === "left" ? "right" : "left";
            }
          },
          {
            label: `${t("hide")} ${t("primarySideBar")}`,
            onClick() {
              n.relayoutTopGridProp("primarySideBar", !1);
            }
          }
        ] : [],
        ...i.parentGrid === "secondarySideBar" ? [
          {
            label: t("activityBarPosition"),
            divided: "up",
            children: [
              {
                label: t("side"),
                checked: e.value.secondaryActivityBarPosition === "side",
                onClick() {
                  e.value.secondaryActivityBarPosition = "side";
                }
              },
              {
                label: t("top"),
                checked: e.value.secondaryActivityBarPosition === "top",
                onClick() {
                  e.value.secondaryActivityBarPosition = "top";
                }
              },
              {
                label: t("hidden"),
                checked: e.value.secondaryActivityBarPosition === "hidden",
                onClick() {
                  e.value.secondaryActivityBarPosition = "hidden";
                }
              }
            ]
          },
          {
            label: e.value.primarySideBarPosition === "left" ? t("moveSecondarySideBarLeft") : t("moveSecondarySideBarRight"),
            onClick() {
              e.value.primarySideBarPosition = e.value.primarySideBarPosition === "left" ? "right" : "left";
            }
          },
          {
            label: `${t("hide")} ${t("secondarySideBar")}`,
            onClick() {
              n.relayoutTopGridProp("secondarySideBar", !1);
            }
          }
        ] : [],
        ...i.parentGrid === "bottomPanel" ? [
          {
            label: t("alignPanel"),
            divided: "up",
            children: [
              {
                label: t("center"),
                checked: e.value.bottomAlignment === "center",
                onClick() {
                  e.value.bottomAlignment = "center";
                }
              },
              {
                label: t("justify"),
                checked: e.value.bottomAlignment === "justify",
                onClick() {
                  e.value.bottomAlignment = "justify";
                }
              },
              {
                label: t("left"),
                checked: e.value.bottomAlignment === "left",
                onClick() {
                  e.value.bottomAlignment = "left";
                }
              },
              {
                label: t("right"),
                checked: e.value.bottomAlignment === "right",
                onClick() {
                  e.value.bottomAlignment = "right";
                }
              }
            ]
          },
          {
            label: `${t("hide")} ${t("panel")}`,
            onClick() {
              n.relayoutTopGridProp("bottomPanel", !1);
            }
          }
        ] : []
      ]
    });
  }
  return {
    onContextMenu: o
  };
}
const Ao = {}, Mo = {
  class: "icon",
  style: { width: "14px", height: "14px", "vertical-align": "middle", fill: "currentColor", overflow: "hidden" },
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
function Do(t, n) {
  return x(), V("svg", Mo, n[0] || (n[0] = [
    q("path", { d: "M342.3 101.9L752.4 512 342.3 922.1l-70.7-70.7L611 512 271.6 172.6l70.7-70.7z" }, null, -1)
  ]));
}
const $o = /* @__PURE__ */ de(Ao, [["render", Do]]), Ro = ["draggable"], Io = ["title"], Oo = /* @__PURE__ */ ce({
  __name: "CodeLayoutCollapseTitle",
  props: {
    draggable: {
      type: Boolean,
      default: !1
    },
    showIconSmall: {
      type: Boolean,
      default: !1
    },
    actions: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ""
    },
    tooltip: {
      type: String,
      default: ""
    },
    iconSmall: {
      type: null,
      default: ""
    }
  },
  emits: ["click", "contextmenu", "dragstart", "dragend"],
  setup(t) {
    return (n, e) => (x(), V("div", {
      class: "code-layout-collapse",
      draggable: t.draggable,
      onDragstart: e[2] || (e[2] = (o) => n.$emit("dragstart", o)),
      onDragend: e[3] || (e[3] = (o) => n.$emit("dragend", o))
    }, [
      q("div", {
        class: "collapse-title",
        title: t.tooltip,
        onClick: e[0] || (e[0] = (o) => n.$emit("click", o)),
        onContextmenu: e[1] || (e[1] = (o) => n.$emit("contextmenu", o))
      }, [
        ie($o, { class: "arrow" }),
        ie(ke, { content: t.title }, null, 8, ["content"]),
        t.showIconSmall ? (x(), te(ke, {
          key: 0,
          content: t.iconSmall
        }, null, 8, ["content"])) : Z("", !0)
      ], 40, Io),
      ie(Te, {
        class: "actions",
        actions: t.actions
      }, null, 8, ["actions"])
    ], 40, Ro));
  }
});
const gt = /* @__PURE__ */ ce({
  __name: "CodeLayoutPanelRender",
  props: {
    panel: {
      type: Object,
      required: !0
    },
    selected: {
      type: Boolean,
      default: !1
    },
    /**
     * Only my self? Id true, do not show header
     */
    alone: {
      type: Boolean,
      default: !1
    },
    open: {
      type: Boolean,
      default: !1
    },
    dragResizeable: {
      type: Boolean,
      default: !1
    },
    dragResizeStartHandler: {
      type: Function,
      default: null
    },
    dragResizeHandler: {
      type: Function,
      default: null
    },
    horizontal: {
      type: Boolean,
      default: !0
    },
    collapsedSize: {
      type: Number,
      default: 0
    },
    resizeDragging: {
      type: Boolean,
      default: !1
    },
    opening: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:open",
    "update:resizeDragging",
    "toggleHandler"
  ],
  setup(t, { emit: n }) {
    const e = n, o = t, i = je(() => o.open ? o.panel.size : o.collapsedSize), a = je(() => o.alone ? "100%" : `calc(100% - ${u.value.panelHeaderHeight}px)`), { horizontal: s, panel: c } = be(o), g = E(), u = ae("codeLayoutConfig"), r = ae("codeLayoutContext"), {
      dragSelfState: h,
      handleDragStart: S,
      handleDragEnd: m
    } = Ze(), {
      dragPanelState: b,
      dragEnterState: k,
      dragOverState: _,
      handleDragOver: P,
      handleDragEnter: L,
      handleDragLeave: I,
      handleDropPreCheck: B,
      resetDragOverState: T,
      resetDragState: O
    } = _e(
      g,
      c,
      s,
      () => {
      },
      (j) => r.dragDropNonPanel(j, !1, "normal"),
      (j) => Ke(j, c.value, _)
    );
    function ne(j) {
      const M = $e();
      M && _.value ? (j.preventDefault(), j.stopPropagation(), r.dragDropToPanelNear(c.value, _.value, M, "normal")) : B(j) && (j.preventDefault(), j.stopPropagation(), r.dragDropNonPanel(j, !0, "normal", c.value, _.value)), T(), O();
    }
    function v() {
      e("toggleHandler", o.panel, !o.open);
    }
    let C = null;
    const D = E(), W = E(!1), y = it({
      onDown(j) {
        var M;
        return D.value ? (e("update:resizeDragging", !0), W.value = !0, C = (M = o.dragResizeStartHandler) == null ? void 0 : M.call(
          o,
          o.panel,
          o.horizontal ? j.x : j.y
        ), C !== !1) : !1;
      },
      onMove(j, M, z) {
        var H;
        (H = o.dragResizeHandler) == null || H.call(
          o,
          o.panel,
          C,
          o.horizontal ? z.x : z.y
        );
      },
      onUp() {
        e("update:resizeDragging", !1), W.value = !1;
      }
    }), {
      onContextMenu: J
    } = lt();
    return we(() => {
      b.value = !1;
    }), (j, M) => l(c).visible ? (x(), V("div", {
      key: 0,
      ref_key: "element",
      ref: g,
      class: re([
        "code-layout-panel",
        t.open ? "open" : "closed",
        t.selected ? "selected" : "",
        t.dragResizeable ? "resizeable" : "",
        W.value ? "resizing-self" : "",
        t.resizeDragging ? "resizing" : "",
        l(s) ? "horizontal" : "",
        l(k) ? "drag-enter" : "",
        l(h) ? "dragging-self" : "",
        l(b) ? "dragging" : "",
        t.opening ? "opening" : "",
        `drag-over-${l(_)}`
      ]),
      style: Ge({
        width: l(s) && i.value ? `${i.value}px` : "100%",
        height: !l(s) && i.value ? `${i.value}px` : "100%"
      }),
      tabindex: "0",
      onDragover: M[3] || (M[3] = //@ts-ignore
      (...z) => l(P) && l(P)(...z)),
      onDragleave: M[4] || (M[4] = //@ts-ignore
      (...z) => l(I) && l(I)(...z)),
      onDragenter: M[5] || (M[5] = //@ts-ignore
      (...z) => l(L) && l(L)(...z)),
      onDrop: ne
    }, [
      t.dragResizeable ? (x(), V("div", {
        key: 0,
        ref_key: "resizeDragger",
        ref: D,
        draggable: !1,
        class: re([
          "drag-line",
          W.value ? "active" : ""
        ]),
        onMousedown: M[0] || (M[0] = //@ts-ignore
        (...z) => l(y) && l(y)(...z))
      }, null, 34)) : Z("", !0),
      t.alone ? Z("", !0) : (x(), te(Oo, {
        key: 1,
        draggable: l(c).draggable && !t.resizeDragging,
        showIconSmall: l(s) && !t.open,
        iconSmall: l(c).iconSmall,
        title: l(c).title,
        tooltip: l(c).tooltip,
        actions: l(c).actions,
        onClick: v,
        onContextmenu: M[1] || (M[1] = (z) => l(J)(o.panel, z)),
        onDragstart: M[2] || (M[2] = (z) => l(S)(l(c), z)),
        onDragend: l(m)
      }, null, 8, ["draggable", "showIconSmall", "iconSmall", "title", "tooltip", "actions", "onDragend"])),
      t.open ? (x(), V("div", {
        key: 2,
        class: "content",
        draggable: !1,
        style: Ge({
          width: !t.open && l(s) ? a.value : "",
          height: t.open || !l(s) ? a.value : ""
        })
      }, [
        U(j.$slots, "default", {
          panel: l(c),
          open: t.open
        })
      ], 4)) : Z("", !0)
    ], 38)) : Z("", !0);
  }
});
const At = /* @__PURE__ */ ce({
  __name: "CodeLayoutGroupDraggerHost",
  props: {
    group: {
      type: Object,
      required: !0
    },
    /**
     * Is horizontal?
     * 
     * Default: true
     */
    horizontal: {
      type: Boolean,
      default: !0
    }
  },
  setup(t) {
    const n = E(), e = E(!1), o = ae("codeLayoutConfig"), i = ae("codeLayoutContext"), a = t, { group: s, horizontal: c } = be(a), g = E(!1);
    function u(f) {
      return f || o.value.panelMinHeight;
    }
    function r(f, p, w) {
      const A = p + w;
      return f.size = Math.max(u(f.minSize), A), f.size - p;
    }
    function h(f) {
      if (!n.value)
        return !1;
      const p = a.group.children, w = p.indexOf(f);
      if (w < 1)
        return !1;
      const A = o.value.panelHeaderHeight, F = a.horizontal ? Be.getLeft(n.value) - n.value.scrollLeft : Be.getTop(n.value) - n.value.scrollTop;
      let R = 0, N = 0;
      const Y = [], Q = [];
      for (let X = w - 1; X >= 0; X--) {
        const oe = p[X];
        oe.visible && (R += oe.open ? oe.size : A, oe.open && Y.push({ panel: oe, size: oe.size }));
      }
      for (let X = w; X < p.length; X++) {
        const oe = p[X];
        oe.visible && (N += oe.open ? oe.size : A, oe.open && Q.push({ panel: oe, size: oe.size }));
      }
      return {
        prevPanelsSize: R,
        nextPanelsSize: N,
        prevOpenedPanels: Y,
        nextOpenedPanels: Q,
        firstPanelAbsolutePosScreen: F
      };
    }
    function S(f, p, w) {
      const {
        prevPanelsSize: A,
        //nextPanelsSize,
        prevOpenedPanels: F,
        nextOpenedPanels: R,
        firstPanelAbsolutePosScreen: N
      } = p;
      let Q = w - N - A;
      if (Q === 0)
        return;
      const X = Q > 0, oe = (ve) => {
        let me = Q - ve;
        for (let Le = 0; Le < R.length; Le++) {
          const Ie = R[Le];
          if (me += r(Ie.panel, Ie.size, -me), X ? me <= 0 : me >= 0)
            break;
        }
        return me;
      }, ue = (ve) => {
        let me = Q - ve;
        for (let Le = 0; Le < F.length; Le++) {
          const Ie = F[Le];
          if (me -= r(Ie.panel, Ie.size, me), X ? me <= 0 : me >= 0)
            break;
        }
        return me;
      };
      if (X) {
        const ve = oe(0);
        ue(ve);
      } else {
        const ve = ue(0);
        oe(ve);
      }
    }
    function m(f, p) {
      if (f.open = p, g.value = !0, setTimeout(() => g.value = !1, 300), !n.value)
        return;
      const w = a.horizontal ? n.value.offsetWidth : n.value.offsetHeight, A = a.group.children;
      if (A.length === 1) {
        f.size = w;
        return;
      }
      const F = o.value.panelHeaderHeight, R = A.indexOf(f);
      if (b(), p) {
        let N = !0;
        for (let X = 0; X < A.length; X++)
          if (A[X].visible && A[X].open && A[X] !== f) {
            N = !1;
            break;
          }
        if (N) {
          let X = 0;
          A.forEach((oe) => {
            oe.visible && (X += oe !== f ? F : 0);
          }), f.size = Math.max(u(f.minSize), w - X);
          return;
        }
        let Y = f.size - F;
        const Q = (X) => {
          const oe = u(X.minSize), ue = Math.min(X.size, Y);
          Y -= ue, X.size -= ue;
          const ve = oe - X.size;
          ve > 0 && (X.size = oe, Y += ve);
        };
        for (let X = R + 1; X < A.length; X++) {
          const oe = A[X];
          if (oe.visible && (oe.open && Q(oe), Y <= 0))
            return;
        }
        for (let X = R - 1; X >= 0; X--) {
          const oe = A[X];
          oe.visible && oe.open && Q(oe);
        }
        Y > 0 && (f.size = Math.max(
          f.size - Y,
          u(f.minSize)
        ));
      } else {
        let N = f.size - F;
        for (let Y = R + 1; Y < A.length; Y++) {
          const Q = A[Y];
          if (Q.visible && Q.open) {
            Q.size += N;
            return;
          }
        }
        for (let Y = R - 1; Y >= 0; Y--) {
          const Q = A[Y];
          if (Q.visible && Q.open) {
            Q.size += N;
            return;
          }
        }
      }
    }
    function b() {
      let f = !1;
      for (let p = 0; p < a.group.children.length; p++) {
        const w = a.group.children[p];
        p > 0 && (w.resizeable = w.open || f), w.open && (f = !0);
      }
      for (let p = a.group.children.length - 1; p >= 0; p--) {
        const w = a.group.children[p];
        if (w.resizeable && !w.open && (w.resizeable = !1), w.open)
          break;
      }
    }
    function k() {
      if (!n.value)
        return 0;
      const f = o.value.panelHeaderHeight;
      let p = 0;
      for (let w = 0; w < a.group.children.length; w++) {
        const A = a.group.children[w];
        A.visible && (p += A.open ? A.size : f);
      }
      s.value.lastLayoutSizeCounter = p;
    }
    function _() {
      if (!n.value)
        throw new Error("No container");
      const f = a.horizontal ? n.value.offsetWidth : n.value.offsetHeight, p = o.value.panelHeaderHeight;
      let w = f, A = 0;
      return a.group.children.forEach((F) => {
        F.visible && (F.open && F.size > 0 ? w -= F.size : F.open ? A++ : w -= p);
      }), {
        canAllocSize: Math.max(w, 0),
        notAllocSpaceAndOpenCount: A
      };
    }
    function P() {
      const { canAllocSize: f, notAllocSpaceAndOpenCount: p } = _();
      return p > 0 ? f / p : 0;
    }
    function L() {
      if (!n.value)
        return;
      const f = o.value.panelHeaderHeight, p = a.horizontal ? n.value.offsetWidth : n.value.offsetHeight;
      let w = 0;
      a.group.children.forEach((A) => {
        A.visible && (w += A.open ? A.size : f);
      }), w !== p && B(w - p);
    }
    function I() {
      const f = P();
      a.group.children.forEach((p) => {
        p.visible && p.size === 0 && (p.size = Math.max(f, u(p.minSize)));
      }), T(), k(), b();
    }
    function B(f) {
      if (!n.value)
        return;
      let p = 0;
      const w = a.group.children.filter((R) => R.visible ? (p += R.open ? R.size : o.value.panelHeaderHeight, R.open) : !1).sort((R, N) => R.size > N.size ? 1 : -1), A = f < 0, F = a.horizontal ? n.value.offsetWidth : n.value.offsetHeight;
      if (A) {
        if (p >= F)
          return;
        const R = p + -f - F;
        R > 0 && (f -= -R);
      }
      for (let R = 0; R < w.length; R++) {
        const N = w[R];
        if (f += r(N, N.size, -f), !A && f <= 0 || A && f >= 0)
          break;
      }
      k();
    }
    function T() {
      if (!n.value)
        return;
      const f = a.horizontal ? n.value.offsetWidth : n.value.offsetHeight;
      if (s.value.lastRelayoutSize === 0) {
        s.value.lastRelayoutSize = f;
        return;
      }
      let p = a.group.lastRelayoutSize - f;
      p !== 0 && (B(p), s.value.lastRelayoutSize = f);
    }
    function O(f) {
      const p = o.value.panelHeaderHeight;
      let w = 0;
      for (const A of f) {
        const F = P();
        if (A.size <= 0) {
          const { canAllocSize: R } = _();
          A.size = A.open ? Math.max(Math.min(R, F), u(A.minSize)) : u(A.minSize), A.open && A.size > R ? w += A.size - R : !A.open && p > R && (w += p - R);
        } else
          w += A.open ? A.size : p;
      }
      B(w), b(), k();
    }
    function ne(f) {
      B(-(f.open ? f.size : o.value.panelHeaderHeight));
    }
    se(() => a.group.children, () => {
      I();
    });
    const {
      startResizeChecker: v,
      stopResizeChecker: C
    } = Ct(
      n,
      a.horizontal ? T : void 0,
      a.horizontal ? void 0 : T
    );
    function D() {
      s.value.listenLateAction("notifyRelayout", () => I()), s.value.listenLateAction("relayoutAllWithNewPanel", O), s.value.listenLateAction("relayoutAllWithResizedSize", B), s.value.listenLateAction("relayoutAllWithRemovePanel", ne);
    }
    function W(f) {
      f.unlistenAllLateAction();
    }
    se(() => a.group, (f, p) => {
      W(p), D();
    });
    const {
      dragEnterState: y,
      dragOverState: J,
      handleDragOver: j,
      handleDragEnter: M,
      handleDragLeave: z,
      handleDropPreCheck: H,
      resetDragOverState: d,
      resetDragState: $
    } = _e(
      n,
      s,
      c,
      () => {
      },
      (f) => i.dragDropNonPanel(f, !1, "empty"),
      (f) => s.value.lastLayoutSizeCounter < s.value.lastRelayoutSize && Ke(f, s.value, J)
    );
    function G(f) {
      const p = $e();
      if (p && J.value) {
        f.preventDefault(), f.stopPropagation();
        const w = s.value.getLastChildOrSelf();
        w !== p && i.dragDropToPanelNear(
          w,
          "right",
          p,
          "empty"
        );
      } else if (H(f)) {
        f.preventDefault(), f.stopPropagation();
        const w = s.value.getLastChildOrSelf();
        i.dragDropNonPanel(f, !0, "empty", w, "right");
      }
      d(), $();
    }
    return we(() => {
      D(), fe(() => {
        I(), v(), T(), setTimeout(() => {
          T(), L();
        }, 200);
      });
    }), Re(() => {
      C(), W(a.group);
    }), (f, p) => (x(), V("div", {
      ref_key: "container",
      ref: n,
      class: re([
        "code-layout-group-dragger-host",
        l(y) ? "drag-enter" : ""
      ]),
      onDragover: p[1] || (p[1] = //@ts-ignore
      (...w) => l(j) && l(j)(...w)),
      onDragleave: p[2] || (p[2] = //@ts-ignore
      (...w) => l(z) && l(z)(...w)),
      onDragenter: p[3] || (p[3] = //@ts-ignore
      (...w) => l(M) && l(M)(...w)),
      onDrop: G
    }, [
      (x(!0), V(xe, null, Oe(l(s).children, (w, A) => {
        var F;
        return x(), te(gt, {
          key: A,
          open: w.open,
          "onUpdate:open": (R) => w.open = R,
          resizeDragging: e.value,
          "onUpdate:resizeDragging": p[0] || (p[0] = (R) => e.value = R),
          panel: w,
          opening: g.value,
          horizontal: l(c),
          dragResizeable: w.resizeable,
          dragResizeStartHandler: h,
          dragResizeHandler: S,
          alone: ((F = l(s).children) == null ? void 0 : F.length) === 1,
          collapsedSize: l(o).panelHeaderHeight,
          onToggleHandler: m
        }, {
          default: ee((R) => [
            U(f.$slots, "panelRender", nt({ ref_for: !0 }, R))
          ]),
          _: 2
        }, 1032, ["open", "onUpdate:open", "resizeDragging", "panel", "opening", "horizontal", "dragResizeable", "alone", "collapsedSize"]);
      }), 128))
    ], 34));
  }
});
const To = ["draggable"], Wo = {
  key: 0,
  class: "title"
}, Ho = {
  key: 1,
  class: "icon"
}, No = {
  key: 2,
  class: "badge"
}, Eo = /* @__PURE__ */ ce({
  __name: "CodeLayoutTabItem",
  props: {
    tabStyle: {
      type: String,
      default: "none"
    },
    active: {
      type: Boolean,
      default: !0
    },
    panel: {
      type: Object,
      required: !0
    }
  },
  emits: [
    "focusSelf"
  ],
  setup(t, { emit: n }) {
    const e = n, o = t, { panel: i } = be(o), a = E(!0), s = E(), c = ae("codeLayoutContext"), {
      handleDragStart: g,
      handleDragEnd: u
    } = Ze(), {
      dragEnterState: r,
      dragOverState: h,
      handleDragOver: S,
      handleDragEnter: m,
      handleDragLeave: b,
      handleDropPreCheck: k,
      resetDragState: _,
      resetDragOverState: P
    } = _e(
      s,
      i,
      a,
      () => e("focusSelf"),
      (B) => c.dragDropNonPanel(B, !1, "tab-header"),
      (B) => Ke(B, i.value, h)
    );
    function L(B) {
      const T = $e();
      T && h.value ? (B.preventDefault(), B.stopPropagation(), c.dragDropToPanelNear(i.value, h.value, T, "tab-header")) : k(B) && (B.preventDefault(), B.stopPropagation(), c.dragDropNonPanel(B, !0, "tab-header", i.value, h.value)), P(), _();
    }
    const {
      onContextMenu: I
    } = lt();
    return (B, T) => (x(), te(bt, {
      content: l(i).tooltip,
      direction: "top"
    }, {
      default: ee(() => [
        q("div", {
          ref_key: "container",
          ref: s,
          class: re([
            "tab-item",
            t.active ? "active" : "",
            l(r) ? "drag-enter" : "",
            `drag-over-${l(h)}`
          ]),
          draggable: l(i).draggable,
          onDragstart: T[0] || (T[0] = (O) => l(g)(l(i), O)),
          onDragend: T[1] || (T[1] = //@ts-ignore
          (...O) => l(u) && l(u)(...O)),
          onDragover: T[2] || (T[2] = //@ts-ignore
          (...O) => l(S) && l(S)(...O)),
          onDragleave: T[3] || (T[3] = //@ts-ignore
          (...O) => l(b) && l(b)(...O)),
          onDragenter: T[4] || (T[4] = //@ts-ignore
          (...O) => l(m) && l(m)(...O)),
          onDrop: L,
          onContextmenu: T[5] || (T[5] = (O) => l(I)(l(i), O))
        }, [
          t.tabStyle == "text" ? (x(), V("span", Wo, Ce(l(i).title), 1)) : Z("", !0),
          t.tabStyle == "icon" ? (x(), V("span", Ho, [
            ie(ke, {
              content: l(i).iconSmall || l(i).iconLarge || l(i).title
            }, null, 8, ["content"])
          ])) : Z("", !0),
          l(i).badge ? (x(), V("span", No, [
            ie(ke, {
              content: l(i).badge
            }, null, 8, ["content"])
          ])) : Z("", !0)
        ], 42, To)
      ]),
      _: 1
    }, 8, ["content"]));
  }
}), _o = {}, Vo = {
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
function jo(t, n) {
  return x(), V("svg", Vo, n[0] || (n[0] = [
    q("path", {
      d: "M204.8 443.744a68.256 68.256 0 1 1 0 136.512 68.256 68.256 0 0 1 0-136.512z m307.2 0a68.256 68.256 0 1 1 0 136.512 68.256 68.256 0 0 1 0-136.512z m307.2 0a68.256 68.256 0 1 1 0 136.512 68.256 68.256 0 0 1 0-136.512z",
      fill: "currentColor"
    }, null, -1)
  ]));
}
const Fo = /* @__PURE__ */ de(_o, [["render", jo]]), Uo = /* @__PURE__ */ ce({
  __name: "OverflowCollapseList",
  props: {
    /**
     * Items to display, render by slot
     */
    items: {
      type: Object,
      default: () => []
    },
    /**
     * Activated item, activated item will not be hidden
     */
    activeItem: {
      type: null,
      default: null
    },
    /**
     * Direction of the list, horizontal or vertical
     */
    direction: {
      type: String,
      default: "horizontal"
    },
    /**
     * Label of the item in the context menu
     */
    itemMenuLabel: {
      type: Function,
      default: null
    },
    /**
     * Mergin of the item when collapse
     */
    itemCollapseMergin: {
      type: Number,
      default: 30
    }
  },
  emits: [
    "overflowItemClicked"
  ],
  setup(t, { emit: n }) {
    const e = t, o = n, i = E(), a = E(), s = E(-1);
    function c() {
      if (s.value = -1, !i.value)
        return;
      const h = e.activeItem, S = e.direction === "horizontal", m = (S ? i.value.offsetWidth : i.value.offsetHeight) - e.itemCollapseMergin, b = i.value.children;
      let k = 0, _ = -1;
      for (let P = 0; P < b.length && P < e.items.length; P++) {
        const L = b[P];
        L.style.display = "", k += S ? L.offsetWidth : L.offsetHeight, L.style.display = k < m || e.items[P] === h ? "" : "none", k >= m && _ === -1 && (_ = P, s.value = P, h && e.items.indexOf(h) >= P && P > 0 && (b[P - 1].style.display = "none"));
      }
    }
    function g() {
      var h;
      a.value && rt.showContextMenu({
        theme: "code-layout",
        x: Be.getLeft(a.value),
        y: Be.getTop(a.value) + ((h = a.value) == null ? void 0 : h.offsetHeight),
        items: e.items.slice(s.value).map((S) => {
          var m;
          return {
            label: ((m = e.itemMenuLabel) == null ? void 0 : m.call(e, S)) || "",
            onClick() {
              o("overflowItemClicked", S);
            }
          };
        })
      });
    }
    se(() => e.items, c), se(() => e.activeItem, c);
    const {
      startResizeChecker: u,
      stopResizeChecker: r
    } = Ct(
      i,
      () => c(),
      () => c()
    );
    return we(() => {
      u(), fe(() => {
        c();
      });
    }), Re(() => {
      r();
    }), (h, S) => (x(), V("div", {
      ref_key: "container",
      ref: i,
      class: re([
        "OverflowCollapseList",
        t.direction
      ])
    }, [
      (x(!0), V(xe, null, Oe(t.items, (m, b) => U(h.$slots, "item", {
        key: m.key ?? b,
        item: m,
        index: b
      })), 128)),
      s.value >= 0 ? U(h.$slots, "overflowItem", { key: 0 }, () => [
        q("div", {
          ref_key: "overflowItem",
          ref: a,
          class: "OverflowItem",
          onClick: g
        }, [
          ie(Fo)
        ], 512)
      ]) : Z("", !0)
    ], 2));
  }
});
const qo = {}, Jo = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  version: "1.1",
  viewBox: "-10 0 350 340"
};
function Yo(t, n) {
  return x(), V("svg", Jo, n[0] || (n[0] = [
    q("g", null, [
      q("path", {
        stroke: "null",
        id: "svg_1",
        d: "m154.5,173.04268l123.14634,124.95732l25.35366,-25.35366l-124.95732,-123.14634l124.95732,-123.14634l-25.35366,-25.35366l-123.14634,124.95732l-123.14634,-124.95732l-25.35366,25.35366l124.95732,123.14634l-124.95732,123.14634l25.35366,25.35366l123.14634,-124.95732z",
        fill: "currentColor"
      })
    ], -1)
  ]));
}
const Mt = /* @__PURE__ */ de(qo, [["render", Yo]]), Xo = {}, Ko = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function Zo(t, n) {
  return x(), V("svg", Ko, n[0] || (n[0] = [
    q("g", null, [
      q("path", {
        stroke: "null",
        id: "svg_1",
        d: "m155,114.04268l127.70732,124.95732l26.29268,-25.35366l-129.58537,-123.14634l-24.41463,-23.54268l-24.41463,23.54268l-129.58537,123.14634l26.29268,25.35366l127.70732,-124.95732z",
        fill: "currentColor"
      })
    ], -1)
  ]));
}
const Qo = /* @__PURE__ */ de(Xo, [["render", Zo]]), ei = { class: "right" }, ti = ["draggable"], ni = { class: "title" }, ft = /* @__PURE__ */ ce({
  __name: "CodeLayoutGroupRender",
  props: {
    group: {
      type: Object,
      required: !0
    },
    horizontal: {
      type: Boolean,
      default: !0
    },
    show: {
      type: Boolean,
      default: !0
    },
    type: {
      type: String,
      default: ""
    }
  },
  setup(t, { expose: n }) {
    const e = t, o = ae("codeLayoutConfig");
    function i(S) {
      e.group.setActiveChild(S);
    }
    const {
      handleDragStart: a,
      handleDragEnd: s
    } = Ze(), {
      onContextMenu: c
    } = lt(), { t: g } = Pt(), u = E([
      {
        icon() {
          return le(Qo, {
            style: {
              transform: o.value.bottomPanelMaximize ? "rotate(180deg)" : ""
            }
          });
        },
        tooltip: g("maximizePanel"),
        onClick() {
          o.value.bottomPanelMaximize = !o.value.bottomPanelMaximize;
        }
      },
      {
        icon: () => le(Mt),
        tooltip: g("hidePanel"),
        onClick: () => {
          o.value.bottomPanel = !1;
        }
      }
    ]), r = E([
      {
        icon: () => le(Mt),
        tooltip: g("hideSecondarySideBar"),
        onClick: () => {
          o.value.secondarySideBar = !1;
        }
      }
    ]);
    se(() => o.value.bottomPanelMaximize, (S) => {
      u.value[0].tooltip = g(S ? "restorePanelSize" : "maximizePanel");
    });
    const h = mt();
    return n({
      forceUpdate() {
        var S;
        (S = h == null ? void 0 : h.proxy) == null || S.$forceUpdate();
      }
    }), (S, m) => {
      const b = Ve("CodeLayoutGroupRender", !0);
      return t.show && t.group.tabStyle === "hidden" ? (x(), V(xe, { key: 0 }, [
        t.group.activePanel ? (x(), te(b, {
          key: 0,
          show: t.group.activePanel.visible,
          group: t.group.activePanel,
          horizontal: !1
        }, {
          panelRender: ee((k) => [
            U(S.$slots, "panelRender", pe(Se(k)))
          ]),
          emptyTabRender: ee(() => [
            U(S.$slots, "emptyTabRender")
          ]),
          _: 3
        }, 8, ["show", "group"])) : U(S.$slots, "emptyTabRender", { key: 1 })
      ], 64)) : t.show ? (x(), V("div", {
        key: 1,
        class: re([
          "code-layout-group",
          "tab-" + t.group.tabStyle,
          t.type === "primary" ? "primary" : ""
        ])
      }, [
        t.group.tabStyle && t.group.tabStyle != "none" && t.group.tabStyle != "single" ? (x(), V("div", {
          key: 0,
          class: re("tab " + t.group.tabStyle)
        }, [
          ie(Uo, {
            class: "tab-container",
            items: t.group.children,
            activeItem: t.group.activePanel,
            itemMenuLabel: (k) => k.title,
            onOverflowItemClicked: m[0] || (m[0] = (k) => t.group.setActiveChild(k))
          }, {
            item: ee(({ item: k }) => [
              Me(ie(Eo, {
                tabStyle: t.group.tabStyle,
                active: t.group.activePanel === k,
                panel: k,
                onClick: (_) => i(k),
                onFocusSelf: (_) => i(k)
              }, null, 8, ["tabStyle", "active", "panel", "onClick", "onFocusSelf"]), [
                [De, k.visible]
              ])
            ]),
            _: 1
          }, 8, ["items", "activeItem", "itemMenuLabel"]),
          q("div", ei, [
            t.group.activePanel ? (x(), te(Te, {
              key: 0,
              class: "actions",
              actions: t.group.activePanel.actions
            }, null, 8, ["actions"])) : Z("", !0),
            t.group.parentGrid === "bottomPanel" ? (x(), te(Te, {
              key: 1,
              class: "actions",
              actions: u.value
            }, null, 8, ["actions"])) : Z("", !0),
            t.group.parentGrid === "secondarySideBar" ? (x(), te(Te, {
              key: 2,
              class: "actions",
              actions: r.value
            }, null, 8, ["actions"])) : Z("", !0)
          ])
        ], 2)) : t.group.tabStyle === "single" || !t.group.children || t.group.children.length == 0 ? (x(), V("div", {
          key: 1,
          class: "title-bar",
          draggable: t.group.draggable,
          onDragstart: m[1] || (m[1] = (k) => l(a)(t.group, k)),
          onDragend: m[2] || (m[2] = //@ts-ignore
          (...k) => l(s) && l(s)(...k)),
          onContextmenu: m[3] || (m[3] = (k) => l(c)(t.group, k))
        }, [
          q("span", ni, Ce(t.group.title), 1),
          t.group.activePanel ? (x(), te(Te, {
            key: 0,
            class: "actions",
            actions: t.group.actions
          }, null, 8, ["actions"])) : Z("", !0)
        ], 40, ti)) : Z("", !0),
        q("div", {
          class: re(["content", t.horizontal ? "horizontal" : "vertical"])
        }, [
          t.group.children.length > 1 && (!t.group.tabStyle || t.group.tabStyle === "none" || t.group.tabStyle === "single") ? (x(), te(At, {
            key: 0,
            group: t.group,
            horizontal: t.horizontal
          }, {
            panelRender: ee((k) => [
              U(S.$slots, "panelRender", pe(Se(k)))
            ]),
            _: 3
          }, 8, ["group", "horizontal"])) : t.group.activePanel && t.group.activePanel.children.length > 1 ? (x(), te(At, {
            key: 1,
            group: t.group.activePanel,
            horizontal: t.horizontal
          }, {
            panelRender: ee((k) => [
              U(S.$slots, "panelRender", pe(Se(k)))
            ]),
            _: 3
          }, 8, ["group", "horizontal"])) : (t.group.tabStyle === "text" || t.group.tabStyle === "icon") && t.group.children.length == 0 ? U(S.$slots, "emptyTabRender", { key: 2 }) : t.group.activePanel ? (x(), te(gt, {
            key: 3,
            open: !0,
            panel: t.group.activePanel,
            alone: !0,
            horizontal: t.horizontal
          }, {
            default: ee((k) => [
              U(S.$slots, "panelRender", pe(Se(k)))
            ]),
            _: 3
          }, 8, ["panel", "horizontal"])) : (x(), te(gt, {
            key: 4,
            open: !0,
            panel: t.group,
            alone: !0,
            horizontal: t.horizontal
          }, {
            default: ee((k) => [
              U(S.$slots, "panelRender", pe(Se(k)))
            ]),
            _: 3
          }, 8, ["panel", "horizontal"]))
        ], 2)
      ], 2)) : Z("", !0);
    };
  }
});
const ht = /* @__PURE__ */ ce({
  __name: "CodeLayoutEmpty",
  props: {
    panel: {
      type: Object,
      default: null
    },
    grid: {
      type: String,
      required: !0
    }
  },
  setup(t) {
    const n = t, { panel: e } = be(n), o = E(), i = ae("codeLayoutContext"), a = E(!1), {
      dragEnterState: s,
      handleDragOver: c,
      handleDragEnter: g,
      handleDragLeave: u,
      handleDropPreCheck: r,
      resetDragOverState: h,
      resetDragState: S
    } = _e(
      o,
      e,
      a,
      () => {
      },
      (b) => i.dragDropNonPanel(b, !1, "empty"),
      (b) => (!b.accept || b.accept.includes(n.grid)) && (!b.preDropCheck || b.preDropCheck(b, n.grid))
    );
    function m(b) {
      const k = $e();
      k ? (b.preventDefault(), b.stopPropagation(), n.panel ? i.dragDropToPanelNear(n.panel, "right", k, "empty") : i.dragDropToGrid(n.grid, k)) : r(b) && (b.preventDefault(), b.stopPropagation(), i.dragDropNonPanel(b, !0, "empty", n.panel, "right")), h(), S();
    }
    return (b, k) => (x(), V("div", {
      ref_key: "container",
      ref: o,
      class: re([
        "code-layout-empty",
        l(s) ? "drag-active" : ""
      ]),
      onDragover: k[0] || (k[0] = //@ts-ignore
      (..._) => l(c) && l(c)(..._)),
      onDragleave: k[1] || (k[1] = //@ts-ignore
      (..._) => l(u) && l(u)(..._)),
      onDragenter: k[2] || (k[2] = //@ts-ignore
      (..._) => l(g) && l(g)(..._)),
      onDrop: m
    }, [
      U(b.$slots, "default")
    ], 34));
  }
});
const oi = {}, ii = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function ai(t, n) {
  return x(), V("svg", ii, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M38 19l-19 18v225l19 19h225l18 -19v-225l-18 -18h-225zM263 262h-132v-225h132v225z"
    }, null, -1)
  ]));
}
const et = /* @__PURE__ */ de(oi, [["render", ai]]), ri = {}, li = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function si(t, n) {
  return x(), V("svg", li, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M38 19l-19 19v225l19 18h225l18 -18v-225l-18 -19h-225zM38 263v-225h75v225h-75zM131 263v-225h132v225h-132z"
    }, null, -1)
  ]));
}
const ci = /* @__PURE__ */ de(ri, [["render", si]]), ui = {}, di = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function fi(t, n) {
  return x(), V("svg", di, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M38 19l-19 18v225l19 19h225l18 -19v-225l-18 -18h-225zM38 187v-150h225v150h-225z"
    }, null, -1)
  ]));
}
const Dt = /* @__PURE__ */ de(ui, [["render", fi]]), hi = {}, vi = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function gi(t, n) {
  return x(), V("svg", vi, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M38 19l-19 19v225l19 18h225l18 -18v-225l-18 -19h-225zM38 188v-150h225v150h-225zM38 206h225v57h-225v-57z"
    }, null, -1)
  ]));
}
const mi = /* @__PURE__ */ de(hi, [["render", gi]]), yi = {}, pi = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function Si(t, n) {
  return x(), V("svg", pi, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M38 19l-19 18v225l19 19h225l18 -19v-225l-18 -18h-225zM38 262v-225h131v225h-131z"
    }, null, -1)
  ]));
}
const $t = /* @__PURE__ */ de(yi, [["render", Si]]), bi = {}, Ci = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function wi(t, n) {
  return x(), V("svg", Ci, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M38 19l-19 19v225l19 18h225l18 -18v-225l-18 -19h-225zM38 263v-225h131v225h-131zM188 263v-225h75v225h-75z"
    }, null, -1)
  ]));
}
const Pi = /* @__PURE__ */ de(bi, [["render", wi]]), zi = {}, ki = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function xi(t, n) {
  return x(), V("svg", ki, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M56 37l-18 19v188l18 18h75l19 -18v-188l-19 -19h-75zM56 244v-188h75v188h-75zM188 56l18 -19h57l18 19v56l-18 19h-57l-18 -19v-56zM206 56v56h57v-56h-57zM188 187l18 -18h57l18 18v57l-18 18h-57l-18 -18v-57zM206 187v57h57v-57h-57z"
    }, null, -1)
  ]));
}
const Bi = /* @__PURE__ */ de(zi, [["render", xi]]), Li = {}, Gi = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function Ai(t, n) {
  return x(), V("svg", Gi, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M19 38l19 -19h225l18 19v225l-18 18h-225l-19 -18v-225zM38 38v225h225v-225h-225zM56 56h38v19h-38v-19zM113 56h37v19h-37v-19zM206 56h-37v19h37v-19z"
    }, null, -1)
  ]));
}
const Mi = /* @__PURE__ */ de(Li, [["render", Ai]]), Di = {}, $i = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function Ri(t, n) {
  return x(), V("svg", $i, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M38 19l-19 18v225l19 19h225l18 -19v-225l-18 -18h-225zM263 262h-188v-225h188v225z"
    }, null, -1)
  ]));
}
const Ii = /* @__PURE__ */ de(Di, [["render", Ri]]), Oi = {}, Ti = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function Wi(t, n) {
  return x(), V("svg", Ti, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M38 19l-19 19v225l19 18h225l18 -18v-225l-18 -19h-225zM38 244v-206h225v206h-225z"
    }, null, -1)
  ]));
}
const Hi = /* @__PURE__ */ de(Oi, [["render", Wi]]), Ni = {}, Ei = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function _i(t, n) {
  return x(), V("svg", Ei, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M19 37l19 -18h225l18 18v225l-18 19h-225l-19 -19v-225zM38 37v150h150v-150h-150zM206 37v225h57v-225h-57z"
    }, null, -1)
  ]));
}
const Vi = /* @__PURE__ */ de(Ni, [["render", _i]]), ji = {}, Fi = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function Ui(t, n) {
  return x(), V("svg", Fi, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M19 37l19 -18h225l18 18v225l-18 19h-225l-19 -19v-225zM38 37v225h56v-225h-56zM113 37v150h150v-150h-150z"
    }, null, -1)
  ]));
}
const qi = /* @__PURE__ */ de(ji, [["render", Ui]]), Ji = {}, Yi = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function Xi(t, n) {
  return x(), V("svg", Yi, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M38 19l-19 18v225l19 19h225l18 -19v-225l-18 -18h-225zM38 262v-225h37v225h-37zM94 187v-150h112v150h-112zM225 37h38v225h-38v-225z"
    }, null, -1)
  ]));
}
const Ki = /* @__PURE__ */ de(Ji, [["render", Xi]]), Zi = {}, Qi = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function ea(t, n) {
  return x(), V("svg", Qi, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M38 19l-19 18v225l19 19h225l18 -19v-225l-18 -18h-225zM38 187v-150h37v150h-37zM94 187v-150h112v150h-112zM225 187v-150h38v150h-38z"
    }, null, -1)
  ]));
}
const ta = /* @__PURE__ */ de(Zi, [["render", ea]]), na = {}, oa = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function ia(t, n) {
  return x(), V("svg", oa, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M66 37v66l9 9h66v-18h-48l18 -18q13 -13 30 -17.5t34.5 0t30 17t17.5 30t0 35t-18 29.5l-97 98l13 13l98 -97q16 -17 22 -39t0 -44t-22.5 -38.5t-38.5 -22t-44 0t-38 22.5l-14 13v-39h-18z"
    }, null, -1)
  ]));
}
const aa = /* @__PURE__ */ de(na, [["render", ia]]), ra = {}, la = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function sa(t, n) {
  return x(), V("svg", la, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: "M271 62l-159 188l-15 -1l-63 -89l15 -11l56 79l151 -178z"
    }, null, -1)
  ]));
}
const ca = /* @__PURE__ */ de(ra, [["render", sa]]), ua = {}, da = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function fa(t, n) {
  return x(), V("svg", da, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: `M150 113q21 0 35.5 14.5t14.5 35t-14.5 35.5t-35.5 15t-35.5 -15t-14.5 -35.5t14.5 -35t35.5 -14.5zM150 131q-13 0 -22 9.5t-9 22.5t9 22t22 9t22 -9t9 -22t-9 -22.5t-22 -9.5zM150 69q28 0 53.5 12t43 33.5t24.5 48.5q1 4 -1 7.5t-5.5 4.5t-7 -1t-4.5 -6
q-9 -35 -37.5 -57.5t-65.5 -22.5t-65.5 22.5t-37.5 57.5q-1 4 -4.5 6t-7 1t-5.5 -4.5t-1 -7.5q7 -27 24.5 -48.5t43 -33.5t53.5 -12z`
    }, null, -1)
  ]));
}
const ha = /* @__PURE__ */ de(ua, [["render", fa]]), va = {}, ga = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  version: "1.1",
  viewBox: "-10 0 310 300"
};
function ma(t, n) {
  return x(), V("svg", ga, n[0] || (n[0] = [
    q("path", {
      fill: "currentColor",
      d: `M28 28q-3 2 -3 5.5t2 6.5l51 51q-18 13 -31 31.5t-18 40.5q-1 4 1 7.5t5.5 4.5t7 -1t4.5 -6q5 -20 16.5 -36t28.5 -27l22 23q-14 14 -14 34.5t14.5 35.5t35 15t35.5 -15l74 74q3 3 7 3t6.5 -2.5t2.5 -6t-2 -6.5l-128 -128v0l-104 -104q-3 -3 -7 -3t-6 3zM128 141l44 44
q-9 9 -22 9t-22 -9.5t-9 -22t9 -21.5zM150 69q-19 0 -36 5l15 16q11 -3 21 -3q37 0 65.5 23t37.5 58q1 4 4.5 6t7 1t5.5 -4.5t1 -7.5q-7 -27 -24.5 -48.5t-43 -33.5t-53.5 -12zM152 113l48 47q-1 -19 -14.5 -32.5t-33.5 -14.5z`
    }, null, -1)
  ]));
}
const ya = /* @__PURE__ */ de(va, [["render", ma]]), pa = { class: "header" }, Sa = { class: "list" }, ba = ["onClick"], Ca = { class: "title" }, wa = { class: "right" }, Pa = /* @__PURE__ */ ce({
  __name: "CodeLayoutCustomizeLayout",
  setup(t) {
    const { t: n } = Pt(), e = ae("codeLayoutConfig"), o = E(!1), i = E(), a = E(0), s = E([]), c = je(() => [
      {
        title: n("menuBar"),
        icon: () => le(Mi),
        click: () => e.value.menuBar = !e.value.menuBar,
        rightText: n("visibility"),
        visibility: e.value.menuBar,
        showVisibility: !0
      },
      {
        title: n("activityBar"),
        icon: () => le(Ii),
        click: () => e.value.activityBar = !e.value.activityBar,
        visibility: e.value.activityBar,
        showVisibility: !0
      },
      {
        title: n("primarySideBar"),
        icon: () => le(et),
        click: () => e.value.primarySideBar = !e.value.primarySideBar,
        visibility: e.value.primarySideBar,
        showVisibility: !0
      },
      {
        title: n("secondarySideBar"),
        icon: () => le($t),
        click: () => e.value.secondarySideBar = !e.value.secondarySideBar,
        visibility: e.value.secondarySideBar,
        showVisibility: !0
      },
      {
        title: n("panel"),
        icon: () => le(Dt),
        click: () => e.value.bottomPanel = !e.value.bottomPanel,
        visibility: e.value.bottomPanel,
        showVisibility: !0
      },
      {
        title: n("statusBar"),
        icon: () => le(Hi),
        click: () => e.value.statusBar = !e.value.statusBar,
        visibility: e.value.statusBar,
        showVisibility: !0
      },
      {
        title: n("left"),
        rightText: n("primarySideBarPosition"),
        icon: () => le(et),
        click: () => e.value.primarySideBarPosition = "left",
        splited: !0,
        checked: e.value.primarySideBarPosition === "left"
      },
      {
        title: n("right"),
        icon: () => le(et),
        click: () => e.value.primarySideBarPosition = "right",
        checked: e.value.primarySideBarPosition === "right"
      },
      {
        title: n("left"),
        rightText: n("panelAlignment"),
        icon: () => le(Vi),
        click: () => e.value.bottomAlignment = "left",
        splited: !0,
        checked: e.value.bottomAlignment === "left"
      },
      {
        title: n("right"),
        icon: () => le(qi),
        click: () => e.value.bottomAlignment = "right",
        checked: e.value.bottomAlignment === "right"
      },
      {
        title: n("center"),
        icon: () => le(Ki),
        click: () => e.value.bottomAlignment = "center",
        checked: e.value.bottomAlignment === "center"
      },
      {
        title: n("justify"),
        icon: () => le(ta),
        click: () => e.value.bottomAlignment = "justify",
        checked: e.value.bottomAlignment === "justify"
      }
    ]), g = [
      {
        name: n("restoreDefault"),
        icon: () => le(aa),
        onClick() {
          var S, m;
          (m = (S = e.value).onResetDefault) == null || m.call(S);
        }
      },
      {
        name: n("close"),
        icon: () => le(Ht),
        onClick() {
          o.value = !1;
        }
      }
    ];
    function u(S) {
      a.value = S, s.value[a.value].focus(), c.value[a.value].click();
    }
    function r(S) {
      switch (S.key) {
        case "ArrowUp":
          a.value = Math.max(a.value - 1, 0), s.value[a.value].focus();
          break;
        case "ArrowDown":
          a.value = Math.min(
            a.value + 1,
            c.value.length - 1
          ), s.value[a.value].focus();
          break;
        case " ":
        case "Enter":
          c.value[a.value].click();
          break;
      }
    }
    const h = je(() => [
      {
        name: n("togglePrimarySideBar"),
        tooltip: n("togglePrimarySideBar"),
        icon: () => e.value.primarySideBar ? le(et) : le(ci),
        onClick: () => {
          e.value.primarySideBar = !e.value.primarySideBar;
        }
      },
      {
        name: n("togglePanel"),
        tooltip: n("togglePanel"),
        icon: () => e.value.bottomPanel ? le(Dt) : le(mi),
        onClick: () => {
          e.value.bottomPanel = !e.value.bottomPanel;
        }
      },
      {
        name: n("toggleSecondarySideBar"),
        tooltip: n("toggleSecondarySideBar"),
        icon: () => e.value.secondarySideBar ? le($t) : le(Pi),
        onClick: () => {
          e.value.secondarySideBar = !e.value.secondarySideBar;
        }
      },
      {
        name: n("customizeLayout"),
        tooltip: n("customizeLayout"),
        icon: () => le(Bi),
        onClick: () => {
          o.value = !o.value, o.value && fe(() => {
            var S;
            return (S = i.value) == null ? void 0 : S.focus();
          });
        }
      }
    ]);
    return (S, m) => (x(), V(xe, null, [
      ie(Te, {
        class: "code-layout-customize-layout-actions",
        actions: h.value
      }, null, 8, ["actions"]),
      (x(), te(yt, { to: "body" }, [
        o.value ? (x(), V("div", {
          key: 0,
          ref_key: "customizeLayoutPopup",
          ref: i,
          tabindex: "0",
          class: "code-layout-customize-layout",
          onKeydown: r
        }, [
          q("div", pa, [
            tt(Ce(l(n)("customizeLayout")) + " ", 1),
            ie(Te, { actions: g })
          ]),
          q("div", Sa, [
            (x(!0), V(xe, null, Oe(c.value, (b, k) => (x(), V("div", {
              ref_for: !0,
              ref: (_) => s.value[k] = _,
              key: k,
              class: re([
                "item",
                b.splited ? "splited" : "",
                b.visibility ? "visibility" : "",
                a.value === k ? "active" : ""
              ]),
              tabindex: "0",
              onClick: (_) => u(k)
            }, [
              q("div", null, [
                ie(ke, {
                  content: b.icon
                }, null, 8, ["content"]),
                q("span", Ca, Ce(b.title), 1),
                b.checked ? (x(), te(ca, {
                  key: 0,
                  class: "check"
                })) : Z("", !0)
              ]),
              q("div", null, [
                q("span", wa, Ce(b.rightText), 1),
                b.showVisibility && b.visibility ? (x(), te(ha, {
                  key: 0,
                  class: "eye"
                })) : b.showVisibility ? (x(), te(ya, {
                  key: 1,
                  class: "eye"
                })) : Z("", !0)
              ])
            ], 10, ba))), 128))
          ])
        ], 544)) : Z("", !0)
      ]))
    ], 64));
  }
});
const za = { class: "icon" }, ka = {
  key: 0,
  class: "badge"
}, xa = /* @__PURE__ */ ce({
  __name: "CodeLayoutActionItem",
  props: {
    item: {
      type: Object,
      required: !0
    },
    active: {
      type: Boolean,
      default: !1
    },
    direction: {
      type: String,
      default: "left"
    }
  },
  emits: ["activeItem"],
  setup(t, { emit: n }) {
    const e = n, o = t, { item: i } = be(o), a = E(!1), s = E(), c = ae("codeLayoutContext");
    ae("codeLayoutConfig");
    const {
      onContextMenu: g
    } = lt(), {
      handleDragStart: u,
      handleDragEnd: r
    } = Ze(), {
      dragEnterState: h,
      dragOverState: S,
      handleDragOver: m,
      handleDragEnter: b,
      handleDragLeave: k,
      handleDropPreCheck: _,
      resetDragOverState: P,
      resetDragState: L
    } = _e(
      s,
      i,
      a,
      (B) => {
        (B == i.value || i.value.isChildren(B)) && i.value.isSelfActived() || e("activeItem");
      },
      (B) => c.dragDropNonPanel(B, !1, "activiy-bar"),
      (B) => Ke(B, i.value, S)
    );
    function I(B) {
      const T = $e();
      T && S.value ? (B.preventDefault(), B.stopPropagation(), c.dragDropToPanelNear(i.value, S.value, T, "activiy-bar")) : _(B) && (B.preventDefault(), B.stopPropagation(), c.dragDropNonPanel(B, !0, "activiy-bar", i.value, S.value)), P(), L();
    }
    return (B, T) => (x(), te(bt, {
      content: l(i).tooltip,
      direction: t.direction == "left" ? "right" : "left"
    }, {
      default: ee(() => [
        q("div", {
          ref_key: "container",
          ref: s,
          class: re([
            "item",
            t.active ? "active" : "",
            l(h) ? "drag-enter" : "",
            `drag-over-${l(S)}`
          ]),
          draggable: !0,
          onClick: T[0] || (T[0] = (O) => B.$emit("activeItem", l(i))),
          onDragstart: T[1] || (T[1] = (O) => l(u)(l(i), O)),
          onDragend: T[2] || (T[2] = //@ts-ignore
          (...O) => l(r) && l(r)(...O)),
          onDragover: T[3] || (T[3] = //@ts-ignore
          (...O) => l(m) && l(m)(...O)),
          onDragleave: T[4] || (T[4] = //@ts-ignore
          (...O) => l(k) && l(k)(...O)),
          onDragenter: T[5] || (T[5] = //@ts-ignore
          (...O) => l(b) && l(b)(...O)),
          onDrop: I,
          onContextmenu: T[6] || (T[6] = (O) => l(g)(l(i), O))
        }, [
          q("div", za, [
            ie(ke, {
              content: l(i).iconLarge,
              fallback: l(i).title ?? l(i).name
            }, null, 8, ["content", "fallback"])
          ]),
          l(i).badge ? (x(), V("span", ka, [
            ie(ke, {
              content: l(i).badge
            }, null, 8, ["content"])
          ])) : Z("", !0)
        ], 34)
      ]),
      _: 1
    }, 8, ["content", "direction"]));
  }
}), Rt = /* @__PURE__ */ ce({
  __name: "CodeLayoutActivityBar",
  props: {
    primary: {
      type: Object,
      required: !0
    },
    primarySideBar: {
      type: Boolean,
      default: !1
    },
    direction: {
      type: String,
      default: "left"
    }
  },
  emits: ["activityBarAcitve"],
  setup(t, { expose: n }) {
    const e = t, o = mt();
    return n({
      forceUpdate() {
        var a;
        const i = e.primary.children;
        e.primary.children = [], (a = o == null ? void 0 : o.proxy) == null || a.$forceUpdate(), e.primary.children = i;
      }
    }), (i, a) => (x(!0), V(xe, null, Oe(t.primary.children, (s) => {
      var c;
      return Me((x(), te(xa, {
        key: s.name,
        item: s,
        direction: t.direction,
        active: s.name === ((c = t.primary.activePanel) == null ? void 0 : c.name) && t.primarySideBar,
        onActiveItem: (g) => i.$emit("activityBarAcitve", s)
      }, null, 8, ["item", "direction", "active", "onActiveItem"])), [
        [De, s.visible]
      ]);
    }), 128));
  }
}), Ba = { class: "top" }, La = { class: "bottom" }, Ga = { class: "top" }, Aa = { class: "bottom" }, Ta = /* @__PURE__ */ ce({
  __name: "CodeLayout",
  props: {
    /**
     * Base layout config
     */
    layoutConfig: {
      type: Object,
      default: () => Zt
    },
    /**
     * Language config
     */
    langConfig: {
      type: Object,
      default: () => ({
        lang: "en"
      })
    },
    /**
     * Main menu (in top left) config
     */
    mainMenuConfig: {
      type: Object,
      default: null
    },
    /**
     * The empty text when no panel in the group
     */
    emptyText: {
      type: String,
      default: "Drag a view here to display"
    },
    /**
     * Should the canSaveLayout event be triggered when window. beforeupload
     */
    saveBeforeUnload: {
      type: Boolean,
      default: !0
    }
  },
  emits: [
    "canLoadLayout",
    "canSaveLayout"
  ],
  setup(t, { expose: n, emit: e }) {
    const o = E(), i = E(), a = E(), s = E(), c = E(), g = e, u = t, { layoutConfig: r } = be(u), h = /* @__PURE__ */ new Map(), S = {
      panelInstances: h,
      removePanelInternal: T,
      childGridActiveChildChanged() {
      },
      closePanelInternal() {
      },
      layoutConfig: u.layoutConfig
    }, m = E({
      primary: new Je(
        "primarySideBar",
        "hidden",
        S,
        (d) => {
          const $ = u.layoutConfig;
          $.primarySideBar = d;
        },
        () => {
          i.value.forceUpdate(), c.value.forceUpdate();
        }
      ),
      secondary: new Je(
        "secondarySideBar",
        "icon",
        S,
        (d) => {
          const $ = u.layoutConfig;
          $.secondarySideBar = d;
        },
        () => {
          s.value.forceUpdate();
        }
      ),
      bottom: new Je(
        "bottomPanel",
        "text",
        S,
        (d) => {
          const $ = u.layoutConfig;
          $.bottomPanel = d;
        },
        () => {
          a.value.forceUpdate();
        }
      )
    }), b = ["bottomPanel", "primarySideBar", "secondarySideBar"];
    m.value.bottom.accept = b, m.value.primary.accept = b, m.value.secondary.accept = b;
    function k() {
      switch (r.value.activityBarPosition) {
        case "side":
        case "hidden":
          m.value.primary.tabStyle = "hidden";
          break;
        case "top":
          m.value.primary.tabStyle = r.value.activityBar ? "icon" : "hidden";
          break;
      }
      if (r.value.secondarySideBarAsActivityBar)
        switch (r.value.secondaryActivityBarPosition) {
          case "side":
          case "hidden":
            m.value.secondary.tabStyle = "hidden";
            break;
          case "top":
            m.value.secondary.tabStyle = "icon";
            break;
        }
      else
        m.value.secondary.tabStyle = "icon";
    }
    se(() => r.value.secondarySideBarAsActivityBar, k), se(() => r.value.secondaryActivityBarPosition, k), se(() => r.value.activityBarPosition, k), se(() => r.value.activityBar, k);
    const _ = je(() => ({
      theme: "code-layout",
      mini: !u.layoutConfig.menuBar,
      barPopDirection: u.layoutConfig.menuBar ? "bl" : "tr",
      ...u.mainMenuConfig
    })), P = {
      getPanelByName(d) {
        return h.get(d);
      },
      addGroup: J,
      removeGroup: j,
      getRootGrid: y,
      relayoutAll: M,
      relayoutGroup: z,
      saveLayout: v,
      clearLayout: ne,
      loadLayout: C
    }, L = {
      dragDropToGrid: I,
      dragDropToPanelNear: B,
      dragDropNonPanel(d, $, G, f, p) {
        var w, A, F, R;
        return $ ? ((A = (w = u.layoutConfig).onNonPanelDrop) == null || A.call(w, d, G, f, p), !1) : ((R = (F = u.layoutConfig).onNonPanelDrag) == null ? void 0 : R.call(F, d, G)) ?? !1;
      },
      relayoutTopGridProp(d, $) {
        const G = u.layoutConfig;
        switch (d) {
          case "primarySideBar":
            G.primarySideBar = $;
            break;
          case "secondarySideBar":
            G.secondarySideBar = $;
            break;
          case "bottomPanel":
            G.bottomPanel = $;
            break;
        }
      },
      instance: P
    };
    function I(d, $) {
      var A, F;
      const G = y(d);
      if (G.hasChild($) || (((F = (A = r.value).onDropToGrid) == null ? void 0 : F.call(A, $, d)) ?? !1))
        return;
      if ($.parentGroup && T($), $.parentGrid = d, !u.layoutConfig.onGridFirstDrop) {
        G.addChild($);
        return;
      }
      const w = u.layoutConfig.onGridFirstDrop(d, $);
      w && G.addChild(w ?? $);
    }
    function B(d, $, G, f) {
      var Q, X, oe;
      if (((X = (Q = r.value).onDropToPanel) == null ? void 0 : X.call(Q, d, $, G, f)) ?? !1)
        return;
      const w = f === "tab-header", A = f === "activiy-bar", F = f === "empty", R = G.parentGroup;
      if (d === G)
        throw new Error("Can not drop to self, panel : " + G.name);
      if (console.log("dragDropToPanelNear"), R && R === d.parentGroup && !(R.getIsTabContainer() && d.parentGroup.getIsTabContainer())) {
        R.removeChild(G), R.addChild(G, d.getIndexInParent() + ($ === "right" || $ === "down" ? 1 : 0)), R.setActiveChild(G);
        return;
      }
      if (!R && !d.parentGroup && d.parentGrid === G.parentGrid && w) {
        const ue = y(G.parentGrid);
        ue.removeChild(G), ue.addChild(G, d.getIndexInParent() + ($ === "right" || $ === "down" ? 1 : 0)), ue.setActiveChild(G);
        return;
      }
      if (T(G), G.open = !0, (oe = d.parentGroup) != null && oe.getIsTabContainer() && w) {
        d.parentGroup.addChild(G, d.getIndexInParent() + ($ === "right" || $ === "down" ? 1 : 0)), d.parentGroup.notifyRelayout(), d.parentGroup.setActiveChild(G), G.size = 0, G.notifyRelayout();
        return;
      }
      if (d.getIsTabContainer()) {
        d.addChild(G), d.notifyRelayout(), d.setActiveChild(G), G.size = 0, G.notifyRelayout();
        return;
      }
      if (d.getIsTopGroup() && F) {
        const ue = y(d.parentGrid);
        ue.addChild(G), G.notifyRelayout(), d.parentGrid === "primarySideBar" && ue.setActiveChild(G);
        return;
      }
      const N = d.getParent();
      if (!N)
        return I(d.parentGrid, G);
      const Y = G.getFlatternChildOrSelf();
      if (!A && N.children.length === 1 || !w && N instanceof ze && N.getIsTabContainer() || !A && N instanceof Je) {
        const ue = new ze(S);
        switch (Object.assign(ue, {
          ...d,
          name: d.name + ".clone" + Math.floor(Math.random() * 10),
          children: []
        }), d.open = !0, ue.addChild(d), h.set(ue.name, ue), $) {
          case "left":
          case "up":
            ue.addChilds(Y, 0);
            break;
          case "right":
          case "down":
            ue.addChilds(Y);
            break;
        }
        N.replaceChild(d, ue), N.setActiveChild(ue);
        for (const ve of ue.children)
          ve.size = 0, ve.open = !0, ve.notifyRelayout();
        ue.notifyRelayout();
      } else {
        const ue = N.children.indexOf(d);
        switch ($) {
          case "left":
          case "up":
            N.addChilds(Y, ue);
            break;
          case "right":
          case "down":
            N.addChilds(Y, ue + 1);
            break;
        }
        for (const ve of Y)
          ve.size = 0;
        w || N instanceof ze && N.relayoutAllWithNewPanel(Y), G.notifyRelayout(), N.setActiveChild(G);
      }
    }
    function T(d) {
      if (d.parentGrid === "none")
        throw new Error(`Panel ${d.name} already removed from any group !`);
      const $ = d.parentGroup;
      if ($) {
        const G = d.getIsInTab();
        $.removeChild(d), O($, G, d);
      } else
        y(d.parentGrid).removeChild(d);
      d.size = 0, d.parentGrid = "none";
    }
    function O(d, $, G) {
      var f, p, w, A, F;
      if ($) {
        d.noAutoShink ? (p = (f = u.layoutConfig).onNoAutoShinkTabGroup) == null || p.call(f, d) : d.children.length === 0 && d.getIsTopGroup() && y(d.parentGrid).collapse(!1);
        return;
      }
      if (d.getIsTopGroup()) {
        if (d.children.length === 0) {
          d.noAutoShink ? (A = (w = u.layoutConfig).onNoAutoShinkNormalGroup) == null || A.call(w, d) : y(d.parentGrid).collapse(!1);
          return;
        } else if (d.children.length === 1) {
          const R = y(d.parentGrid), N = d.children[0];
          N.open = !0, N.size = 0, R.replaceChild(d, N), h.delete(d.name);
          return;
        }
      } else if (d.children.length === 1) {
        const R = d.children[0];
        R.open = !0, R.size = 0, d.parentGroup.replaceChild(d, R), h.delete(d.name);
        return;
      }
      (F = h.get(d.name)) == null || F.relayoutAllWithRemovePanel(G);
    }
    function ne() {
      m.value.primary.children.splice(0), m.value.secondary.children.splice(0), m.value.bottom.children.splice(0), m.value.primary.setActiveChild(null), m.value.secondary.setActiveChild(null), m.value.bottom.setActiveChild(null), h.clear();
    }
    function v() {
      var $;
      ($ = o.value) == null || $.saveGridLayoutDataToConfig();
      function d(G) {
        var f;
        for (const p of G.children)
          (f = p.children) != null && f.length && d(p);
      }
      return d(m.value.primary), d(m.value.secondary), d(m.value.bottom), {
        primary: m.value.primary.toJson(),
        secondary: m.value.secondary.toJson(),
        bottom: m.value.bottom.toJson()
      };
    }
    function C(d, $) {
      if (ne(), !d)
        return;
      function G(f, p) {
        var w;
        if (p.loadFromJson(f), f.children instanceof Array)
          for (const A of f.children) {
            const F = p.addPanel(A), R = $(F);
            (w = u.layoutConfig.defaultPanelConfig) != null && w.iconGenerator && (R.iconSmall && typeof R.iconSmall == "string" && (R._iconSmallName = R.iconSmall, R.iconSmall = u.layoutConfig.defaultPanelConfig.iconGenerator(R.iconSmall)), R.iconLarge && typeof R.iconLarge == "string" && (R._iconLargeName = R.iconLarge, R.iconLarge = u.layoutConfig.defaultPanelConfig.iconGenerator(R.iconLarge))), G(A, R);
          }
        p.notifyRelayout();
      }
      d.primary && G(d.primary, m.value.primary), d.secondary && G(d.secondary, m.value.secondary), d.primary && G(d.bottom, m.value.bottom);
    }
    Nt(), ge("codeLayoutConfig", r), ge("codeLayoutLangConfig", u.langConfig), ge("codeLayoutContext", L);
    function D(d) {
      const $ = u.layoutConfig;
      m.value.primary.activePanel === d && u.layoutConfig.primarySideBarSwitchWithActivityBar ? $.primarySideBar = !$.primarySideBar : (u.layoutConfig.primarySideBar || ($.primarySideBar = !0), m.value.primary.setActiveChild(d));
    }
    function W(d) {
      const $ = u.layoutConfig;
      m.value.secondary.activePanel === d && u.layoutConfig.primarySideBarSwitchWithActivityBar ? $.secondarySideBar = !$.secondarySideBar : (u.layoutConfig.secondarySideBar || ($.secondarySideBar = !0), m.value.secondary.setActiveChild(d));
    }
    function y(d) {
      switch (d) {
        case "primarySideBar":
          return m.value.primary;
        case "secondarySideBar":
          return m.value.secondary;
        case "bottomPanel":
          return m.value.bottom;
      }
      throw new Error(`Unknown grid ${d}`);
    }
    function J(d, $) {
      const G = d;
      if (G.parentGrid && G.parentGrid !== "none")
        throw new Error(`Group ${d.name} already added to ${G.parentGrid} !`);
      if (h.has(G.name))
        throw new Error(`A panel named ${d.name} already exists`);
      const f = Ee(new ze(S));
      return Object.assign(f, d), f.open = d.startOpen ?? !1, f.size = d.size ?? 0, f.accept = d.accept ?? b, f.parentGrid = $, h.set(G.name, f), y($).addChild(f), f;
    }
    function j(d) {
      const $ = d.parentGrid;
      if (!$ || $ === "none")
        throw new Error(`Group ${d.name} already removed from any grid !`);
      return y($).removeChild(d), d.parentGrid = "none", h.delete(d.name), d;
    }
    function M() {
      h.forEach((d) => d.notifyRelayout());
    }
    function z(d) {
      var $;
      ($ = h.get(d)) == null || $.notifyRelayout();
    }
    n(P), we(() => {
      fe(() => {
        g("canLoadLayout", P), k();
      }), u.saveBeforeUnload && window.addEventListener("beforeunload", H);
    }), Re(() => {
      H();
    });
    function H() {
      var d;
      window.removeEventListener("beforeunload", H), (d = o.value) == null || d.saveGridLayoutDataToConfig(), g("canSaveLayout", P);
    }
    return (d, $) => (x(), te(On, {
      ref_key: "codeLayoutBase",
      ref: o,
      config: l(r)
    }, {
      titleBarBottom: ee(() => [
        U(d.$slots, "titleBarBottom")
      ]),
      titleBarTop: ee(() => [
        U(d.$slots, "titleBarTop")
      ]),
      titleBarIcon: ee(() => [
        U(d.$slots, "titleBarIcon")
      ]),
      titleBarMenu: ee(() => [
        U(d.$slots, "titleBarMenu", {}, () => [
          ie(l(dt), { options: _.value }, null, 8, ["options"])
        ])
      ]),
      titleBarCenter: ee(() => [
        U(d.$slots, "titleBarCenter")
      ]),
      titleBarRight: ee(() => [
        l(r).titleBarShowCustomizeLayout ? (x(), te(Pa, { key: 0 })) : Z("", !0),
        U(d.$slots, "titleBarRight")
      ]),
      activityBar: ee(() => [
        q("div", Ba, [
          l(r).menuBar ? Z("", !0) : U(d.$slots, "activityBarTopBar", { key: 0 }, () => [
            ie(l(dt), { options: _.value }, null, 8, ["options"])
          ]),
          ie(Rt, {
            ref_key: "activityBarGroup",
            ref: c,
            primary: m.value.primary,
            primarySideBar: l(r).primarySideBar,
            direction: l(r).primarySideBarPosition,
            onActivityBarAcitve: D
          }, null, 8, ["primary", "primarySideBar", "direction"])
        ]),
        q("div", La, [
          U(d.$slots, "activityBarBottom")
        ])
      ]),
      activityBarSecondary: ee(() => [
        q("div", Ga, [
          l(r).menuBar ? Z("", !0) : U(d.$slots, "activityBarSecondaryTopBar", { key: 0 }, () => [
            ie(l(dt), { options: _.value }, null, 8, ["options"])
          ]),
          ie(Rt, {
            ref_key: "activityBarGroup",
            ref: c,
            primary: m.value.secondary,
            primarySideBar: l(r).secondarySideBar,
            direction: l(r).primarySideBarPosition == "left" ? "right" : "left",
            onActivityBarAcitve: W
          }, null, 8, ["primary", "primarySideBar", "direction"])
        ]),
        q("div", Aa, [
          U(d.$slots, "activityBarSecondaryBottom")
        ])
      ]),
      primarySideBar: ee(() => [
        ie(ft, {
          ref_key: "primarySideBarGroup",
          ref: i,
          group: m.value.primary,
          horizontal: !1
        }, {
          panelRender: ee((G) => [
            U(d.$slots, "panelRender", pe(Se(G)))
          ]),
          emptyTabRender: ee(() => [
            ie(ht, {
              panel: m.value.primary,
              grid: "primarySideBar"
            }, {
              default: ee(() => [
                U(d.$slots, "emptyGroup", {
                  panel: m.value.primary,
                  grid: "primarySideBar"
                }, () => [
                  tt(Ce(t.emptyText), 1)
                ])
              ]),
              _: 3
            }, 8, ["panel"])
          ]),
          _: 3
        }, 8, ["group"])
      ]),
      secondarySideBar: ee(() => [
        ie(ft, {
          ref_key: "secondarySideBarGroup",
          ref: s,
          group: m.value.secondary,
          horizontal: !1
        }, {
          panelRender: ee((G) => [
            U(d.$slots, "panelRender", pe(Se(G)))
          ]),
          emptyTabRender: ee(() => [
            ie(ht, {
              panel: m.value.secondary,
              grid: "secondarySideBar"
            }, {
              default: ee(() => [
                U(d.$slots, "emptyGroup", {
                  panel: m.value.secondary,
                  grid: "secondarySideBar"
                }, () => [
                  tt(Ce(t.emptyText), 1)
                ])
              ]),
              _: 3
            }, 8, ["panel"])
          ]),
          _: 3
        }, 8, ["group"])
      ]),
      bottomPanel: ee(() => [
        ie(ft, {
          ref_key: "bottomPanelGroup",
          ref: a,
          group: m.value.bottom,
          horizontal: !0
        }, {
          panelRender: ee((G) => [
            U(d.$slots, "panelRender", pe(Se(G)))
          ]),
          emptyTabRender: ee(() => [
            ie(ht, { grid: "bottomPanel" }, {
              default: ee(() => [
                U(d.$slots, "emptyGroup", {
                  panel: m.value.bottom,
                  grid: "bottomPanel"
                }, () => [
                  tt(Ce(t.emptyText), 1)
                ])
              ]),
              _: 3
            })
          ]),
          _: 3
        }, 8, ["group"])
      ]),
      centerArea: ee(() => [
        U(d.$slots, "centerArea")
      ]),
      statusBar: ee(() => [
        U(d.$slots, "statusBar")
      ]),
      _: 3
    }, 8, ["config"]));
  }
});
const { install: Ma, store: Da } = nn(), Wa = Da, Ha = { install: Ma };
export {
  Ta as CodeLayout,
  ht as CodeLayoutEmpty,
  Je as CodeLayoutGridInternal,
  ze as CodeLayoutPanelInternal,
  he as CodeLayoutSplitNGridInternal,
  ye as CodeLayoutSplitNPanelInternal,
  Uo as OverflowCollapseList,
  bt as SimpleTooltip,
  Gn as SplitLayout,
  sn as SplitN,
  Ln as SplitTab,
  wn as SplitTabItem,
  nn as createLayoutStore,
  Ha as default,
  Zt as defaultCodeLayoutConfig,
  Qt as defaultSplitLayoutConfig,
  Wa as layoutStore,
  Ia as useLayout,
  tn as useLayoutPersistence,
  Wt as useLayoutStore,
  Oa as usePanelData
};
//# sourceMappingURL=vue-code-layout.es.js.map
